var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleImg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 400,
    viewBox: "0 0 435 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_3461)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_195_3461)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0909,
    d: "M181.807 261.15L250.395 234.757C254.254 232.522 259.13 231.328 264.005 231.379C266.1 231.404 268.094 231.683 269.935 232.141C271.687 232.572 273.718 233.423 275.14 234.249L325.864 263.97C325.914 263.995 327.336 264.834 327.375 264.872C331.387 267.285 333.215 271.044 332.999 275.096C332.771 279.249 329.647 283.949 325.153 286.553L282.974 327.197C279.191 329.381 274.442 330.588 269.643 330.588C265.466 330.588 261.657 329.686 258.66 327.959L180.512 282.095C176.576 279.821 174.342 276.239 174.354 272.276C174.354 267.945 177.071 263.894 181.807 261.15Z",
    fill: "#9FA5D0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1818,
    d: "M182.112 261.213L250.699 234.82C254.546 232.598 259.422 231.442 264.247 231.531C266.342 231.581 268.31 231.912 270.125 232.382C271.7 232.788 273.985 233.804 275.267 234.541L325.711 264.109C325.8 264.16 327.133 264.948 327.209 265.011C331.145 267.45 332.44 271.184 332.009 275.185C331.602 278.906 328.136 284.076 324.099 286.413L282.695 326.688C279 328.822 274.366 329.991 269.681 330.003C265.605 330.016 261.885 329.14 258.965 327.45L180.817 281.129C177.033 278.944 174.926 275.54 174.964 271.781C174.976 267.678 177.566 263.83 182.112 261.213Z",
    fill: "#8F95BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M182.404 261.264L250.991 234.871C254.826 232.661 259.714 231.531 264.475 231.683C266.558 231.747 268.513 232.128 270.29 232.623C271.674 233.004 274.239 234.185 275.369 234.846L325.534 264.249C325.673 264.325 326.905 265.075 327.019 265.164C330.866 267.64 331.653 271.311 330.98 275.274C330.422 278.551 326.587 284.19 322.994 286.26L282.365 326.168C278.759 328.251 274.226 329.394 269.681 329.406C265.72 329.419 262.063 328.568 259.232 326.93L181.084 280.138C177.465 278.043 175.472 274.816 175.522 271.273C175.599 267.412 178.062 263.766 182.404 261.264Z",
    fill: "#7F84A7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M182.708 261.315L251.296 234.922C255.105 232.724 260.019 231.632 264.716 231.823C266.786 231.911 268.716 232.343 270.481 232.851C271.687 233.207 274.505 234.553 275.496 235.125L325.381 264.363C325.571 264.477 326.701 265.163 326.841 265.29C330.599 267.805 331.729 271.679 329.977 275.337C329.977 278.246 325.076 284.279 321.927 286.095L282.073 325.621C278.556 327.653 274.137 328.758 269.719 328.771C265.859 328.784 262.291 327.971 259.536 326.383L181.388 279.135C177.935 277.141 176.055 274.08 176.132 270.739C176.208 267.145 178.569 263.715 182.708 261.315Z",
    fill: "#6F7492"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M183 261.379L251.588 234.986C255.384 232.788 260.298 231.734 264.945 231.988C267.014 232.103 268.919 232.585 270.658 233.119C271.699 233.436 274.759 234.96 275.61 235.456L325.216 264.529C325.457 264.669 326.486 265.304 326.663 265.456C330.333 268.009 331.158 271.908 328.961 275.452C328.961 277.941 323.54 284.432 320.835 285.981L281.755 325.139C278.327 327.121 274.023 328.187 269.731 328.213C265.973 328.238 262.494 327.451 259.815 325.901L181.667 278.183C178.366 276.278 176.614 273.394 176.716 270.257C176.83 266.879 179.064 263.652 183 261.379Z",
    fill: "#5F637D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5455,
    d: "M183.305 261.429L251.893 235.036C255.676 232.852 260.603 231.836 265.186 232.128C267.243 232.267 269.122 232.801 270.836 233.347C271.7 233.626 275.026 235.328 275.724 235.748L325.051 264.656C325.33 264.821 326.27 265.405 326.486 265.595C330.066 268.187 330.587 272.111 327.959 275.528C327.959 277.611 322.016 284.533 319.769 285.829L281.463 324.618C278.124 326.549 273.921 327.578 269.77 327.616C266.126 327.641 262.723 326.892 260.12 325.38L181.972 277.204C178.836 275.388 177.198 272.683 177.325 269.749C177.452 266.612 179.56 263.589 183.305 261.429Z",
    fill: "#505368"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M183.597 261.48L252.185 235.087C255.955 232.915 260.894 231.925 265.414 232.268C267.459 232.433 269.325 233.017 271.014 233.576C271.699 233.804 275.28 235.697 275.851 236.027L324.898 264.77C325.228 264.961 326.079 265.494 326.32 265.71C329.812 268.339 330.04 272.289 326.955 275.579C326.955 277.243 320.493 284.622 318.702 285.651L281.171 324.072C277.933 325.939 273.832 326.955 269.807 326.981C266.265 327.006 262.951 326.282 260.425 324.822L182.277 276.189C179.306 274.474 177.795 271.934 177.922 269.216C178.061 266.345 180.055 263.525 183.597 261.48Z",
    fill: "#404253"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7273,
    d: "M183.902 261.532L252.489 235.138C256.235 232.979 261.187 232.027 265.656 232.42C267.7 232.598 269.528 233.233 271.204 233.817C271.712 233.995 275.547 236.078 275.978 236.332L324.746 264.923C325.127 265.139 325.876 265.621 326.156 265.875C329.571 268.543 329.482 272.518 325.965 275.693C325.965 276.938 318.982 284.762 317.636 285.537L280.892 323.59C277.743 325.406 273.756 326.384 269.858 326.422C266.43 326.46 263.193 325.762 260.742 324.352L182.594 275.249C179.776 273.623 178.392 271.261 178.544 268.746C178.684 266.079 180.55 263.475 183.902 261.532Z",
    fill: "#30323E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M184.194 261.595L252.781 235.202C256.514 233.042 261.479 232.128 265.884 232.572C267.916 232.776 269.719 233.462 271.369 234.071C271.712 234.198 275.788 236.472 276.08 236.637L324.568 265.062C325 265.304 325.648 265.735 325.965 266.015C329.291 268.72 328.898 272.721 324.937 275.769C324.937 276.595 317.433 284.863 316.544 285.384L280.574 323.069C277.514 324.834 273.629 325.774 269.871 325.825C266.545 325.863 263.396 325.203 261.021 323.831L182.873 274.271C180.22 272.734 178.95 270.549 179.128 268.238C179.306 265.812 181.058 263.411 184.194 261.595Z",
    fill: "#20212A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9091,
    d: "M184.499 261.645L253.086 235.252C256.806 233.106 261.783 232.229 266.138 232.725C268.157 232.953 269.934 233.69 271.572 234.312C271.737 234.376 276.08 236.865 276.219 236.941L324.429 265.202C324.898 265.481 325.457 265.849 325.812 266.167C329.05 268.91 328.352 272.949 323.959 275.858C323.959 276.277 315.947 284.99 315.49 285.244L280.295 322.548C277.324 324.262 273.553 325.177 269.922 325.228C266.709 325.266 263.637 324.643 261.339 323.31L183.191 273.28C180.702 271.844 179.547 269.825 179.737 267.717C179.915 265.545 181.553 263.347 184.499 261.645Z",
    fill: "#101115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.618 322.789L183.47 272.302C178.76 269.583 179.356 264.833 184.791 261.696L253.378 235.303C258.812 232.166 267.027 231.823 271.737 234.541L324.264 265.329C328.974 268.047 328.377 272.797 322.943 275.934L279.99 322.027C274.543 325.164 266.329 325.507 261.618 322.789Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.618 322.688L183.47 277.281C181.375 276.074 180.322 274.461 180.296 272.759C180.296 272.709 180.296 261.824 180.296 261.773C180.334 259.715 181.858 263.284 184.791 261.595L253.378 235.202C258.812 232.065 267.027 231.722 271.738 234.44L324.264 265.227C325.838 266.129 326.968 262.281 327.387 263.513C327.527 263.919 327.438 274.41 327.451 274.83C327.501 276.938 325.978 279.173 322.956 280.914L280.003 321.926C274.544 325.063 266.329 325.406 261.618 322.688Z",
    fill: "url(#paint0_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.618 311.803L183.47 266.396C178.76 263.678 179.356 258.927 184.791 255.79L253.378 229.397C258.812 226.26 267.027 225.917 271.737 228.635L324.264 259.423C328.974 262.141 328.377 266.891 322.943 270.028L279.99 311.041C274.543 314.178 266.329 314.521 261.618 311.803Z",
    fill: "url(#paint1_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.264 259.423L271.738 228.635C267.027 225.917 258.812 226.26 253.378 229.397L218.831 242.695C219.161 242.949 219.503 243.203 219.91 243.432L298.058 288.839C299.137 289.461 300.419 289.918 301.791 290.223L322.943 270.028C328.377 266.891 328.961 262.141 324.264 259.423Z",
    fill: "url(#paint2_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.943 269.038L279.99 310.05C274.556 313.187 266.341 313.53 261.631 310.812L183.483 265.405C181.528 264.275 180.499 262.802 180.347 261.227C180.106 263.144 181.134 265.024 183.483 266.383L261.631 312.133C266.341 314.851 274.556 314.508 279.99 311.371L322.943 270.003C326.117 268.161 327.628 265.786 327.4 263.576C327.158 265.507 325.648 267.476 322.943 269.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.725 312.057L171.802 201.124C161.988 195.459 154.04 180.256 154.04 167.161V20.322C154.04 7.23977 161.988 1.21939 171.802 6.88414L363.725 117.817C373.54 123.481 381.488 138.685 381.488 151.78V298.619C381.488 311.701 373.54 317.722 363.725 312.057Z",
    fill: "url(#paint3_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.01 301.832L176.792 192.475C168.895 187.458 164.006 177.424 164.006 167.161V19.3568C164.006 16.9308 166.647 15.4194 168.755 16.6387C168.996 16.7784 169.199 16.8927 169.314 16.9689L358.735 126.466C368.131 131.89 371.521 141.517 371.521 151.78V299.114C371.521 301.718 368.702 303.356 366.442 302.061C366.252 301.972 366.099 301.883 366.01 301.832Z",
    fill: "url(#paint4_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.735 126.466L169.301 16.9691C169.186 16.9056 168.983 16.7913 168.742 16.6389C166.647 15.4069 163.993 16.9183 163.993 19.357V167.161C163.993 177.424 168.882 187.458 176.779 192.475L365.997 301.832C366.086 301.883 366.239 301.972 366.416 302.074C368.676 303.369 371.495 301.731 371.495 299.127V151.793C371.508 141.517 368.13 131.89 358.735 126.466ZM369.514 299.114C369.514 299.978 368.778 300.524 368.105 300.524C367.864 300.524 367.635 300.461 367.419 300.334L177.795 190.747C170.659 186.213 166.012 176.941 166.012 167.161V19.357C166.012 18.6457 166.609 18.2012 167.168 18.2012C167.371 18.2012 167.561 18.252 167.752 18.3663L357.745 128.194C367.483 133.808 369.527 144.121 369.527 151.78V299.114H369.514Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.901 113.066L179.966 2.13384C176.081 -0.114277 172.488 -0.520717 169.567 0.609693C169.199 0.749407 161.099 5.46157 160.756 5.65208C160.756 5.65208 160.743 5.66479 160.73 5.66479C163.765 4.19144 167.612 4.45817 171.789 6.8841L363.712 117.817C373.527 123.481 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.196 373.666 313.733C374.047 313.759 374.53 313.606 375.228 313.2C375.457 313.073 383.976 307.967 384.192 307.815C387.569 305.452 389.664 300.587 389.664 293.869V147.03C389.664 133.947 381.716 118.744 371.901 113.066Z",
    fill: "url(#paint5_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.749 113.168L179.826 2.2354C175.941 -0.0127148 172.348 -0.419154 169.428 0.711256C169.059 0.850969 161.111 5.46152 160.756 5.65204C160.756 5.65204 160.743 5.66474 160.73 5.66474C163.765 4.19139 167.612 4.45812 171.789 6.88406L363.712 117.817C373.527 123.481 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.196 373.666 313.733C374.047 313.759 374.53 313.606 375.228 313.2C375.457 313.073 383.824 308.056 384.039 307.916C387.417 305.554 389.512 300.689 389.512 293.97V147.131C389.512 134.036 381.564 118.833 371.749 113.168Z",
    fill: "url(#paint6_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.597 113.27L179.674 2.32476C175.789 0.0766407 172.196 -0.329799 169.275 0.800611C168.907 0.940325 161.111 5.44926 160.756 5.65248C160.756 5.65248 160.743 5.66518 160.73 5.66518C163.765 4.19184 167.612 4.45857 171.789 6.8845L363.712 117.817C373.527 123.482 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.197 373.666 313.734C374.047 313.759 374.53 313.607 375.228 313.2C375.457 313.073 383.671 308.158 383.887 308.005C387.264 305.643 389.359 300.778 389.359 294.059V147.233C389.372 134.138 381.411 118.935 371.597 113.27Z",
    fill: "url(#paint7_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.444 113.371L179.522 2.42583C175.636 0.177715 172.043 -0.228725 169.123 0.901685C168.755 1.0414 161.099 5.46143 160.756 5.65195C160.756 5.65195 160.743 5.66465 160.73 5.66465C163.765 4.19131 167.612 4.45803 171.789 6.88397L363.712 117.817C373.527 123.481 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.196 373.666 313.733C374.047 313.759 374.53 313.606 375.228 313.2C375.457 313.073 383.519 308.259 383.735 308.106C387.112 305.744 389.207 300.879 389.207 294.161V147.322C389.22 134.239 381.259 119.036 371.444 113.371Z",
    fill: "url(#paint8_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.305 113.473L179.369 2.5274C175.484 0.279277 171.891 -0.127162 168.971 1.00325C168.602 1.14296 161.099 5.46138 160.756 5.6519C160.756 5.6519 160.743 5.6646 160.73 5.6646C163.765 4.19126 167.612 4.45798 171.789 6.88392L363.712 117.817C373.527 123.481 381.475 138.685 381.475 151.78V298.619C381.475 306.785 378.377 312.196 373.666 313.733C374.047 313.758 374.53 313.606 375.228 313.2C375.457 313.073 383.367 308.36 383.582 308.208C386.96 305.846 389.055 300.981 389.055 294.262V147.423C389.067 134.341 381.107 119.137 371.305 113.473Z",
    fill: "url(#paint9_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.152 113.562L179.23 2.62945C175.344 0.381328 171.751 -0.0251114 168.831 1.1053C168.463 1.24501 161.111 5.46182 160.756 5.65234C160.756 5.65234 160.743 5.66504 160.73 5.66504C163.765 4.1917 167.612 4.45842 171.789 6.88436L363.712 117.817C373.527 123.482 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.197 373.666 313.734C374.047 313.759 374.53 313.607 375.228 313.2C375.457 313.073 383.227 308.463 383.443 308.31C386.82 305.948 388.915 301.083 388.915 294.364V147.525C388.915 134.43 380.967 119.227 371.152 113.562Z",
    fill: "url(#paint10_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 113.663L179.077 2.73052C175.192 0.482402 171.599 0.0759628 168.679 1.20637C168.31 1.34609 161.111 5.46129 160.756 5.6518C160.756 5.6518 160.743 5.66451 160.73 5.66451C163.765 4.19116 167.612 4.45789 171.789 6.88382L363.712 117.816C373.527 123.481 381.475 138.685 381.475 151.78V298.618C381.475 306.785 378.377 312.196 373.666 313.733C374.047 313.758 374.53 313.606 375.228 313.199C375.457 313.073 383.074 308.551 383.29 308.398C386.668 306.036 388.763 301.171 388.763 294.452V147.626C388.763 134.531 380.814 119.328 371 113.663Z",
    fill: "url(#paint11_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.848 113.765L178.925 2.81988C175.04 0.571758 171.446 0.165318 168.526 1.29573C168.158 1.43544 161.111 5.44903 160.756 5.65225C160.756 5.65225 160.743 5.66495 160.73 5.66495C163.765 4.19161 167.612 4.45834 171.789 6.88427L363.712 117.817C373.527 123.482 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.197 373.666 313.733C374.047 313.759 374.53 313.606 375.228 313.2C375.457 313.073 382.922 308.653 383.138 308.5C386.515 306.138 388.61 301.273 388.61 294.555V147.716C388.623 134.633 380.662 119.43 370.848 113.765Z",
    fill: "url(#paint12_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.708 113.867L178.772 2.92144C174.887 0.67332 171.294 0.266881 168.374 1.39729C168.006 1.537 161.099 5.46169 160.756 5.6522C160.756 5.6522 160.743 5.66491 160.73 5.66491C163.765 4.19156 167.612 4.45829 171.789 6.88422L363.712 117.817C373.527 123.482 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.197 373.666 313.733C374.047 313.759 374.53 313.606 375.228 313.2C375.457 313.073 382.77 308.754 382.986 308.602C386.363 306.24 388.458 301.375 388.458 294.656V147.817C388.471 134.735 380.51 119.531 370.708 113.867Z",
    fill: "url(#paint13_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.556 113.956L178.62 3.023C174.735 0.774883 171.142 0.368443 168.222 1.49885C167.853 1.63857 161.099 5.46164 160.756 5.65216C160.756 5.65216 160.743 5.66486 160.73 5.66486C163.765 4.19151 167.612 4.45824 171.789 6.88418L363.712 117.817C373.527 123.482 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.196 373.666 313.733C374.047 313.759 374.53 313.606 375.228 313.2C375.457 313.073 382.63 308.856 382.833 308.704C386.211 306.341 388.306 301.477 388.306 294.758V147.919C388.318 134.836 380.37 119.633 370.556 113.956Z",
    fill: "url(#paint14_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.403 114.057L178.48 3.12408C174.595 0.875957 171.002 0.469518 168.082 1.59993C167.714 1.73964 161.111 5.4611 160.756 5.65162C160.756 5.65162 160.743 5.66432 160.73 5.66432C163.765 4.19098 167.612 4.45771 171.789 6.88364L363.712 117.816C373.527 123.481 381.475 138.684 381.475 151.779V298.618C381.475 306.785 378.377 312.196 373.666 313.733C374.047 313.758 374.53 313.606 375.228 313.199C375.457 313.072 382.478 308.944 382.694 308.805C386.071 306.442 388.166 301.578 388.166 294.859V148.02C388.166 134.925 380.218 119.721 370.403 114.057Z",
    fill: "url(#paint15_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.251 114.159L178.328 3.21392C174.443 0.965801 170.85 0.559361 167.929 1.68977C167.561 1.82948 161.111 5.44934 160.756 5.65256C160.756 5.65256 160.743 5.66526 160.73 5.66526C163.765 4.19191 167.612 4.45864 171.789 6.88458L363.712 117.817C373.527 123.482 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.197 373.666 313.734C374.047 313.759 374.53 313.607 375.228 313.2C375.457 313.073 382.325 309.047 382.541 308.895C385.919 306.532 388.013 301.668 388.013 294.949V148.122C388.013 135.027 380.065 119.824 370.251 114.159Z",
    fill: "url(#paint16_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.099 114.26L178.176 3.31499C174.291 1.06687 170.697 0.660436 167.777 1.79085C167.409 1.93056 161.111 5.4615 160.756 5.65202C160.756 5.65202 160.743 5.66472 160.73 5.66472C163.765 4.19138 167.612 4.4581 171.789 6.88404L363.712 117.817C373.527 123.481 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.196 373.666 313.733C374.047 313.759 374.53 313.606 375.228 313.2C375.457 313.073 382.173 309.148 382.389 308.996C385.766 306.633 387.861 301.769 387.861 295.05V148.211C387.874 135.128 379.913 119.925 370.099 114.26Z",
    fill: "url(#paint17_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.959 114.349L178.023 3.41656C174.138 1.16844 170.545 0.761998 167.625 1.89241C167.257 2.03212 161.099 5.46145 160.756 5.65197C160.756 5.65197 160.743 5.66467 160.73 5.66467C163.765 4.19133 167.612 4.45806 171.789 6.88399L363.712 117.817C373.527 123.481 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.196 373.666 313.733C374.047 313.759 374.53 313.606 375.228 313.2C375.457 313.073 382.021 309.25 382.237 309.097C385.614 306.735 387.709 301.87 387.709 295.151V148.312C387.721 135.23 379.761 120.027 369.959 114.349Z",
    fill: "url(#paint18_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.807 114.451L177.884 3.51812C173.999 1.27 170.406 0.86356 167.485 1.99397C167.117 2.13368 161.112 5.46141 160.769 5.65193C160.769 5.65193 160.756 5.66463 160.743 5.66463C163.778 4.19128 167.625 4.45801 171.802 6.88395L363.725 117.817C373.54 123.481 381.488 138.685 381.488 151.78V298.619C381.488 306.786 378.39 312.196 373.679 313.733C374.06 313.758 374.543 313.606 375.241 313.2C375.469 313.073 381.894 309.338 382.11 309.199C385.487 306.836 387.582 301.972 387.582 295.253V148.414C387.569 135.319 379.621 120.115 369.807 114.451Z",
    fill: "url(#paint19_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.654 114.552L177.731 3.61968C173.846 1.37156 170.253 0.965123 167.333 2.09553C166.965 2.23525 161.111 5.46136 160.756 5.65188C160.756 5.65188 160.743 5.66458 160.73 5.66458C163.765 4.19124 167.612 4.45796 171.789 6.8839L363.712 117.816C373.527 123.481 381.475 138.685 381.475 151.78V298.619C381.475 306.785 378.377 312.196 373.666 313.733C374.047 313.758 374.53 313.606 375.228 313.2C375.457 313.073 381.729 309.44 381.945 309.288C385.322 306.925 387.417 302.061 387.417 295.342V148.515C387.417 135.42 379.469 120.217 369.654 114.552Z",
    fill: "url(#paint20_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.502 114.654L177.579 3.70855C173.694 1.46043 170.101 1.05399 167.18 2.1844C166.812 2.32411 161.111 5.44862 160.756 5.65184C160.756 5.65184 160.743 5.66454 160.73 5.66454C163.765 4.1912 167.612 4.45792 171.789 6.88386L363.712 117.816C373.527 123.481 381.475 138.685 381.475 151.78V298.619C381.475 306.785 378.377 312.196 373.666 313.733C374.047 313.758 374.53 313.606 375.228 313.2C375.457 313.073 381.576 309.542 381.792 309.389C385.169 307.027 387.264 302.162 387.264 295.443V148.604C387.277 135.522 379.316 120.319 369.502 114.654Z",
    fill: "url(#paint21_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.349 114.756L177.427 3.8106C173.541 1.56248 169.948 1.15604 167.028 2.28645C166.66 2.42616 161.099 5.46176 160.756 5.65228C160.756 5.65228 160.743 5.66498 160.73 5.66498C163.765 4.19164 167.612 4.45836 171.789 6.8843L363.712 117.817C373.527 123.482 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.197 373.666 313.733C374.047 313.759 374.53 313.606 375.228 313.2C375.457 313.073 381.424 309.644 381.64 309.491C385.017 307.129 387.112 302.264 387.112 295.545V148.706C387.125 135.624 379.164 120.421 369.349 114.756Z",
    fill: "url(#paint22_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.21 114.844L177.274 3.91167C173.389 1.66355 169.796 1.25712 166.876 2.38753C166.507 2.52724 161.099 5.46122 160.756 5.65174C160.756 5.65174 160.743 5.66444 160.73 5.66444C163.765 4.1911 167.612 4.45783 171.789 6.88376L363.712 117.816C373.527 123.481 381.475 138.684 381.475 151.779V298.618C381.475 306.785 378.377 312.196 373.666 313.733C374.047 313.758 374.53 313.606 375.228 313.199C375.457 313.072 381.284 309.745 381.487 309.592C384.865 307.23 386.96 302.365 386.96 295.646V148.807C386.972 135.725 379.012 120.522 369.21 114.844Z",
    fill: "url(#paint23_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.057 114.946L177.135 4.01372C173.249 1.76561 169.656 1.35917 166.736 2.48958C166.368 2.62929 161.111 5.46166 160.756 5.65218C160.756 5.65218 160.743 5.66488 160.73 5.66488C163.765 4.19154 167.612 4.45827 171.789 6.8842L363.712 117.817C373.527 123.482 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.196 373.666 313.733C374.047 313.759 374.53 313.606 375.228 313.2C375.457 313.073 381.132 309.834 381.348 309.694C384.725 307.332 386.82 302.467 386.82 295.748V148.909C386.82 135.814 378.872 120.611 369.057 114.946Z",
    fill: "url(#paint24_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.905 115.048L176.982 4.10259C173.097 1.85447 169.504 1.44803 166.584 2.57844C166.215 2.71816 161.111 5.44892 160.756 5.65214C160.756 5.65214 160.743 5.66484 160.73 5.66484C163.765 4.1915 167.612 4.45823 171.789 6.88416L363.712 117.817C373.527 123.482 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.196 373.666 313.733C374.047 313.759 374.53 313.606 375.228 313.2C375.457 313.073 380.98 309.936 381.195 309.783C384.573 307.421 386.668 302.556 386.668 295.837V149.011C386.668 135.916 378.72 120.713 368.905 115.048Z",
    fill: "url(#paint25_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.753 115.149L176.83 4.20415C172.945 1.95604 169.352 1.5496 166.431 2.68001C166.063 2.81972 161.111 5.46158 160.756 5.65209C160.756 5.65209 160.743 5.6648 160.73 5.6648C163.765 4.19145 167.612 4.45818 171.789 6.88411L363.712 117.817C373.527 123.481 381.475 138.685 381.475 151.78V298.619C381.475 306.786 378.377 312.196 373.666 313.733C374.047 313.759 374.53 313.606 375.228 313.2C375.457 313.073 380.827 310.037 381.043 309.885C384.42 307.522 386.515 302.658 386.515 295.939V149.1C386.528 136.018 378.567 120.814 368.753 115.149Z",
    fill: "url(#paint26_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.576 117.398L172.653 6.45236C168.628 4.12804 164.933 3.7978 161.95 5.08063C164.489 4.67419 167.409 5.29655 170.52 7.08742L362.443 118.02C372.257 123.685 380.205 138.888 380.205 151.983V298.822C380.205 306.544 377.425 311.777 373.146 313.632C378.631 312.768 382.338 307.129 382.338 298.187V151.348C382.338 138.266 374.39 123.062 364.576 117.398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.107 30.5465C146.879 30.5465 146.65 30.483 146.434 30.356L137.547 24.8563C136.95 24.488 136.772 23.7005 137.14 23.1036C137.509 22.5066 138.296 22.3161 138.893 22.6971L147.78 28.1968C148.377 28.5651 148.555 29.3526 148.186 29.9495C147.945 30.3306 147.526 30.5465 147.107 30.5465Z",
    fill: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.107 47.6548C146.993 47.6548 146.878 47.6294 146.777 47.5659L137.889 42.0663C137.584 41.8758 137.496 41.4947 137.686 41.1899C137.876 40.8978 138.27 40.7962 138.562 40.9867L147.45 46.4863C147.754 46.6769 147.843 47.0579 147.653 47.3627C147.526 47.5532 147.323 47.6548 147.107 47.6548Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.107 66.046C146.879 66.046 146.65 65.9825 146.434 65.8555L137.547 60.3558C136.95 59.9875 136.772 59.2 137.14 58.6031C137.509 58.0061 138.296 57.8156 138.893 58.1966L147.78 63.6963C148.377 64.0646 148.555 64.8521 148.186 65.449C147.945 65.8301 147.526 66.046 147.107 66.046Z",
    fill: "#B4F759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.107 83.1545C146.993 83.1545 146.878 83.1291 146.777 83.0656L137.889 77.5659C137.584 77.3754 137.496 76.9944 137.686 76.6895C137.876 76.3847 138.27 76.2958 138.562 76.4863L147.45 81.986C147.754 82.1765 147.843 82.5575 147.653 82.8623C147.526 83.0529 147.323 83.1545 147.107 83.1545Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.107 100.911C146.993 100.911 146.878 100.885 146.777 100.822L137.889 95.3223C137.584 95.1318 137.496 94.7507 137.686 94.4459C137.876 94.1411 138.27 94.0522 138.562 94.2427L147.45 99.7423C147.754 99.9328 147.843 100.314 147.653 100.619C147.526 100.797 147.323 100.911 147.107 100.911Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.107 118.655C146.993 118.655 146.878 118.63 146.777 118.566L137.889 113.066C137.584 112.876 137.496 112.495 137.686 112.19C137.876 111.885 138.27 111.796 138.562 111.987L147.45 117.486C147.754 117.677 147.843 118.058 147.653 118.363C147.526 118.553 147.323 118.655 147.107 118.655Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.107 136.398C146.993 136.398 146.878 136.373 146.777 136.309L137.889 130.81C137.584 130.619 137.496 130.238 137.686 129.933C137.876 129.628 138.27 129.539 138.562 129.73L147.45 135.23C147.754 135.42 147.843 135.801 147.653 136.106C147.526 136.297 147.323 136.398 147.107 136.398Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.107 154.155C146.993 154.155 146.878 154.129 146.777 154.066L137.889 148.566C137.584 148.376 137.496 147.995 137.686 147.69C137.876 147.398 138.27 147.296 138.562 147.487L147.45 152.986C147.754 153.177 147.843 153.558 147.653 153.863C147.526 154.053 147.323 154.155 147.107 154.155Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.911 33.0742H185.959V193.3H186.911V33.0742Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.159 46.4233H209.207V206.649H210.159V46.4233Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.419 59.7725H232.467V219.999H233.419V59.7725Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.667 73.1211H255.715V233.347H256.667V73.1211Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.927 86.4702H278.975V246.696H279.927V86.4702Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.187 99.8188H302.235V260.045H303.187V99.8188Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.435 113.168H325.482V273.394H326.435V113.168Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.695 126.517H348.743V286.743H349.695V126.517Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.637 41.5707L169.16 42.3955L365.998 156.12L366.474 155.295L169.637 41.5707Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.642 59.3231L169.166 60.1479L366.003 173.872L366.48 173.047L169.642 59.3231Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.637 77.0687L169.161 77.8936L365.998 191.618L366.474 190.793L169.637 77.0687Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.632 94.8138L169.156 95.6387L365.993 209.363L366.469 208.538L169.632 94.8138Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.638 112.566L169.161 113.391L365.999 227.115L366.475 226.29L169.638 112.566Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.632 130.311L169.156 131.136L365.993 244.86L366.47 244.036L169.632 130.311Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.638 148.064L169.162 148.889L365.999 262.613L366.475 261.788L169.638 148.064Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.626 165.821L169.15 166.646L365.987 280.37L366.464 279.545L169.626 165.821Z",
    fill: "#3C0862"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0476,
    d: "M5.42523 237.031C2.8732 238.504 1.41309 240.828 1.41309 243.419C1.41309 246.252 3.16523 248.894 6.23782 250.672C6.25052 250.672 7.38052 251.18 7.39322 251.193L19.3789 256.527C19.4551 256.565 30.0568 261.265 30.1456 261.277C32.5707 262.649 35.5798 263.386 38.6397 263.373C40.3665 263.36 41.9789 263.106 43.4264 262.636C44.2009 262.382 44.9627 262.039 45.6229 261.658L52.6441 257.137C55.1962 255.663 56.6563 253.339 56.6563 250.761C56.6563 247.928 54.9042 245.287 51.8316 243.508C51.8189 243.496 50.346 242.365 50.3334 242.353L39.5539 234.097C39.5158 234.084 35.3386 230.858 35.3005 230.845C32.8881 229.461 29.8663 228.711 26.8064 228.699C24.1528 228.699 21.7278 229.27 19.8106 230.363C19.7725 230.375 15.5318 232.331 15.5064 232.344L5.42523 237.031Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952,
    d: "M6.59319 237.551C4.10464 238.986 2.68262 241.247 2.68262 243.762C2.68262 246.506 4.39667 249.084 7.38038 250.824C7.39308 250.837 8.48499 251.319 8.49769 251.332L20.1659 256.539C20.3056 256.628 30.4756 261.112 30.6534 261.125C33.0277 262.433 35.9606 263.131 38.9316 263.106C40.6076 263.093 42.182 262.827 43.5786 262.369C44.315 262.128 45.0895 261.785 45.7116 261.417L52.5424 257.035C55.031 255.6 56.453 253.339 56.453 250.837C56.453 248.093 54.7517 245.515 51.7679 243.775C51.7425 243.762 50.3332 242.67 50.3078 242.657L39.795 234.681C39.7315 234.643 35.7193 231.569 35.6432 231.543C33.2816 230.21 30.3614 229.486 27.3776 229.473C24.8002 229.473 22.4386 230.019 20.5722 231.073C20.5087 231.086 16.4331 232.966 16.3823 233.004L6.59319 237.551Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M7.76139 238.072C5.32363 239.481 3.95239 241.679 3.95239 244.105C3.95239 246.772 5.61566 249.274 8.52319 250.976C8.54859 250.989 9.58971 251.459 9.61511 251.471L20.9532 256.539C21.1691 256.666 30.8947 260.946 31.1614 260.959C33.4848 262.204 36.3416 262.864 39.2237 262.826C40.8489 262.801 42.3725 262.534 43.7438 262.077C44.4294 261.848 45.2293 261.493 45.826 261.15L52.4791 256.907C54.9041 255.51 56.2881 253.313 56.2881 250.887C56.3008 248.22 54.6502 245.73 51.7427 244.016C51.7046 243.99 50.3587 242.949 50.3206 242.936L40.0617 235.239C39.9601 235.188 36.1258 232.254 36.0115 232.216C33.7134 230.933 30.8693 230.235 27.9745 230.222C25.4732 230.222 23.1878 230.743 21.3595 231.759C21.258 231.784 17.3728 233.575 17.2839 233.626L7.76139 238.072Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M8.92935 238.592C6.56777 239.951 5.22192 242.085 5.22192 244.448C5.22192 247.026 6.8344 249.465 9.66576 251.129C9.69115 251.154 10.6942 251.598 10.7196 251.611L21.7403 256.552C22.0323 256.717 31.3136 260.781 31.6691 260.82C33.9418 262.001 36.7224 262.623 39.5029 262.56C41.0773 262.522 42.5628 262.255 43.8833 261.81C44.5308 261.594 45.3434 261.226 45.9021 260.908L52.3774 256.806C54.7389 255.447 56.0721 253.313 56.0848 250.963C56.0975 248.385 54.4977 245.959 51.679 244.295C51.6409 244.27 50.3459 243.279 50.2951 243.241L40.3028 235.824C40.1759 235.747 36.5065 232.966 36.3542 232.915C34.1068 231.683 31.3517 231.01 28.5457 230.997C26.1206 230.997 23.8987 231.505 22.1212 232.47C21.9815 232.509 18.2741 234.21 18.1598 234.274L8.92935 238.592Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M10.0976 239.113C7.78676 240.447 6.4917 242.505 6.4917 244.791C6.4917 247.293 8.05339 249.643 10.8086 251.281C10.8467 251.306 11.7862 251.738 11.837 251.764L22.5276 256.565C22.8831 256.768 31.7327 260.629 32.1771 260.667C34.399 261.785 37.1034 262.369 39.7951 262.293C41.3314 262.242 42.7661 261.976 44.0485 261.544C44.6579 261.34 45.4832 260.959 46.0037 260.655L52.3013 256.679C54.5994 255.345 55.8944 253.301 55.9071 251.027C55.9198 248.538 54.3708 246.175 51.6411 244.549C51.5903 244.511 50.3587 243.571 50.2952 243.533L40.5696 236.395C40.4045 236.306 36.9129 233.664 36.7225 233.601C34.5386 232.42 31.8596 231.772 29.1426 231.759C26.7937 231.759 24.6352 232.242 22.8958 233.156C22.718 233.207 19.2011 234.82 19.0614 234.896L10.0976 239.113Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M11.2655 239.621C9.0182 240.929 7.76123 242.924 7.76123 245.134C7.76123 247.547 9.27213 249.833 11.9511 251.421C12.0019 251.446 12.8907 251.865 12.9415 251.891L23.302 256.565C23.7336 256.819 32.1515 260.464 32.6721 260.515C34.8432 261.569 37.4587 262.115 40.0743 262.026C41.5598 261.975 42.9437 261.696 44.188 261.264C44.7593 261.061 45.5973 260.693 46.0925 260.4L52.2123 256.565C54.4469 255.269 55.7039 253.288 55.7165 251.09C55.7292 248.677 54.2437 246.391 51.5901 244.803C51.5266 244.753 50.3586 243.863 50.2824 243.825L40.8234 236.967C40.6329 236.852 37.3064 234.363 37.0778 234.287C34.9575 233.156 32.3547 232.534 29.7265 232.521C27.4538 232.509 25.3588 232.978 23.6702 233.855C23.467 233.906 20.1151 235.443 19.95 235.544L11.2655 239.621Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M12.4337 240.142C10.2499 241.4 9.03101 243.343 9.03101 245.477C9.03101 247.814 10.4911 250.024 13.0939 251.573C13.1447 251.611 13.9954 251.992 14.0589 252.03L24.102 256.578C24.6098 256.87 32.5833 260.312 33.1928 260.363C35.3131 261.353 37.8524 261.849 40.3664 261.747C41.8011 261.683 43.147 261.404 44.3531 260.985C44.8864 260.794 45.7371 260.413 46.1942 260.147L52.1362 256.451C54.3073 255.193 55.5262 253.275 55.5389 251.154C55.5516 248.83 54.1169 246.62 51.5394 245.07C51.4633 245.019 50.3587 244.168 50.2698 244.118L41.0774 237.526C40.8489 237.399 37.6874 235.049 37.4335 234.96C35.3639 233.88 32.85 233.283 30.3106 233.271C28.1141 233.258 26.0826 233.703 24.4448 234.541C24.2035 234.604 21.0294 236.052 20.8389 236.167L12.4337 240.142Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M13.6017 240.663C11.4813 241.895 10.3005 243.762 10.3005 245.82C10.3005 248.068 11.7099 250.214 14.2365 251.726C14.3 251.764 15.0999 252.132 15.1634 252.17L24.8763 256.578C25.4477 256.908 32.9895 260.147 33.6878 260.21C35.7574 261.137 38.2205 261.595 40.6456 261.48C42.0295 261.404 43.3246 261.125 44.4927 260.718C44.9878 260.54 45.8512 260.147 46.2702 259.905L52.0345 256.349C54.1421 255.13 55.3229 253.275 55.3356 251.243C55.3483 249.008 53.9644 246.861 51.4758 245.35C51.387 245.286 50.3458 244.499 50.2443 244.435L41.3058 238.123C41.0392 237.97 38.0555 235.76 37.7507 235.671C35.7447 234.63 33.3069 234.071 30.8564 234.058C28.7361 234.046 26.7681 234.465 25.181 235.265C24.9017 235.341 21.918 236.7 21.6894 236.827L13.6017 240.663Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M14.7699 241.184C12.713 242.378 11.5703 244.181 11.5703 246.163C11.5703 248.322 12.9289 250.405 15.3793 251.878C15.4555 251.929 16.2046 252.272 16.2808 252.323L25.6763 256.603C26.3238 256.972 33.4213 260.007 34.2085 260.071C36.2272 260.947 38.6142 261.353 40.9504 261.226C42.2962 261.15 43.5405 260.858 44.6578 260.452C45.1149 260.287 45.991 259.88 46.3846 259.664L51.9711 256.235C54.0153 255.054 55.1453 253.263 55.1707 251.307C55.1961 249.148 53.8629 247.077 51.4505 245.604C51.349 245.54 50.3713 244.791 50.2571 244.728L41.5852 238.694C41.2932 238.529 38.4746 236.459 38.1317 236.357C36.1765 235.367 33.8276 234.833 31.466 234.821C29.4218 234.808 27.5173 235.202 25.9683 235.964C25.6509 236.04 22.845 237.323 22.591 237.462L14.7699 241.184Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M15.9378 241.704C13.9318 242.86 12.8398 244.6 12.8398 246.505C12.8398 248.588 14.1476 250.595 16.5219 252.03C16.5981 252.081 17.3091 252.411 17.3853 252.462L26.4507 256.602C27.1617 257.022 33.8274 259.829 34.7162 259.917C36.6842 260.73 38.9823 261.099 41.2423 260.946C42.5374 260.857 43.7308 260.565 44.8228 260.171C45.2417 260.019 46.1178 259.613 46.486 259.397L51.8821 256.107C53.8628 254.964 54.9547 253.249 54.9801 251.357C55.0055 249.286 53.7231 247.292 51.3996 245.857C51.2981 245.781 50.3712 245.082 50.2442 245.006L41.839 239.253C41.5089 239.062 38.868 237.144 38.4871 237.03C36.5953 236.09 34.3226 235.582 32.0499 235.569C30.0819 235.556 28.2536 235.925 26.7427 236.649C26.3999 236.738 23.759 237.932 23.4797 238.097L15.9378 241.704Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M17.106 242.225C15.1634 243.343 14.1096 245.02 14.1096 246.849C14.1096 248.843 15.3793 250.786 17.6647 252.17C17.7536 252.234 18.4011 252.539 18.5027 252.589L27.2507 256.603C28.0379 257.06 34.2592 259.664 35.2369 259.753C37.1668 260.502 39.376 260.833 41.5344 260.667C42.7787 260.566 43.9341 260.274 44.9752 259.893C45.3561 259.753 46.2449 259.334 46.575 259.143L51.7933 255.993C53.7105 254.888 54.7644 253.237 54.7897 251.434C54.8151 249.452 53.5836 247.522 51.349 246.125C51.2347 246.036 50.3713 245.388 50.2316 245.312L42.0931 239.837C41.7376 239.634 39.2617 237.856 38.8427 237.729C37.0017 236.84 34.8306 236.357 32.6341 236.345C30.7423 236.332 28.9774 236.675 27.5173 237.348C27.1364 237.45 24.6859 238.555 24.3685 238.732L17.106 242.225Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M18.274 242.746C16.3949 243.825 15.3792 245.438 15.3792 247.191C15.3792 249.109 16.598 250.963 18.8073 252.322C18.8961 252.386 19.5056 252.678 19.6071 252.729L28.025 256.615C28.8884 257.111 34.6781 259.511 35.7319 259.6C37.611 260.286 39.7441 260.578 41.8136 260.4C43.0071 260.299 44.1117 259.994 45.1274 259.626C45.4703 259.499 46.3717 259.067 46.6764 258.902L51.717 255.891C53.5707 254.825 54.5865 253.237 54.6119 251.51C54.6373 249.604 53.4692 247.75 51.3107 246.391C51.1838 246.302 50.3839 245.705 50.2315 245.616L42.3596 240.421C41.966 240.193 39.6679 238.567 39.2108 238.427C37.4333 237.589 35.3383 237.132 33.2307 237.119C31.415 237.106 29.7137 237.424 28.2917 238.059C27.8727 238.161 25.6 239.189 25.2699 239.38L18.274 242.746Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M19.4422 243.267C17.6266 244.321 16.6489 245.858 16.6489 247.534C16.6489 249.363 17.817 251.154 19.9501 252.475C20.0516 252.538 20.6103 252.805 20.7246 252.881L28.825 256.628C29.7519 257.162 35.1099 259.359 36.2526 259.461C38.0809 260.083 40.1378 260.324 42.1184 260.134C43.2738 260.02 44.3277 259.715 45.2926 259.346C45.5973 259.232 46.5115 258.8 46.7781 258.648L51.6409 255.777C53.4312 254.749 54.4088 253.224 54.4342 251.573C54.4596 249.757 53.3423 247.966 51.2727 246.645C51.1331 246.544 50.3967 245.997 50.2316 245.908L42.6136 240.993C42.1819 240.752 40.0616 239.266 39.5664 239.113C37.8524 238.326 35.8336 237.894 33.8148 237.881C32.0754 237.869 30.4375 238.161 29.0663 238.758C28.6219 238.872 26.5142 239.812 26.1587 240.028L19.4422 243.267Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M20.6102 243.787C18.858 244.803 17.9185 246.276 17.9185 247.877C17.9185 249.63 19.0358 251.344 21.0799 252.627C21.1942 252.703 21.7021 252.945 21.8163 253.021L29.5867 256.641C30.5897 257.225 35.5033 259.206 36.7349 259.308C38.5125 259.867 40.4931 260.07 42.3722 259.867C43.4769 259.74 44.4926 259.435 45.4067 259.079C45.6734 258.978 46.6002 258.533 46.8288 258.393L51.5138 255.65C53.2406 254.659 54.1674 253.199 54.2055 251.624C54.2436 249.884 53.1644 248.182 51.1837 246.899C51.0314 246.797 50.3584 246.289 50.1807 246.188L42.8293 241.552C42.3722 241.285 40.417 239.951 39.8837 239.786C38.2204 239.049 36.2905 238.643 34.3606 238.618C32.6974 238.605 31.123 238.884 29.8025 239.43C29.3201 239.557 27.4029 240.408 27.0093 240.637L20.6102 243.787Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M21.7784 244.308C20.0897 245.286 19.1882 246.696 19.1882 248.233C19.1882 249.896 20.2548 251.548 22.2227 252.792C22.337 252.869 22.8068 253.097 22.9338 253.173L30.3867 256.654C31.4659 257.276 35.9351 259.054 37.2556 259.168C38.9823 259.664 40.8741 259.829 42.6771 259.613C43.7309 259.473 44.6958 259.168 45.5846 258.825C45.8132 258.737 46.7527 258.279 46.9558 258.165L51.4632 255.561C53.1264 254.596 54.0152 253.224 54.0533 251.725C54.0914 250.074 53.0756 248.436 51.1584 247.191C50.9934 247.077 50.3839 246.62 50.1935 246.518L43.1088 242.161C42.6136 241.882 40.8361 240.688 40.2647 240.51C38.6649 239.824 36.8112 239.443 34.9702 239.418C33.3831 239.405 31.8722 239.659 30.6025 240.167C30.082 240.307 28.3425 241.069 27.9235 241.31L21.7784 244.308Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M22.9463 244.829C21.3084 245.769 20.4578 247.128 20.4578 248.576C20.4578 250.163 21.4735 251.738 23.3653 252.945C23.4923 253.034 23.8986 253.237 24.0382 253.313L31.1611 256.666C32.3038 257.327 36.3413 258.889 37.7506 259.016C39.4266 259.448 41.2422 259.575 42.9563 259.334C43.9593 259.194 44.8862 258.876 45.7241 258.533C45.9146 258.457 46.8668 257.987 47.0319 257.898L51.3615 255.434C52.9612 254.507 53.8119 253.199 53.8373 251.776C53.8754 250.214 52.9104 248.639 51.0821 247.433C50.9171 247.306 50.3584 246.912 50.168 246.798L43.3499 242.72C42.8293 242.416 41.2168 241.374 40.6074 241.184C39.0584 240.536 37.2935 240.193 35.5414 240.167C34.0305 240.155 32.5831 240.383 31.3515 240.853C30.7929 240.993 29.2312 241.679 28.7868 241.933L22.9463 244.829Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M24.1145 245.35C22.5401 246.252 21.7275 247.547 21.7275 248.919C21.7275 250.418 22.6925 251.929 24.5081 253.085C24.6351 253.174 25.0033 253.364 25.1556 253.453L31.9611 256.679C33.1799 257.378 36.7858 258.737 38.2713 258.877C39.8965 259.245 41.6359 259.334 43.2484 259.08C44.2133 258.927 45.0767 258.61 45.8893 258.28C46.0417 258.216 47.0066 257.746 47.1336 257.67L51.2854 255.346C52.8217 254.457 53.6343 253.212 53.6597 251.866C53.6978 250.379 52.7836 248.893 51.0441 247.725C50.8664 247.598 50.3712 247.242 50.1681 247.115L43.6166 243.318C43.0579 243 41.6105 242.098 40.9757 241.895C39.4902 241.298 37.8015 240.981 36.1383 240.955C34.7035 240.942 33.3323 241.146 32.1388 241.565C31.5548 241.717 30.1708 242.314 29.6884 242.594L24.1145 245.35Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M25.2825 245.87C23.7716 246.746 22.9971 247.966 22.9971 249.261C22.9971 250.671 23.9112 252.119 25.6507 253.237C25.7903 253.326 26.1078 253.503 26.2601 253.592L32.7354 256.679C34.0305 257.428 37.1919 258.571 38.7663 258.711C40.3407 259.028 42.004 259.067 43.5276 258.8C44.4417 258.635 45.267 258.317 46.0288 258C46.1431 257.949 47.1207 257.466 47.2223 257.403L51.1837 255.218C52.6565 254.367 53.4183 253.186 53.4564 251.928C53.4945 250.531 52.6438 249.109 50.9805 247.978C50.7901 247.839 50.3584 247.534 50.1425 247.407L43.845 243.876C43.261 243.533 41.9786 242.771 41.293 242.555C39.8582 242.009 38.2585 241.717 36.6841 241.691C35.3255 241.666 34.0178 241.856 32.8751 242.237C32.2529 242.402 31.0468 242.911 30.5516 243.203L25.2825 245.87Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M26.4506 246.391C25.0032 247.229 24.2668 248.385 24.2795 249.605C24.2795 250.938 25.1428 252.297 26.8061 253.389C26.9585 253.491 27.2251 253.644 27.3901 253.732L33.5353 256.692C34.8939 257.479 37.6237 258.419 39.2869 258.572C40.8105 258.826 42.3849 258.813 43.8323 258.533C44.6957 258.368 45.4702 258.038 46.1939 257.721C46.2701 257.695 47.2604 257.187 47.3239 257.149L51.1075 255.091C52.5168 254.279 53.2406 253.161 53.2786 251.98C53.3167 250.671 52.5168 249.312 50.9425 248.22C50.7393 248.08 50.3711 247.814 50.1426 247.687L44.1117 244.435C43.4895 244.079 42.3849 243.457 41.6612 243.228C40.29 242.733 38.7791 242.466 37.2808 242.441C35.9985 242.416 34.7542 242.581 33.6623 242.924C33.0021 243.089 31.9736 243.521 31.4531 243.825L26.4506 246.391Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M27.6188 246.912C26.2349 247.713 25.5365 248.805 25.5492 249.948C25.5492 251.193 26.3618 252.488 27.9489 253.542C28.1013 253.644 28.3298 253.771 28.4949 253.873L34.3226 256.692C35.7574 257.518 38.0428 258.255 39.8076 258.407C41.2804 258.598 42.7786 258.547 44.1372 258.255C44.9625 258.077 45.6862 257.747 46.3718 257.442C46.4099 257.429 47.4129 256.908 47.4383 256.896L51.0442 254.978C52.39 254.203 53.0756 253.161 53.1137 252.044C53.1645 250.812 52.4027 249.529 50.9172 248.487C50.7013 248.335 50.3966 248.132 50.1554 247.979L44.3911 245.007C43.7309 244.626 42.804 244.156 42.0422 243.915C40.7345 243.47 39.2997 243.229 37.8904 243.204C36.6842 243.178 35.5034 243.318 34.4496 243.623C33.7513 243.801 32.9133 244.144 32.3547 244.474L27.6188 246.912Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5115 257.175L50.9554 254.876C53.8756 253.187 53.5074 250.24 50.1428 248.297L44.6451 245.604C41.2678 243.661 36.1637 243.445 33.2435 245.134L28.7997 247.433C25.8794 249.122 26.2476 252.069 29.6122 254.012L35.1099 256.705C38.4872 258.648 43.5913 258.864 46.5115 257.175Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0476,
    d: "M8.64991 212.593C6.11058 214.054 4.65046 216.365 4.63776 218.944C4.62507 221.764 6.35182 224.405 9.38632 226.184C9.41171 226.209 15.6585 229.6 15.6966 229.626L30.1708 237.45L30.6532 237.716C30.7548 237.78 50.8663 248.601 50.9933 248.589C53.4057 249.948 56.4021 250.684 59.4366 250.659C59.8937 250.659 60.3507 250.633 60.7951 250.595C62.8774 250.43 64.8454 249.846 66.3817 248.957L73.3521 244.461C75.8661 243 77.3262 240.714 77.3389 238.161C77.3643 235.354 75.6502 232.737 72.6411 230.985C72.6411 230.921 55.7673 218.766 55.6784 218.715L44.1498 210.485C44.1117 210.459 38.4998 206.446 38.449 206.433C36.0366 205.061 33.0275 204.299 29.9676 204.299C27.314 204.299 24.9016 204.871 22.9844 205.963C22.9591 205.976 19.1754 207.716 19.1501 207.729L8.64991 212.593Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952,
    d: "M10.6941 213.698C8.23091 215.121 6.82158 217.343 6.79619 219.82C6.77079 222.551 8.42136 225.104 11.3416 226.844C11.3797 226.895 17.3598 230.146 17.436 230.197L31.4531 237.754L31.9229 238.008C32.1387 238.135 51.3996 248.449 51.6535 248.411C54.0024 249.693 56.8972 250.379 59.8302 250.341C60.2746 250.328 60.7062 250.303 61.1379 250.265C63.1059 250.1 65.0739 249.503 66.534 248.652L73.2886 244.308C75.7137 242.911 77.1103 240.714 77.1484 238.262C77.1865 235.57 75.574 233.055 72.7173 231.353C72.7173 231.239 56.6433 219.617 56.4656 219.515L45.2417 211.564C45.1655 211.513 39.7821 207.678 39.6933 207.652C37.3317 206.331 34.4114 205.607 31.4531 205.607C28.8757 205.607 26.5268 206.166 24.6604 207.22C24.5969 207.233 20.9784 208.91 20.9403 208.935L10.6941 213.698Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M12.7382 214.803C10.3512 216.175 8.97995 218.322 8.94186 220.71C8.89107 223.339 10.4782 225.815 13.2841 227.517C13.3476 227.606 19.0357 230.705 19.1627 230.782L32.7227 238.072L33.1798 238.313C33.4972 238.504 51.9074 248.297 52.2883 248.246C54.5737 249.452 57.3669 250.088 60.1983 250.024C60.63 250.011 61.049 249.986 61.4553 249.948C63.3217 249.783 65.277 249.173 66.6736 248.373L73.2124 244.194C75.5359 242.848 76.8817 240.739 76.9325 238.402C76.9833 235.824 75.4724 233.411 72.768 231.76C72.7553 231.582 57.4812 220.506 57.2273 220.354L46.3082 212.682C46.1812 212.606 41.039 208.961 40.8994 208.923C38.6013 207.653 35.7699 206.954 32.8878 206.954C30.3865 206.954 28.1138 207.488 26.2982 208.504C26.2093 208.529 22.7558 210.129 22.6797 210.168L12.7382 214.803Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M14.7826 215.909C12.4845 217.242 11.1513 219.3 11.1006 221.599C11.0371 224.139 12.548 226.54 15.2397 228.191C15.3285 228.305 20.7373 231.265 20.9024 231.354L34.0053 238.39L34.4497 238.631C34.8814 238.885 52.4282 248.157 52.9361 248.106C55.158 249.237 57.8624 249.821 60.5668 249.745C60.9731 249.732 61.3794 249.694 61.7857 249.656C63.5505 249.491 65.5058 248.869 66.8135 248.119L73.1365 244.093C75.3711 242.81 76.6535 240.791 76.7296 238.568C76.8058 236.104 75.3838 233.779 72.8318 232.192C72.8191 231.95 58.3449 221.421 58.002 221.218L47.3749 213.826C47.2099 213.737 42.2963 210.257 42.1058 210.206C39.8712 208.987 37.116 208.326 34.3355 208.326C31.9104 208.326 29.7012 208.847 27.9363 209.812C27.8221 209.85 24.5209 211.362 24.4321 211.425L14.7826 215.909Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M16.8268 217.014C14.6048 218.297 13.3225 220.291 13.259 222.488C13.1828 224.939 14.6175 227.251 17.195 228.864C17.3092 229.004 22.4387 231.823 22.6418 231.938L35.2877 238.707L35.7194 238.936C36.2527 239.241 52.9615 248.017 53.5836 247.941C55.7293 248.995 58.3449 249.529 60.9477 249.427C61.3413 249.415 61.7349 249.376 62.1158 249.338C63.779 249.173 65.7216 248.551 66.9532 247.827L73.0476 243.953C75.1806 242.721 76.4249 240.803 76.5011 238.682C76.59 236.332 75.2822 234.11 72.8698 232.573C72.8572 232.268 59.1701 222.272 58.7512 222.031L48.4288 214.905C48.2256 214.791 43.5405 211.501 43.2993 211.438C41.1155 210.269 38.4492 209.634 35.7575 209.634C33.4086 209.634 31.2756 210.13 29.5488 211.057C29.4092 211.095 26.2604 212.543 26.1461 212.606L16.8268 217.014Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M18.871 218.118C16.7252 219.363 15.4936 221.268 15.4048 223.376C15.3159 225.726 16.6617 227.974 19.1376 229.549C19.2646 229.714 24.1274 232.394 24.3686 232.534L36.5574 239.05L36.9764 239.266C37.6239 239.634 53.4694 247.89 54.2185 247.801C56.3007 248.779 58.8147 249.274 61.3159 249.147C61.6968 249.122 62.065 249.084 62.4332 249.046C63.9822 248.88 65.9248 248.245 67.0802 247.572L72.9588 243.863C74.9902 242.682 76.1837 240.866 76.2853 238.859C76.3996 236.611 75.1807 234.503 72.9207 233.017C72.908 232.661 60.0209 223.199 59.5003 222.906L49.4826 216.06C49.2414 215.921 44.7849 212.809 44.4928 212.733C42.3725 211.615 39.7951 211.018 37.1923 211.018C34.9323 211.018 32.85 211.488 31.1867 212.377C31.009 212.428 28.038 213.8 27.8983 213.876L18.871 218.118Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M20.915 219.224C18.8454 220.418 17.6519 222.247 17.563 224.266C17.4615 226.527 18.7311 228.686 21.0927 230.223C21.2451 230.413 25.8159 232.954 26.1079 233.119L37.8396 239.368L38.2332 239.584C38.9823 240.016 53.9771 247.751 54.8531 247.649C56.8719 248.563 59.2843 248.995 61.6713 248.843C62.0395 248.817 62.395 248.767 62.7505 248.729C64.1979 248.563 66.1405 247.916 67.2197 247.293L72.8824 243.737C74.825 242.619 75.955 240.892 76.082 238.987C76.2216 236.853 75.0916 234.833 72.984 233.411C72.9713 232.992 60.8714 224.075 60.2746 223.733L50.5617 217.166C50.2696 217.001 46.0544 214.067 45.7115 213.978C43.6547 212.924 41.1534 212.34 38.6395 212.352C36.4557 212.352 34.4496 212.81 32.8244 213.648C32.6213 213.711 29.8026 214.994 29.6376 215.096L20.915 219.224Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M22.9593 220.341C20.9786 221.484 19.8232 223.237 19.7089 225.167C19.5947 227.339 20.7881 229.41 23.0355 230.908C23.2132 231.124 27.5047 233.525 27.8348 233.715L39.1094 239.71L39.4903 239.914C40.3537 240.409 54.4851 247.636 55.4881 247.522C57.4434 248.36 59.7542 248.741 62.0396 248.576C62.3951 248.55 62.7252 248.5 63.0681 248.462C64.4139 248.309 66.3438 247.636 67.3468 247.064L72.7937 243.673C74.6347 242.606 75.7139 240.98 75.8536 239.177C76.006 237.157 74.9775 235.24 73.0222 233.868C72.9968 233.385 61.7095 225.015 61.0239 224.621L51.603 218.334C51.2728 218.144 47.2861 215.4 46.9052 215.299C44.9118 214.295 42.4994 213.749 40.0744 213.749C37.9667 213.749 36.0241 214.181 34.4498 214.981C34.2212 215.045 31.5676 216.264 31.3772 216.378L22.9593 220.341Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M25.0034 221.446C23.0989 222.551 21.9815 224.214 21.8673 226.043C21.7276 228.114 22.8576 230.121 24.9907 231.568C25.1938 231.822 29.206 234.071 29.5615 234.287L40.3663 240.015L40.7345 240.205C41.6995 240.764 54.9929 247.47 56.1229 247.343C58.0147 248.105 60.2239 248.436 62.4077 248.258C62.7379 248.232 63.068 248.169 63.3854 248.131C64.6297 247.978 66.5469 247.293 67.4737 246.759L72.692 243.52C74.4315 242.517 75.4726 240.98 75.625 239.291C75.8027 237.386 74.8759 235.557 73.0602 234.248C73.0349 233.702 62.5347 225.878 61.7729 225.434L52.6567 219.426C52.2885 219.21 48.5303 216.645 48.0986 216.53C46.156 215.578 43.8325 215.057 41.4963 215.07C39.4649 215.07 37.5985 215.476 36.0749 216.251C35.8082 216.327 33.3197 217.47 33.1038 217.597L25.0034 221.446Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M27.0475 222.551C25.2192 223.605 24.1527 225.193 24.0257 226.933C23.8734 228.914 24.9272 230.832 26.946 232.242C27.1618 232.521 30.8946 234.63 31.3009 234.871L41.6487 240.345L42.0042 240.536C43.0834 241.158 55.5135 247.344 56.7704 247.204C58.5988 247.89 60.7191 248.169 62.7887 247.966C63.1061 247.928 63.4108 247.877 63.7282 247.826C64.8582 247.674 66.7881 246.988 67.6388 246.493L72.6413 243.419C74.2918 242.466 75.2695 241.031 75.4345 239.443C75.625 237.64 74.7997 235.925 73.1364 234.668C73.111 234.071 63.4108 226.78 62.5601 226.285L53.7486 220.544C53.3423 220.303 49.8127 217.927 49.3302 217.8C47.4511 216.899 45.2165 216.416 42.9692 216.416C41.0139 216.429 39.2109 216.81 37.7381 217.534C37.4461 217.623 35.1099 218.69 34.8814 218.817L27.0475 222.551Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M29.0918 223.656C27.3396 224.672 26.3239 226.171 26.1715 227.822C26.0065 229.715 26.9841 231.544 28.8886 232.928C29.1299 233.233 32.5833 235.202 33.0277 235.456L42.9184 240.663L43.2612 240.841C44.442 241.527 56.0214 247.204 57.4053 247.039C59.1702 247.649 61.1889 247.878 63.1442 247.662C63.4489 247.624 63.741 247.56 64.033 247.522C65.0614 247.382 66.9786 246.671 67.7531 246.226L72.5398 243.305C74.0888 242.416 75.0156 241.07 75.2061 239.584C75.4219 237.894 74.6855 236.281 73.1746 235.075C73.1492 234.414 64.2361 227.67 63.2966 227.124L54.7771 221.662C54.32 221.396 51.0316 219.198 50.4983 219.058C48.6827 218.208 46.5243 217.75 44.3659 217.763C42.4867 217.776 40.76 218.131 39.3253 218.817C39.0079 218.906 36.8367 219.897 36.5701 220.049L29.0918 223.656Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M31.1359 224.761C29.4599 225.726 28.4823 227.149 28.3299 228.711C28.1522 230.502 29.0409 232.267 30.8439 233.601C31.1105 233.931 34.2847 235.76 34.7671 236.04L44.2008 240.98L44.5309 241.146C45.8259 241.895 56.5419 247.052 58.0528 246.874C59.7542 247.407 61.6714 247.598 63.5251 247.344C63.8171 247.306 64.0837 247.229 64.3631 247.191C65.2899 247.052 67.1944 246.328 67.8927 245.921L72.4635 243.152C73.911 242.314 74.7997 241.069 75.0029 239.698C75.2314 238.123 74.5966 236.598 73.238 235.455C73.2127 234.731 65.0995 228.533 64.071 227.936L55.8563 222.754C55.3611 222.475 52.3012 220.455 51.7172 220.303C49.9524 219.503 47.8828 219.083 45.8259 219.083C44.0357 219.096 42.3597 219.426 40.9758 220.074C40.633 220.176 38.6142 221.09 38.3349 221.255L31.1359 224.761Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M33.1799 225.866C31.5928 226.781 30.6532 228.127 30.4755 229.6C30.285 231.302 31.0976 232.979 32.7863 234.274C33.0783 234.63 35.9731 236.319 36.4937 236.624L45.4702 241.311L45.7877 241.476C47.1843 242.289 57.0623 246.925 58.6875 246.747C60.3253 247.217 62.141 247.344 63.8931 247.077C64.1597 247.039 64.4264 246.963 64.693 246.912C65.5183 246.785 67.4228 246.036 68.0322 245.68L72.3745 243.076C73.733 242.289 74.5583 241.146 74.7741 239.876C75.0281 238.415 74.4821 236.992 73.2759 235.9C73.2505 235.113 65.9246 229.461 64.82 228.825L56.9099 223.923C56.3767 223.618 53.5453 221.776 52.9232 221.611C51.2218 220.862 49.2411 220.468 47.2605 220.481C45.5464 220.493 43.9466 220.811 42.6135 221.408C42.2326 221.522 40.3789 222.361 40.0742 222.538L33.1799 225.866Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M35.2242 226.984C33.7133 227.86 32.8118 229.117 32.6341 230.502C32.4182 232.115 33.1673 233.715 34.729 234.96C35.0338 235.354 37.6493 236.891 38.2206 237.221L46.7401 241.641L47.0321 241.793C48.543 242.67 57.5576 246.798 59.3098 246.594C60.8715 246.988 62.5982 247.064 64.2361 246.772C64.49 246.721 64.7313 246.645 64.9852 246.607C65.7089 246.48 67.6007 245.718 68.1467 245.413L72.2731 242.962C73.5301 242.238 74.3172 241.184 74.5458 240.015C74.8251 238.656 74.3807 237.348 73.3015 236.306C73.2634 235.468 66.75 230.35 65.5565 229.664L57.9512 225.04C57.3799 224.71 54.7771 223.059 54.1042 222.868C52.4663 222.183 50.5618 221.814 48.6827 221.827C47.0448 221.84 45.5085 222.132 44.2261 222.691C43.8198 222.805 42.1312 223.567 41.8011 223.77L35.2242 226.984Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M37.2683 228.089C35.8336 228.915 34.9829 230.096 34.7925 231.391C34.564 232.903 35.2369 234.427 36.6843 235.634C37.0144 236.053 39.3506 237.45 39.96 237.805L48.0224 241.971L48.3018 242.111C49.9142 243.038 58.0782 246.658 59.9573 246.442C61.4555 246.76 63.0934 246.785 64.617 246.48C64.8582 246.43 65.0868 246.353 65.3153 246.303C65.9247 246.188 67.8165 245.414 68.2863 245.134L72.1969 242.848C73.3523 242.175 74.0887 241.222 74.3426 240.168C74.6346 238.923 74.2918 237.704 73.365 236.726C73.3269 235.824 67.6134 231.252 66.331 230.515L59.0177 226.158C58.4083 225.803 56.034 224.329 55.3103 224.139C53.7232 223.504 51.9203 223.161 50.1301 223.174C48.5684 223.186 47.1083 223.453 45.864 223.974C45.4323 224.101 43.896 224.787 43.5405 224.99L37.2683 228.089Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M39.3127 229.193C37.9541 229.981 37.1415 231.073 36.9384 232.28C36.6971 233.702 37.2939 235.138 38.627 236.319C38.9825 236.763 41.0394 238.021 41.6869 238.402L49.2922 242.301L49.5589 242.441C51.2856 243.432 58.5862 246.531 60.605 246.302C62.0397 246.543 63.576 246.518 64.998 246.2C65.2266 246.15 65.4297 246.061 65.6582 246.023C66.1661 245.921 68.0579 245.121 68.4388 244.892L72.1335 242.758C73.2001 242.149 73.873 241.285 74.1396 240.332C74.457 239.202 74.2031 238.084 73.4286 237.157C73.3905 236.192 68.4642 232.166 67.093 231.378L60.0844 227.301C59.4242 226.92 57.2911 225.624 56.5166 225.421C54.993 224.837 53.2663 224.532 51.5649 224.545C50.0794 224.558 48.6828 224.812 47.502 225.294C47.0322 225.434 45.6737 226.044 45.2801 226.259L39.3127 229.193Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M41.357 230.298C40.0746 231.035 39.3128 232.051 39.097 233.156C38.843 234.49 39.3636 235.849 40.5825 236.979C40.9634 237.449 42.7409 238.567 43.4265 238.973L50.5621 242.619L50.816 242.746C52.6443 243.8 59.1069 246.391 61.24 246.137C62.6112 246.302 64.0459 246.226 65.3664 245.883C65.5695 245.832 65.7727 245.73 65.9758 245.692C66.3821 245.603 68.2612 244.778 68.5659 244.6L72.0321 242.619C72.9971 242.06 73.6319 241.285 73.9112 240.459C74.254 239.443 74.089 238.414 73.4668 237.551C73.4288 236.535 69.3023 233.042 67.8422 232.204L61.1384 228.406C60.4401 227.999 58.5356 226.894 57.7103 226.679C56.2502 226.145 54.6123 225.866 52.9998 225.878C51.6032 225.891 50.27 226.12 49.1273 226.564C48.6322 226.704 47.426 227.25 47.0197 227.479L41.357 230.298Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M43.4006 231.404C42.2071 232.09 41.4707 233.03 41.2422 234.046C40.9629 235.278 41.4199 236.56 42.5246 237.653C42.9182 238.148 44.4164 239.126 45.1528 239.545L51.8312 242.924L52.0725 243.051C54.015 244.169 59.6143 246.239 61.8743 245.985C63.182 246.074 64.5152 245.959 65.7214 245.591C65.9118 245.528 66.0896 245.439 66.28 245.388C66.5847 245.312 68.4512 244.461 68.6924 244.334L71.9427 242.517C72.8061 242.009 73.4028 241.336 73.6822 240.612C74.0504 239.698 73.9742 238.783 73.5044 237.97C73.4663 236.891 70.1271 233.944 68.5908 233.055L62.1917 229.537C61.4553 229.105 59.7793 228.178 58.9033 227.949C57.4939 227.466 55.9449 227.225 54.4213 227.238C53.1009 227.25 51.8312 227.454 50.7393 227.86C50.2187 228.013 49.1649 228.47 48.7332 228.724L43.4006 231.404Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M45.445 232.509C44.3277 233.157 43.6421 234.008 43.4009 234.935C43.1088 236.078 43.477 237.272 44.4801 238.326C44.8991 238.847 46.1179 239.685 46.8924 240.13L53.1138 243.242L53.3424 243.356C55.3865 244.537 60.1351 246.1 62.522 245.82C63.7663 245.845 64.9979 245.668 66.1025 245.274C66.2803 245.21 66.4453 245.109 66.6231 245.071C66.8262 245.02 68.6926 244.131 68.845 244.042L71.8795 242.378C72.654 241.934 73.1872 241.349 73.492 240.727C73.8729 239.927 73.911 239.114 73.5808 238.352C73.5301 237.209 71.0034 234.808 69.3782 233.868L63.2712 230.629C62.4967 230.185 61.0492 229.436 60.1351 229.194C58.7892 228.762 57.3164 228.546 55.8944 228.572C54.6501 228.585 53.4566 228.775 52.4155 229.131C51.8695 229.296 50.9808 229.677 50.5237 229.944L45.445 232.509Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M47.489 233.614C46.4479 234.211 45.8003 234.985 45.5591 235.824C45.2417 236.865 45.5464 237.996 46.4352 238.999C46.8796 239.558 47.8191 240.244 48.619 240.714L54.3833 243.571L54.5991 243.673C56.7576 244.918 60.6428 245.959 63.1567 245.667C64.3375 245.616 65.4802 245.388 66.4705 244.981C66.6356 244.918 66.7879 244.842 66.9403 244.765C67.0419 244.753 68.8956 243.813 68.9718 243.775L71.7904 242.276C72.4634 241.882 72.9585 241.4 73.2759 240.891C73.6949 240.206 73.8092 239.482 73.6314 238.783C73.5807 237.576 71.8412 235.722 70.1399 234.731L64.3375 231.759C63.5122 231.289 62.306 230.718 61.3411 230.464C60.0587 230.083 58.6748 229.905 57.3289 229.918C56.1608 229.93 55.0435 230.095 54.0405 230.413C53.4564 230.578 52.7327 230.896 52.2503 231.162L47.489 233.614Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2579 244.473L71.7017 242.174C74.6219 240.485 74.2537 237.538 70.8891 235.595L65.3914 232.902C62.0141 230.959 56.9101 230.743 53.9898 232.432L49.546 234.731C46.6258 236.421 46.994 239.367 50.3586 241.31L55.8562 244.003C59.2209 245.946 64.3249 246.162 67.2579 244.473Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0476,
    d: "M22.4387 197.542C19.8994 199.003 18.452 201.314 18.4393 203.88C18.4266 206.7 20.1533 209.329 23.1751 211.107C23.2005 211.145 31.5676 215.502 31.6184 215.54L48.3145 224.202C48.4288 224.265 73.3651 237.157 73.5047 237.132C75.9044 238.478 78.9008 239.215 81.9353 239.202C84.5381 239.202 87.0013 238.58 88.8677 237.5L95.8255 233.004C98.3394 231.556 99.7868 229.257 99.7995 226.704C99.8249 223.91 98.1109 221.293 95.1145 219.528C95.1272 219.464 73.9364 205.48 73.8348 205.429L60.9858 197.021C60.935 196.996 52.3013 191.344 52.2378 191.331C49.8254 189.959 46.8163 189.21 43.7691 189.21C41.1155 189.21 38.7032 189.794 36.7987 190.887C36.7733 190.899 33.8657 192.246 33.853 192.246L22.4387 197.542Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952,
    d: "M24.9146 198.825C22.4642 200.235 21.0548 202.458 21.0295 204.935C20.9914 207.653 22.6419 210.206 25.5495 211.933C25.5876 211.996 33.5865 216.188 33.688 216.239L49.8128 224.609C50.054 224.748 73.9111 237.018 74.1777 236.967C76.5139 238.237 79.396 238.923 82.3163 238.885C84.7921 238.885 87.2426 238.237 89.0074 237.221L95.7366 232.89C98.149 231.493 99.5456 229.295 99.5837 226.857C99.6218 224.177 98.0093 221.662 95.1653 219.96C95.178 219.833 75.003 206.471 74.8125 206.37L62.3317 198.254C62.2174 198.19 53.9646 192.792 53.8249 192.779C51.4761 191.471 48.5558 190.747 45.6102 190.76C43.0455 190.773 40.6966 191.331 38.8429 192.386C38.8048 192.398 36.0242 193.681 35.9861 193.707L24.9146 198.825Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M27.3905 200.108C25.0289 201.48 23.6577 203.613 23.6069 205.988C23.5561 208.618 25.1178 211.082 27.8984 212.771C27.9619 212.873 35.5799 216.873 35.7322 216.962L51.2983 225.028C51.6539 225.231 74.4444 236.891 74.8507 236.814C77.1107 238.008 79.8912 238.643 82.6972 238.58C85.0461 238.58 87.4712 237.907 89.1471 236.941L95.6478 232.775C97.9586 231.442 99.3045 229.346 99.3552 227.009C99.406 224.443 97.8951 222.043 95.2034 220.392C95.2288 220.188 76.0569 207.462 75.7775 207.297L63.6649 199.46C63.4998 199.371 55.6025 194.227 55.3994 194.202C53.114 192.944 50.2826 192.258 47.4259 192.271C44.9373 192.284 42.6773 192.817 40.8744 193.833C40.8109 193.859 38.1573 195.078 38.1065 195.116L27.3905 200.108Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M29.8661 201.404C27.5807 202.725 26.2603 204.782 26.1968 207.056C26.1333 209.583 27.6061 211.971 30.2724 213.61C30.3613 213.749 37.5857 217.56 37.7889 217.674L52.7963 225.447C53.2788 225.726 74.9901 236.751 75.5234 236.65C77.7072 237.767 80.3862 238.352 83.0779 238.263C85.2871 238.263 87.6995 237.577 89.2865 236.65L95.5587 232.649C97.7679 231.366 99.063 229.372 99.1265 227.149C99.2026 224.698 97.7933 222.399 95.254 220.811C95.2794 220.544 77.1358 208.44 76.7549 208.224L65.0105 200.68C64.7947 200.553 57.2528 195.675 56.9989 195.637C54.777 194.443 52.0345 193.796 49.2793 193.808C46.8797 193.821 44.6831 194.342 42.931 195.32C42.8548 195.345 40.3155 196.514 40.252 196.564L29.8661 201.404Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M32.342 202.686C30.1455 203.956 28.8631 205.925 28.787 208.109C28.6981 210.535 30.0947 212.834 32.634 214.447C32.7483 214.625 39.5918 218.257 39.8458 218.397L54.2946 225.865C54.8913 226.208 75.5361 236.623 76.209 236.496C78.3294 237.538 80.8941 238.071 83.4715 237.97C85.5538 237.97 87.9407 237.258 89.4389 236.395L95.4826 232.559C97.6029 231.34 98.8345 229.435 98.9107 227.326C98.9995 224.989 97.6918 222.792 95.3048 221.268C95.3429 220.937 78.2024 209.455 77.7326 209.189L66.3564 201.924C66.0771 201.771 58.9162 197.148 58.586 197.084C56.4276 195.941 53.774 195.332 51.1077 195.344C48.7842 195.357 46.6639 195.865 44.9625 196.792C44.8609 196.83 42.4613 197.935 42.3724 197.986L32.342 202.686Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M34.8176 203.982C32.6973 205.201 31.4657 207.093 31.3768 209.176C31.2753 211.513 32.583 213.723 35.0081 215.286C35.1351 215.489 41.6104 218.944 41.9151 219.122L55.8052 226.298C56.5289 226.717 76.0945 236.497 76.8944 236.344C78.9386 237.31 81.4017 237.792 83.8649 237.665C85.8202 237.665 88.1944 236.929 89.5911 236.116L95.3934 232.445C97.4122 231.277 98.5803 229.473 98.6819 227.479C98.7962 225.256 97.5773 223.161 95.3427 221.7C95.3808 221.306 79.256 210.447 78.6846 210.116L67.6766 203.143C67.3465 202.953 60.5411 198.596 60.1475 198.52C58.0525 197.441 55.4878 196.856 52.9231 196.882C50.6758 196.907 48.6316 197.39 46.9937 198.279C46.8795 198.317 44.5941 199.371 44.4925 199.435L34.8176 203.982Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M37.2936 205.265C35.2621 206.446 34.0814 208.237 33.9671 210.231C33.8528 212.466 35.0717 214.6 37.3698 216.124C37.5222 216.366 43.6166 219.63 43.9594 219.833L57.2909 226.704C58.1288 227.187 76.6279 236.357 77.5674 236.18C79.5354 237.069 81.897 237.488 84.2459 237.348C86.0742 237.348 88.4231 236.586 89.7309 235.837L95.3047 232.331C97.2219 231.226 98.3392 229.524 98.4535 227.632C98.5804 225.523 97.4758 223.542 95.3936 222.132C95.4444 221.675 80.3226 211.438 79.6624 211.057L69.0226 204.363C68.6417 204.147 62.1918 200.045 61.7347 199.956C59.6905 198.927 57.2274 198.381 54.7515 198.406C52.5931 198.432 50.6124 198.889 49.0253 199.752C48.8857 199.803 46.7272 200.794 46.613 200.87L37.2936 205.265Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M39.7695 206.547C37.8142 207.678 36.6842 209.393 36.5572 211.285C36.4176 213.419 37.573 215.476 39.7441 216.95C39.9219 217.229 45.6227 220.316 46.029 220.544L58.8018 227.123C59.7541 227.682 77.1866 236.23 78.2531 236.014C80.1576 236.827 82.4049 237.196 84.6395 237.03C86.3282 237.03 88.6644 236.243 89.8832 235.544L95.2285 232.204C97.0442 231.162 98.1107 229.549 98.2503 227.771C98.4027 225.777 97.387 223.897 95.4571 222.551C95.5206 222.03 81.4146 212.415 80.6528 211.984L70.3812 205.582C69.9495 205.328 63.8678 201.492 63.3345 201.391C61.3538 200.425 58.9796 199.917 56.6053 199.943C54.523 199.968 52.6312 200.413 51.0822 201.226C50.9172 201.289 48.8984 202.216 48.7587 202.305L39.7695 206.547Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M42.2456 207.843C40.3792 208.923 39.2873 210.548 39.1476 212.352C38.9953 214.397 40.0618 216.365 42.106 217.801C42.3091 218.118 47.629 221.014 48.0734 221.268L60.2876 227.543C61.3668 228.165 77.7074 236.09 78.9263 235.862C80.7546 236.599 82.9004 236.916 85.0207 236.738C86.5824 236.738 88.9059 235.925 90.0232 235.278L95.14 232.102C96.854 231.112 97.8697 229.6 98.0221 227.936C98.1872 226.057 97.273 224.278 95.4955 222.996C95.5589 222.399 82.4687 213.419 81.618 212.923L71.7019 206.801C71.2067 206.522 65.4932 202.94 64.8965 202.826C62.9793 201.924 60.6939 201.442 58.4085 201.48C56.4151 201.505 54.5868 201.937 53.1013 202.712C52.9235 202.775 51.019 203.652 50.8667 203.74L42.2456 207.843Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M44.7211 209.126C42.9309 210.155 41.8898 211.704 41.7374 213.406C41.5597 215.349 42.55 217.229 44.4799 218.626C44.6958 218.969 49.6475 221.687 50.1426 221.979L61.7982 227.962C62.9917 228.648 78.2657 235.963 79.6116 235.709C81.3637 236.37 83.4079 236.637 85.414 236.433C86.8487 236.433 89.1468 235.595 90.1752 235.011L95.0634 231.988C96.6759 231.061 97.6409 229.638 97.8059 228.089C97.9964 226.323 97.1711 224.647 95.5586 223.427C95.6348 222.767 83.5476 214.409 82.608 213.863L73.0601 208.033C72.5142 207.716 67.1562 204.401 66.4959 204.274C64.6422 203.423 62.4457 202.978 60.2619 203.016C58.3447 203.055 56.5925 203.448 55.1578 204.198C54.9547 204.274 53.1771 205.087 53.0121 205.188L44.7211 209.126Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M47.1972 210.421C45.4959 211.399 44.4928 212.86 44.3278 214.473C44.1373 216.328 45.0388 218.118 46.8417 219.477C47.083 219.858 51.6538 222.399 52.1997 222.716L63.2966 228.394C64.6171 229.156 78.8119 235.849 80.2974 235.557C81.9861 236.141 83.916 236.357 85.8078 236.129C87.1156 236.129 89.3883 235.278 90.3278 234.732L94.9748 231.874C96.4857 230.997 97.3998 229.689 97.5776 228.229C97.7808 226.577 97.0697 225.015 95.5969 223.847C95.6731 223.123 84.6143 215.388 83.5732 214.791L74.3935 209.24C73.7967 208.897 68.807 205.836 68.0705 205.697C66.2803 204.909 64.1727 204.49 62.0777 204.541C60.2494 204.579 58.5607 204.96 57.1768 205.658C56.961 205.735 55.3104 206.497 55.1199 206.611L47.1972 210.421Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M49.673 211.704C48.0605 212.644 47.0956 214.016 46.9178 215.527C46.7147 217.28 47.5273 218.995 49.2159 220.303C49.4825 220.722 53.6597 223.072 54.2565 223.415L64.7947 228.787C66.2294 229.613 79.3578 235.684 80.9703 235.379C82.5828 235.887 84.4111 236.052 86.1886 235.798C87.3567 235.798 89.6294 234.922 90.4674 234.439L94.8858 231.747C96.2952 230.934 97.1585 229.714 97.349 228.368C97.5775 226.831 96.9554 225.371 95.6349 224.266C95.7238 223.478 85.6681 216.365 84.538 215.705L75.7266 210.447C75.0663 210.066 70.4447 207.271 69.6449 207.119C67.9181 206.382 65.912 206.014 63.906 206.052C62.1538 206.09 60.5413 206.458 59.2209 207.119C58.9797 207.208 57.4561 207.906 57.2529 208.033L49.673 211.704Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M52.1488 212.986C50.6125 213.876 49.6983 215.158 49.5079 216.581C49.2793 218.232 50.0157 219.871 51.5774 221.128C51.8568 221.585 55.6658 223.744 56.3133 224.125L66.2929 229.206C67.8546 230.108 79.9037 235.557 81.6558 235.214C83.1921 235.645 84.9189 235.747 86.5821 235.48C87.6233 235.48 89.8706 234.579 90.6197 234.147L94.8096 231.619C96.1173 230.857 96.9299 229.739 97.1331 228.507C97.3743 227.085 96.8538 225.726 95.6984 224.684C95.7999 223.833 86.7472 217.343 85.5283 216.632L77.085 211.653C76.374 211.246 72.1079 208.706 71.2446 208.541C69.5813 207.868 67.6641 207.525 65.7596 207.576C64.0963 207.627 62.5474 207.969 61.2777 208.592C61.0238 208.681 59.6144 209.329 59.3986 209.456L52.1488 212.986Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M54.6246 214.282C53.1771 215.121 52.3011 216.327 52.0852 217.661C51.844 219.223 52.4915 220.773 53.9389 221.992C54.2437 222.475 57.6718 224.469 58.3701 224.862L67.791 229.638C69.467 230.603 80.4496 235.43 82.3287 235.074C83.8015 235.43 85.414 235.481 86.963 235.201C87.8771 235.201 90.099 234.274 90.7593 233.893L94.7206 231.531C95.9268 230.832 96.6886 229.803 96.9172 228.685C97.1838 227.377 96.7648 226.12 95.7491 225.142C95.8506 224.227 87.8263 218.359 86.4932 217.597L78.4181 212.911C77.6563 212.466 73.7584 210.192 72.8189 210.015C71.2191 209.392 69.3908 209.087 67.5752 209.138C65.9881 209.189 64.528 209.507 63.2964 210.091C63.0171 210.192 61.7474 210.777 61.5062 210.916L54.6246 214.282Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M57.1005 215.565C55.7293 216.353 54.904 217.483 54.6755 218.715C54.4089 220.176 54.9929 221.649 56.3007 222.818C56.6308 223.339 59.6653 225.142 60.4144 225.574L69.2767 230.057C71.0669 231.099 80.983 235.303 83.0018 234.909C84.3984 235.189 85.922 235.189 87.344 234.884C88.1312 234.884 90.3404 233.931 90.8991 233.614L94.6192 231.416C95.7238 230.781 96.4348 229.854 96.6761 228.838C96.9554 227.644 96.638 226.501 95.7746 225.574C95.8889 224.583 88.8676 219.35 87.4456 218.525L79.7387 214.117C78.9134 213.647 75.3837 211.628 74.3934 211.437C72.8571 210.879 71.1177 210.599 69.4036 210.663C67.9054 210.713 66.5088 211.018 65.3407 211.564C65.036 211.666 63.8933 212.2 63.6393 212.352L57.1005 215.565Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M59.5763 216.86C58.2939 217.597 57.5067 218.638 57.2655 219.781C56.9861 221.153 57.4813 222.525 58.6748 223.668C59.0303 224.227 61.6839 225.84 62.4838 226.297L70.7874 230.476C72.7046 231.581 81.5415 235.175 83.6872 234.756C85.0077 234.959 86.4297 234.909 87.7375 234.578C88.385 234.578 90.5815 233.6 91.0513 233.334L94.5429 231.301C95.5586 230.717 96.2061 229.892 96.4601 228.99C96.7648 227.923 96.5363 226.869 95.8379 226.005C95.9522 224.951 89.9467 220.34 88.4358 219.464L81.0971 215.349C80.221 214.841 77.0469 213.088 75.993 212.885C74.5202 212.377 72.8697 212.148 71.2445 212.212C69.8225 212.262 68.502 212.554 67.3847 213.05C67.0673 213.164 66.0389 213.634 65.7722 213.799L59.5763 216.86Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M62.052 218.144C60.8458 218.842 60.1094 219.795 59.8555 220.836C59.5508 222.107 59.9698 223.402 61.0363 224.494C61.4045 225.091 63.6899 226.514 64.5406 227.009L72.2855 230.896C74.317 232.077 82.0874 235.036 84.3601 234.605C85.617 234.732 86.9248 234.63 88.1183 234.274C88.6388 234.274 90.81 233.284 91.1909 233.068L94.4539 231.201C95.3681 230.68 95.9648 229.943 96.2314 229.156C96.5616 228.203 96.4219 227.251 95.8759 226.45C96.0029 225.333 91.0131 221.345 89.4006 220.417L82.4302 216.582C81.5033 216.048 78.6973 214.549 77.5673 214.333C76.1453 213.889 74.5963 213.686 73.0727 213.749C71.7396 213.813 70.4826 214.079 69.4161 214.537C69.0733 214.664 68.1845 215.07 67.8925 215.235L62.052 218.144Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M64.5279 219.426C63.4106 220.074 62.7123 220.938 62.4457 221.891C62.1155 223.059 62.4584 224.278 63.4106 225.333C63.8042 225.955 65.7087 227.212 66.5975 227.733L73.7838 231.315C75.9422 232.56 82.6334 234.909 85.0457 234.439C86.2265 234.49 87.4327 234.338 88.5119 233.969C88.9055 233.969 91.0639 232.953 91.3433 232.788L94.3778 231.086C95.1904 230.616 95.7363 229.994 96.0156 229.308C96.3585 228.47 96.3331 227.619 95.9268 226.882C96.0537 225.701 92.0797 222.335 90.3783 221.357L83.7761 217.813C82.7857 217.242 80.348 215.997 79.1545 215.781C77.7959 215.4 76.3358 215.222 74.9011 215.299C73.6441 215.362 72.4633 215.603 71.4603 216.035C71.1048 216.162 70.3303 216.518 70.0256 216.696L64.5279 219.426Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M67.0037 220.722C65.9753 221.319 65.3151 222.106 65.0358 222.957C64.6929 224.037 64.9469 225.167 65.7722 226.171C66.1912 226.831 67.7021 227.898 68.6543 228.444L75.2693 231.734C77.542 233.042 83.1666 234.769 85.7059 234.287C86.8105 234.249 87.9152 234.045 88.8801 233.664C89.1467 233.664 91.2798 232.623 91.4702 232.509L94.2762 230.972C94.9872 230.565 95.4824 230.032 95.7744 229.46C96.1426 228.736 96.2061 228 95.9648 227.314C96.1045 226.069 93.1335 223.326 91.3433 222.284L85.1092 219.02C84.0681 218.423 81.9858 217.432 80.7288 217.204C79.4338 216.873 78.0625 216.734 76.7294 216.81C75.5613 216.873 74.4567 217.102 73.4917 217.483C73.1108 217.623 72.4633 217.915 72.1459 218.105L67.0037 220.722Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M69.4797 222.005C68.5274 222.551 67.9053 223.25 67.6259 224.012C67.2577 224.99 67.4355 226.044 68.1465 227.01C68.5782 227.708 69.7209 228.585 70.7239 229.169L76.7802 232.154C79.1799 233.538 83.7253 234.643 86.4043 234.122C87.4454 234.008 88.4358 233.754 89.2992 233.348C89.4261 233.348 91.5465 232.281 91.648 232.23L94.2128 230.858C94.8222 230.502 95.2793 230.071 95.5713 229.613C95.9649 229.004 96.1173 228.369 96.0284 227.746C96.1807 226.438 94.2255 224.317 92.3337 223.225L86.4678 220.253C85.3759 219.618 83.6618 218.894 82.3287 218.652C81.0971 218.385 79.8147 218.284 78.5705 218.36C77.4786 218.424 76.4501 218.64 75.536 218.982C75.1424 219.122 74.6218 219.363 74.279 219.567L69.4797 222.005Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6802 233.042L94.1241 230.743C97.0443 229.054 96.6761 226.107 93.3115 224.164L87.8138 221.471C84.4365 219.528 79.3324 219.312 76.4122 221.001L71.9684 223.3C69.0481 224.989 69.4163 227.936 72.781 229.879L78.2786 232.572C81.6559 234.515 86.76 234.731 89.6802 233.042Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0476,
    d: "M34.3484 179.672C31.8217 181.132 30.3616 183.431 30.3489 185.997C30.3235 188.804 32.0503 191.433 35.0721 193.211C35.0848 193.249 46.2578 199.181 46.3213 199.219L65.4806 209.342C65.6076 209.418 95.8256 225.307 95.9653 225.269C97.8444 226.323 100.079 226.996 102.415 227.238C103.05 227.301 103.723 227.327 104.37 227.327C106.973 227.327 109.424 226.704 111.29 225.637L118.235 221.154C120.762 219.693 122.222 217.394 122.235 214.829C122.26 212.022 120.533 209.392 117.524 207.614C117.512 207.563 106.351 200.4 106.288 200.362L90.785 190.468L87.9156 188.639C87.814 188.575 64.0967 173.448 63.9697 173.461C61.57 172.102 58.5863 171.365 55.5518 171.378C53.7362 171.39 52.0348 171.67 50.5366 172.191C49.8637 172.432 49.2035 172.724 48.6194 173.067L34.3484 179.672Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952,
    d: "M37.3573 181.26C34.9195 182.67 33.5102 184.88 33.4721 187.344C33.434 190.049 35.0592 192.589 37.954 194.317C37.9921 194.406 48.6446 200.07 48.7589 200.147L67.2325 209.901C67.4992 210.053 96.3968 225.181 96.6761 225.092C98.4917 226.082 100.65 226.705 102.897 226.933C103.507 226.997 104.167 227.01 104.789 227.01C107.265 227.01 109.69 226.375 111.468 225.346L118.172 221.027C120.609 219.618 122.019 217.407 122.057 214.943C122.095 212.238 120.47 209.698 117.588 207.97C117.549 207.882 106.91 201.023 106.783 200.959L91.826 191.446L89.0581 189.681C88.855 189.566 66.1787 175.163 65.9248 175.189C63.6013 173.906 60.7318 173.207 57.8116 173.233C56.0722 173.245 54.4343 173.525 52.9869 174.033C52.352 174.261 51.7045 174.554 51.1459 174.871L37.3573 181.26Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M40.3537 182.847C38.0048 184.206 36.6462 186.327 36.5955 188.69C36.5447 191.293 38.081 193.745 40.8361 195.434C40.8869 195.561 51.0316 200.984 51.2093 201.086L69.0101 210.459C69.4037 210.688 96.9808 225.041 97.3998 224.913C99.1519 225.841 101.234 226.412 103.38 226.615C103.951 226.666 104.612 226.679 105.196 226.679C107.544 226.679 109.931 226.031 111.62 225.053L118.083 220.913C120.432 219.554 121.79 217.432 121.841 215.07C121.892 212.466 120.355 210.015 117.613 208.338C117.562 208.199 107.43 201.658 107.24 201.556L92.8163 192.424L90.15 190.734C89.8326 190.557 68.1975 176.877 67.8293 176.916C65.582 175.696 62.8141 175.048 60.0081 175.087C58.3322 175.112 56.7578 175.391 55.3738 175.874C54.7644 176.09 54.1296 176.382 53.5963 176.687L40.3537 182.847Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M43.3502 184.435C41.0902 185.743 39.7697 187.775 39.7062 190.049C39.6301 192.551 41.0775 194.913 43.7057 196.552C43.7819 196.729 53.3932 201.899 53.6472 202.039L70.7623 211.044C71.2828 211.349 97.5523 224.926 98.1109 224.774C99.7996 225.65 101.806 226.145 103.862 226.336C104.408 226.387 105.043 226.374 105.602 226.374C107.811 226.374 110.185 225.701 111.773 224.786L117.994 220.811C120.254 219.503 121.562 217.471 121.638 215.21C121.714 212.708 120.267 210.345 117.651 208.719C117.575 208.542 107.964 202.305 107.71 202.166L93.8321 193.414L91.2674 191.789C90.8484 191.547 70.2544 178.605 69.7592 178.656C67.5881 177.512 64.9345 176.903 62.2428 176.954C60.6303 176.979 59.1194 177.258 57.7863 177.728C57.2149 177.932 56.5801 178.224 56.0849 178.516L43.3502 184.435Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M46.3592 186.023C44.1754 187.28 42.9184 189.236 42.8295 191.395C42.7407 193.796 44.0992 196.069 46.5878 197.657C46.6766 197.873 55.7801 202.788 56.0849 202.966L72.5144 211.603C73.1746 211.984 98.1235 224.787 98.8219 224.596C100.46 225.409 102.364 225.854 104.345 226.032C104.853 226.07 105.488 226.057 106.008 226.057C108.09 226.057 110.427 225.371 111.925 224.507L117.905 220.697C120.076 219.44 121.346 217.496 121.422 215.337C121.511 212.937 120.152 210.663 117.676 209.088C117.588 208.859 108.484 202.941 108.167 202.763L94.8351 194.393L92.3719 192.843C91.8514 192.538 72.2985 180.333 71.6764 180.396C69.5814 179.329 67.0294 178.77 64.4647 178.821C62.9157 178.859 61.4809 179.126 60.1986 179.596C59.6653 179.786 59.0305 180.078 58.5607 180.345L46.3592 186.023Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M49.3555 187.61C47.2606 188.816 46.0544 190.684 45.9528 192.741C45.8386 195.04 47.1209 197.225 49.4698 198.774C49.5841 199.028 58.167 203.702 58.5352 203.918L74.2791 212.187C75.0663 212.644 98.7075 224.672 99.5455 224.443C101.12 225.193 102.948 225.587 104.827 225.739C105.31 225.777 105.932 225.752 106.414 225.752C108.37 225.752 110.68 225.053 112.077 224.24L117.816 220.608C119.898 219.401 121.117 217.547 121.219 215.489C121.333 213.19 120.063 211.005 117.714 209.469C117.6 209.202 109.017 203.601 108.636 203.372L95.8507 195.383L93.4892 193.91C92.867 193.554 74.3426 182.072 73.6062 182.136C71.6001 181.132 69.1496 180.624 66.6865 180.7C65.2137 180.751 63.8297 181.018 62.5982 181.462C62.0903 181.64 61.4682 181.932 61.0365 182.186L49.3555 187.61Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M52.3646 189.198C50.3585 190.354 49.1904 192.132 49.0762 194.088C48.9492 196.285 50.13 198.381 52.3519 199.88C52.4789 200.184 60.554 204.592 60.9856 204.846L76.0439 212.733C76.9581 213.267 99.2788 224.52 100.256 224.253C101.767 224.939 103.519 225.282 105.31 225.409C105.754 225.447 106.376 225.396 106.833 225.396C108.662 225.396 110.934 224.672 112.242 223.923L117.727 220.456C119.72 219.3 120.889 217.534 121.015 215.578C121.142 213.381 119.974 211.285 117.752 209.799C117.625 209.482 109.55 204.198 109.119 203.931L96.8664 196.323L94.5937 194.913C93.8573 194.494 76.3867 183.736 75.5233 183.825C73.5934 182.898 71.2573 182.428 68.9084 182.517C67.499 182.568 66.1786 182.835 65.0105 183.266C64.5407 183.431 63.9313 183.724 63.525 183.952L52.3646 189.198Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M55.3609 190.785C53.4437 191.89 52.3264 193.579 52.1868 195.447C52.0344 197.542 53.139 199.562 55.2213 201.01C55.3736 201.353 62.9281 205.519 63.4233 205.798L77.8086 213.317C78.8625 213.927 99.8628 224.405 100.98 224.101C102.427 224.723 104.103 225.015 105.805 225.129C106.224 225.155 106.821 225.104 107.252 225.104C108.941 225.104 111.201 224.367 112.407 223.669L117.651 220.379C119.555 219.274 120.685 217.597 120.812 215.73C120.965 213.635 119.873 211.641 117.79 210.193C117.651 209.837 110.096 204.858 109.588 204.566L97.8821 197.339L95.7109 196.005C94.873 195.523 78.4435 185.501 77.4531 185.59C75.5994 184.739 73.3648 184.308 71.1429 184.409C69.797 184.473 68.5528 184.739 67.4355 185.146C67.0038 185.311 66.3943 185.59 66.0134 185.806L55.3609 190.785Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M58.3704 192.373C56.5421 193.427 55.4629 195.027 55.3232 196.793C55.1582 198.787 56.1612 200.718 58.1165 202.115C58.2816 202.509 65.3282 206.42 65.8742 206.738L79.5739 213.889C80.7547 214.575 100.447 224.278 101.704 223.935C103.088 224.494 104.688 224.723 106.3 224.825C106.681 224.85 107.278 224.774 107.672 224.774C109.233 224.774 111.455 224.012 112.573 223.364L117.575 220.239C119.391 219.185 120.47 217.598 120.622 215.832C120.787 213.838 119.797 211.933 117.842 210.536C117.677 210.129 110.643 205.468 110.071 205.138L98.9109 198.292L96.8413 197.022C95.9018 196.475 80.5007 187.191 79.3961 187.292C77.6186 186.505 75.4982 186.137 73.3779 186.238C72.1082 186.302 70.9147 186.568 69.8482 186.962C69.4419 187.115 68.8452 187.394 68.5024 187.597L58.3704 192.373Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M61.3668 193.974C59.6274 194.977 58.599 196.488 58.4339 198.152C58.2435 200.045 59.1703 201.887 60.9859 203.233C61.1764 203.665 67.7025 207.323 68.3119 207.678L81.326 214.461C82.6338 215.223 101.019 224.152 102.415 223.771C103.748 224.266 105.272 224.279 106.77 224.52C107.126 224.584 107.71 224.457 108.065 224.457C109.5 224.457 111.684 223.682 112.712 223.085L117.473 220.125C119.2 219.122 120.229 217.623 120.394 215.959C120.584 214.067 119.67 212.251 117.867 210.904C117.689 210.46 111.163 206.103 110.528 205.735L99.9139 199.27L97.9459 198.076C96.9048 197.479 82.5449 188.906 81.3133 189.033C79.612 188.322 77.6059 187.991 75.5998 188.106C74.3936 188.182 73.2636 188.436 72.2606 188.817C71.8924 188.957 71.2956 189.236 70.9782 189.414L61.3668 193.974Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M64.3758 195.561C62.7252 196.514 61.7476 197.936 61.5571 199.498C61.354 201.289 62.1792 203.042 63.8679 204.35C64.0711 204.833 70.0766 208.237 70.7622 208.631L83.0907 215.032C84.5381 215.87 101.59 224.025 103.126 223.605C104.396 224.037 105.843 223.974 107.252 224.228C107.57 224.279 108.154 224.152 108.471 224.152C109.779 224.152 111.937 223.364 112.864 222.818L117.384 220.036C119.022 219.084 120.013 217.674 120.19 216.112C120.393 214.321 119.581 212.593 117.905 211.285C117.702 210.79 111.696 206.751 110.998 206.344L100.929 200.261L99.0631 199.13C97.9204 198.47 84.6016 190.633 83.243 190.76C81.6178 190.125 79.7133 189.833 77.8342 189.96C76.6915 190.049 75.6377 190.303 74.6855 190.658C74.3554 190.785 73.7713 191.065 73.4793 191.23L64.3758 195.561Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M67.3722 197.149C65.8105 198.051 64.8709 199.385 64.6805 200.858C64.4519 202.547 65.201 204.211 66.7627 205.469C66.9913 205.989 72.4762 209.139 73.2126 209.571L84.8555 215.604C86.4299 216.519 102.174 223.911 103.85 223.441C105.056 223.822 106.414 223.669 107.748 223.923C108.027 223.974 108.598 223.822 108.89 223.822C110.058 223.822 112.191 223.009 113.042 222.526L117.321 219.91C118.87 219.008 119.809 217.687 120.013 216.227C120.241 214.537 119.505 212.899 117.968 211.641C117.753 211.108 112.255 207.374 111.493 206.929L101.958 201.226L100.193 200.172C98.9361 199.448 86.6584 192.348 85.1856 192.488C83.6366 191.916 81.8464 191.675 80.0688 191.827C79.0023 191.916 77.9993 192.17 77.0978 192.513C76.7931 192.628 76.2217 192.894 75.9551 193.047L67.3722 197.149Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M70.3814 198.736C68.9086 199.587 68.0198 200.832 67.804 202.204C67.5628 203.804 68.2103 205.366 69.645 206.573C69.8863 207.132 74.8634 210.04 75.6632 210.498L86.6332 216.162C88.3345 217.153 102.771 223.77 104.586 223.262C105.729 223.58 107.011 223.364 108.243 223.605C108.497 223.656 109.055 223.491 109.322 223.491C110.363 223.491 112.471 222.665 113.22 222.233L117.245 219.795C118.705 218.944 119.594 217.712 119.81 216.353C120.063 214.765 119.416 213.216 118.007 212.009C117.778 211.425 112.788 208.008 111.963 207.538L102.974 202.216L101.311 201.226C99.952 200.438 88.7154 194.075 87.1156 194.227C85.6428 193.732 83.9669 193.541 82.3036 193.694C81.3006 193.795 80.361 194.049 79.523 194.367C79.2564 194.469 78.6851 194.735 78.4565 194.875L70.3814 198.736Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M73.3778 200.324C71.9939 201.124 71.1432 202.28 70.9147 203.55C70.6481 205.049 71.2194 206.522 72.5145 207.691C72.7811 208.3 77.2376 210.955 78.101 211.45L88.3853 216.747C90.2263 217.813 103.342 223.656 105.297 223.11C106.376 223.364 107.583 223.072 108.725 223.326C108.941 223.377 109.5 223.199 109.728 223.199C110.643 223.199 112.712 222.348 113.372 221.979L117.156 219.706C118.527 218.906 119.378 217.763 119.606 216.505C119.873 215.019 119.314 213.559 118.045 212.403C117.791 211.78 113.322 208.669 112.445 208.161L104.002 203.22L102.441 202.305C100.98 201.467 90.785 195.815 89.0582 195.98C87.6616 195.561 86.0872 195.409 84.5509 195.574C83.6114 195.675 82.748 195.929 81.9481 196.234C81.7195 196.323 81.1482 196.59 80.945 196.717L73.3778 200.324Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M76.374 201.912C75.0789 202.661 74.279 203.728 74.0378 204.896C73.7458 206.293 74.2282 207.678 75.3963 208.796C75.6756 209.443 79.6243 211.844 80.5385 212.377L90.1371 217.293C92.1051 218.436 103.9 223.504 105.995 222.919C107.024 223.11 108.128 222.754 109.195 222.996C109.385 223.034 109.931 222.843 110.122 222.843C110.909 222.843 112.953 221.979 113.512 221.649L117.054 219.541C118.336 218.792 119.136 217.737 119.378 216.581C119.67 215.197 119.2 213.825 118.057 212.72C117.791 212.047 113.829 209.253 112.89 208.707L104.992 204.147L103.532 203.296C101.97 202.394 92.8035 197.479 90.9624 197.657C89.642 197.301 88.1819 197.199 86.7471 197.377C85.8711 197.492 85.0712 197.733 84.3348 198.025C84.1316 198.101 83.573 198.368 83.4079 198.47L76.374 201.912Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M79.3831 203.499C78.1769 204.198 77.4151 205.176 77.1612 206.243C76.8565 207.538 77.2501 208.834 78.2785 209.914C78.5832 210.612 82.0113 212.759 82.989 213.317L91.902 217.865C93.997 219.084 104.484 223.377 106.719 222.755C107.684 222.882 108.712 222.45 109.677 222.691C109.83 222.729 110.363 222.526 110.528 222.526C111.176 222.526 113.194 221.649 113.664 221.37L116.965 219.439C118.159 218.741 118.921 217.776 119.174 216.721C119.492 215.439 119.098 214.156 118.095 213.089C117.803 212.378 114.375 209.888 113.359 209.304L106.008 205.125L104.649 204.35C102.974 203.385 94.8603 199.206 92.8924 199.384C91.6481 199.105 90.2895 199.041 88.9818 199.232C88.1819 199.346 87.4328 199.6 86.7599 199.867C86.5948 199.93 86.0489 200.197 85.8965 200.286L79.3831 203.499Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M82.3799 205.087C81.2626 205.735 80.5389 206.624 80.2722 207.602C79.9421 208.796 80.2468 210.002 81.1483 211.031C81.4657 211.768 84.386 213.66 85.4271 214.27L93.6672 218.449C95.9018 219.732 105.069 223.263 107.443 222.602C108.345 222.666 109.297 222.158 110.173 222.412C110.3 222.45 110.82 222.234 110.947 222.234C111.468 222.234 113.461 221.332 113.83 221.116L116.889 219.351C117.994 218.703 118.705 217.826 118.984 216.861C119.314 215.68 119.022 214.486 118.146 213.47C117.842 212.708 114.921 210.536 113.842 209.914L107.024 206.116L105.754 205.417C103.977 204.389 96.9049 200.946 94.8099 201.137C93.6418 200.934 92.3976 200.908 91.2041 201.124C90.4677 201.251 89.7947 201.493 89.1599 201.759C89.0329 201.81 88.487 202.077 88.3727 202.14L82.3799 205.087Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M85.3888 206.675C84.3604 207.272 83.6875 208.072 83.4081 208.948C83.0526 210.041 83.2812 211.158 84.043 212.136C84.3858 212.911 86.7855 214.562 87.8901 215.197L95.4446 219.008C97.8062 220.367 105.665 223.123 108.179 222.424C109.017 222.424 109.868 222.323 110.681 222.094C110.782 222.107 111.29 221.891 111.392 221.891C111.785 221.891 113.74 220.977 114.02 220.811L116.838 219.224C117.854 218.639 118.527 217.839 118.806 216.976C119.162 215.909 118.959 214.791 118.222 213.826C117.892 213.026 115.493 211.158 114.35 210.511L108.078 207.094L106.91 206.459C105.031 205.379 98.987 202.649 96.7777 202.865C95.6985 202.725 94.5558 202.763 93.4639 202.979C92.791 203.119 92.1815 203.36 91.6102 203.601C91.5086 203.639 90.9754 203.906 90.8865 203.957L85.3888 206.675Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M88.3851 208.262C87.4328 208.808 86.8107 209.519 86.5186 210.294C86.1377 211.285 86.2774 212.314 86.9122 213.254C87.2677 214.079 89.1468 215.476 90.3149 216.149L97.1838 219.579C99.6724 221.014 106.224 222.995 108.877 222.259C109.652 222.195 110.426 222.043 111.15 221.789C111.214 221.801 111.722 221.573 111.785 221.573C112.052 221.573 113.982 220.633 114.159 220.531L116.724 219.109C117.664 218.575 118.273 217.864 118.578 217.102C118.959 216.137 118.832 215.121 118.235 214.193C117.892 213.342 116 211.793 114.794 211.107L109.068 208.071L108.001 207.513C106.021 206.37 101.018 204.375 98.6821 204.591C97.679 204.528 96.6379 204.604 95.6729 204.833C95.0762 204.972 94.5302 205.214 93.997 205.442C93.9335 205.468 93.4002 205.734 93.3495 205.773L88.3851 208.262Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M91.3941 209.85C90.5307 210.345 89.9467 210.968 89.6419 211.641C89.2357 212.517 89.2991 213.47 89.7943 214.359C90.1752 215.223 91.5338 216.366 92.7653 217.077L98.9486 220.138C101.577 221.65 106.795 222.856 109.588 222.081C110.312 221.954 110.998 221.764 111.62 221.484C111.658 221.484 112.14 221.256 112.179 221.256C112.306 221.256 114.21 220.303 114.299 220.252L116.622 219.008C117.473 218.525 118.044 217.903 118.349 217.242C118.755 216.378 118.717 215.451 118.248 214.575C117.892 213.686 116.508 212.441 115.238 211.717L110.058 209.063L109.093 208.567C107.011 207.361 103.05 206.103 100.586 206.332C99.6596 206.345 98.7328 206.459 97.8821 206.7C97.3488 206.853 96.8664 207.081 96.3966 207.297C96.3585 207.31 95.8506 207.577 95.8125 207.589L91.3941 209.85Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.115 221.192L116.559 218.893C119.479 217.204 119.111 214.257 115.746 212.314L110.249 209.621C106.871 207.678 101.767 207.462 98.847 209.151L94.4032 211.45C91.4829 213.139 91.8511 216.086 95.2158 218.029L100.713 220.722C104.091 222.665 109.195 222.881 112.115 221.192Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.056 84.9712L120.47 93.8875L105.056 102.791L89.6548 93.8748L105.056 84.9712Z",
    fill: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.482 216.137L105.068 225.041V102.791L120.482 93.875V216.137Z",
    fill: "url(#paint27_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.069 225.041L89.6548 216.137V93.875L105.069 102.791V225.041Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6548 93.875L104.992 102.143L120.482 93.875L105.526 103.121L105.069 225.041L104.332 103.02L89.6548 93.875Z",
    fill: "url(#paint28_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.9638 125.12L98.3649 134.036L82.9638 142.939L67.55 134.023L82.9638 125.12Z",
    fill: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3774 228.444L82.9636 237.361V142.927L98.3774 134.023V228.444Z",
    fill: "url(#paint29_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9638 237.361L67.55 228.444V134.023L82.9638 142.927V237.361Z",
    fill: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.55 134.023L82.8876 142.292L98.3776 134.023L83.4336 143.27L82.9638 237.361L82.2401 143.156L67.55 134.023Z",
    fill: "url(#paint30_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.351 164.405L75.7521 173.321L60.351 182.225L44.9373 173.308L60.351 164.405Z",
    fill: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7646 240.384L60.3508 249.287V182.212L75.7646 173.309V240.384Z",
    fill: "url(#paint31_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.351 249.287L44.9373 240.384V173.309L60.351 182.212V249.287Z",
    fill: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.9373 173.309L60.2748 181.577L75.7648 173.309L60.8208 182.555L60.351 249.287L59.6273 182.441L44.9373 173.309Z",
    fill: "url(#paint32_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0175 205.15L53.4186 214.054L38.0175 222.958L22.6038 214.054L38.0175 205.15Z",
    fill: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0175 245.07L53.4186 253.974L38.0175 262.877L22.6038 253.974L38.0175 245.07Z",
    fill: "url(#paint33_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4308 254.317L38.0171 263.221V222.958L53.4308 214.054V254.317Z",
    fill: "url(#paint34_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0175 263.221L22.6038 254.317V214.054L38.0175 222.958V263.221Z",
    fill: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.6038 214.054L37.9413 222.323L53.4313 214.054L38.4873 223.301L38.0175 263.221L37.2938 223.186L22.6038 214.054Z",
    fill: "url(#paint35_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0909,
    d: "M139.337 351.253L144.263 348.293C144.276 348.281 145.406 347.607 145.419 347.595C147.222 346.566 149.482 346.007 151.754 346.02C152.846 346.02 153.887 346.172 154.84 346.426C155.589 346.629 156.338 346.947 156.96 347.303L188.625 365.338L189.578 365.872L220.304 383.374C221.751 384.212 222.83 385.521 223.199 386.905C223.3 387.286 223.364 387.68 223.376 388.086C223.427 390.182 222.145 392.163 219.834 393.497L214.908 396.456C214.895 396.469 213.765 397.142 213.752 397.155C211.949 398.184 209.689 398.743 207.417 398.73C206.325 398.73 205.284 398.577 204.331 398.323C203.582 398.12 202.833 397.803 202.211 397.447L170.545 379.411L169.593 378.878L138.867 361.376C137.42 360.537 136.341 359.229 135.972 357.845C135.871 357.464 135.807 357.07 135.795 356.663C135.744 354.555 137.039 352.574 139.337 351.253Z",
    fill: "#A9B0DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1818,
    d: "M141.825 352.854L146.472 350.085C146.498 350.072 147.526 349.45 147.564 349.437C149.266 348.472 151.399 347.964 153.532 347.976C154.56 347.989 155.538 348.129 156.426 348.383C157.099 348.573 157.861 348.891 158.407 349.221L188.168 366.19L189.057 366.698L217.929 383.146C219.224 383.895 220.342 385.166 220.684 386.41C220.786 386.766 220.862 387.134 220.887 387.503C220.989 389.459 219.808 391.326 217.637 392.583L212.99 395.352C212.965 395.365 211.924 395.987 211.898 396C210.197 396.965 208.064 397.473 205.931 397.46C204.902 397.448 203.925 397.308 203.036 397.054C202.363 396.863 201.601 396.546 201.055 396.216L171.294 379.247L170.406 378.739L141.533 362.291C140.238 361.541 139.121 360.271 138.778 359.026C138.677 358.671 138.6 358.302 138.575 357.934C138.461 355.978 139.641 354.111 141.825 352.854Z",
    fill: "#A2A9D7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M144.314 354.453L148.669 351.888C148.707 351.862 149.647 351.303 149.697 351.278C151.297 350.389 153.29 349.919 155.284 349.944C156.249 349.957 157.163 350.109 157.988 350.351C158.585 350.516 159.347 350.859 159.842 351.138L187.698 367.028L188.536 367.51L215.555 382.917C216.71 383.59 217.853 384.822 218.183 385.927C218.285 386.257 218.374 386.587 218.399 386.93C218.564 388.734 217.485 390.499 215.428 391.693L211.073 394.259C211.035 394.284 210.095 394.843 210.045 394.869C208.445 395.758 206.451 396.228 204.458 396.202C203.493 396.19 202.579 396.037 201.754 395.796C201.157 395.631 200.395 395.288 199.9 395.008L172.043 379.119L171.205 378.636L144.187 363.23C143.032 362.557 141.889 361.325 141.559 360.22C141.457 359.889 141.368 359.559 141.343 359.216C141.178 357.4 142.257 355.635 144.314 354.453Z",
    fill: "#9CA3CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M146.79 356.054L150.853 353.679C150.903 353.641 151.741 353.145 151.805 353.12C153.303 352.307 155.169 351.875 157.023 351.913C157.925 351.939 158.763 352.091 159.537 352.32C160.058 352.472 160.819 352.815 161.251 353.069L187.203 367.879L187.978 368.323L213.142 382.689C214.158 383.273 215.326 384.479 215.644 385.432C215.745 385.737 215.847 386.042 215.885 386.346C216.101 388.01 215.123 389.662 213.193 390.779L209.13 393.154C209.079 393.192 208.242 393.688 208.178 393.713C206.68 394.526 204.813 394.958 202.96 394.92C202.058 394.894 201.22 394.742 200.446 394.513C199.925 394.361 199.163 394.018 198.732 393.764L172.78 378.954L172.005 378.51L146.84 364.145C145.825 363.56 144.657 362.354 144.339 361.401C144.238 361.096 144.136 360.792 144.098 360.487C143.895 358.823 144.86 357.172 146.79 356.054Z",
    fill: "#969CC8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M149.278 357.654L153.062 355.482C153.126 355.444 153.875 355 153.951 354.974C155.36 354.225 157.087 353.844 158.788 353.895C159.626 353.92 160.401 354.072 161.112 354.288C161.556 354.428 162.318 354.784 162.686 354.987L186.734 368.73L187.457 369.149L210.768 382.46C211.632 382.955 212.838 384.136 213.13 384.936C213.232 385.216 213.346 385.483 213.397 385.775C213.663 387.286 212.8 388.836 210.984 389.877L207.201 392.049C207.137 392.087 206.388 392.532 206.312 392.557C204.903 393.307 203.176 393.688 201.474 393.637C200.637 393.611 199.862 393.459 199.151 393.243C198.707 393.103 197.945 392.748 197.577 392.544L173.529 378.802L172.805 378.383L149.494 365.072C148.631 364.576 147.425 363.395 147.133 362.595C147.031 362.316 146.917 362.049 146.866 361.757C146.599 360.245 147.476 358.708 149.278 357.654Z",
    fill: "#8F96C1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5455,
    d: "M151.767 359.267L155.259 357.286C155.348 357.235 155.982 356.854 156.084 356.816C157.392 356.143 158.991 355.8 160.54 355.863C161.302 355.902 162.026 356.054 162.673 356.257C163.042 356.371 163.816 356.74 164.121 356.918L186.264 369.581L186.937 369.962L208.394 382.231C209.118 382.65 210.362 383.781 210.629 384.454C210.73 384.708 210.857 384.937 210.921 385.203C211.251 386.575 210.476 388.01 208.8 388.976L205.309 390.957C205.22 391.008 204.585 391.389 204.484 391.427C203.176 392.1 201.576 392.443 200.027 392.379C199.265 392.341 198.542 392.189 197.894 391.986C197.526 391.871 196.751 391.503 196.447 391.325L174.304 378.662L173.631 378.281L152.173 366.012C151.45 365.593 150.205 364.462 149.939 363.789C149.837 363.535 149.71 363.306 149.647 363.04C149.317 361.668 150.078 360.233 151.767 359.267Z",
    fill: "#898FBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M154.255 360.868L157.455 359.077C157.556 359.026 158.102 358.696 158.204 358.658C159.41 358.048 160.883 357.756 162.292 357.832C162.991 357.87 163.638 358.035 164.235 358.226C164.527 358.328 165.301 358.709 165.543 358.848L185.781 370.432L186.391 370.787L205.994 382.015C206.578 382.346 207.962 383.412 208.102 383.971C208.241 384.175 208.343 384.403 208.419 384.632C208.8 385.851 208.14 387.172 206.578 388.074L203.379 389.865C203.277 389.916 202.731 390.246 202.63 390.284C201.423 390.893 199.951 391.186 198.541 391.109C197.843 391.071 197.195 390.906 196.599 390.716C196.307 390.614 195.532 390.233 195.291 390.093L175.052 378.51L174.443 378.154L154.839 366.926C154.255 366.596 152.871 365.529 152.732 364.97C152.592 364.767 152.49 364.538 152.414 364.31C152.033 363.09 152.694 361.77 154.255 360.868Z",
    fill: "#8289B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7273,
    d: "M156.731 362.468L159.639 360.88C159.753 360.817 160.198 360.563 160.325 360.512C161.429 359.978 162.775 359.724 164.032 359.813C164.667 359.864 165.251 360.017 165.784 360.207C166 360.283 166.774 360.677 166.965 360.779L185.299 371.295L185.858 371.613L203.607 381.786C204.039 382.04 205.474 383.069 205.588 383.488C205.741 383.666 205.842 383.857 205.931 384.06C206.363 385.14 205.804 386.346 204.369 387.184L201.462 388.772C201.347 388.836 200.903 389.09 200.776 389.14C199.672 389.674 198.326 389.928 197.069 389.839C196.434 389.788 195.85 389.636 195.317 389.445C195.101 389.369 194.326 388.975 194.136 388.874L175.802 378.357L175.243 378.04L157.493 367.866C157.061 367.612 155.614 366.583 155.512 366.164C155.36 365.986 155.259 365.796 155.17 365.592C154.738 364.513 155.297 363.293 156.731 362.468Z",
    fill: "#7C82AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M159.22 364.069L161.848 362.672C161.975 362.595 162.331 362.405 162.471 362.341C163.474 361.871 164.68 361.668 165.81 361.77C166.381 361.821 166.902 361.986 167.371 362.151C167.511 362.202 168.286 362.608 168.413 362.684L184.842 372.121L185.337 372.413L201.233 381.546C201.526 381.711 203.011 382.701 203.074 382.981C203.227 383.133 203.341 383.298 203.43 383.463C203.925 384.403 203.468 385.496 202.148 386.258L199.519 387.655C199.392 387.731 199.037 387.922 198.897 387.985C197.894 388.455 196.688 388.658 195.558 388.557C194.987 388.506 194.466 388.341 193.996 388.176C193.857 388.125 193.082 387.718 192.955 387.642L176.526 378.205L176.031 377.913L160.134 368.781C159.842 368.616 158.357 367.625 158.293 367.346C158.141 367.193 158.027 367.028 157.938 366.863C157.455 365.936 157.912 364.831 159.22 364.069Z",
    fill: "#767CA4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9091,
    d: "M161.709 365.669L164.045 364.475C164.184 364.399 164.438 364.259 164.591 364.196C165.492 363.802 166.571 363.65 167.549 363.751C168.057 363.802 168.501 363.98 168.908 364.132C168.984 364.158 169.758 364.59 169.809 364.628L184.321 372.985L184.766 373.239L198.808 381.33C198.948 381.419 200.484 382.371 200.522 382.511C200.675 382.638 200.802 382.765 200.903 382.905C201.462 383.692 201.094 384.683 199.913 385.369L197.577 386.563C197.437 386.639 197.183 386.779 197.031 386.842C196.129 387.236 195.05 387.388 194.072 387.287C193.565 387.236 193.12 387.058 192.714 386.906C192.638 386.88 191.863 386.448 191.812 386.41L177.3 378.053L176.856 377.799L162.813 369.708C162.674 369.619 161.137 368.667 161.099 368.527C160.947 368.4 160.82 368.273 160.718 368.133C160.16 367.358 160.515 366.368 161.709 365.669Z",
    fill: "#6F759D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.431 385.635L177.655 377.684L163.879 369.733C162.787 369.111 162.927 368.006 164.184 367.282L166.228 366.278C167.485 365.554 169.39 365.478 170.469 366.101L184.245 374.052L198.021 382.003C199.113 382.625 198.973 383.73 197.716 384.454L195.672 385.457C194.415 386.181 192.51 386.27 191.431 385.635Z",
    fill: "#696F96"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M97.2856 379.882C143.889 379.882 181.668 355.06 181.668 324.441C181.668 293.822 143.889 269 97.2856 269C50.6827 269 12.9036 293.822 12.9036 324.441C12.9036 355.06 50.6827 379.882 97.2856 379.882Z",
    fill: "url(#paint36_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.648 283.136C129.51 276.125 113.347 272.264 96.1173 272.264C79.053 272.264 63.0806 276.061 51.133 282.958C39.6933 289.563 33.3958 298.187 33.3958 307.243C33.3958 308.272 33.4846 312.933 33.637 313.949C34.894 306.024 40.9884 298.581 51.133 292.725C63.0806 285.829 79.053 282.031 96.1173 282.031C113.334 282.031 129.51 285.892 141.648 292.903C151.97 298.86 158.166 306.417 159.436 314.432C159.601 313.416 159.677 308.754 159.677 307.726C159.677 298.581 153.265 289.855 141.648 283.136Z",
    fill: "url(#paint37_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96.1173 274.258C79.053 274.258 63.0806 278.055 51.133 284.952C39.6933 291.557 33.3958 300.181 33.3958 309.237C33.3958 318.382 39.7949 327.12 51.425 333.827C63.563 340.838 79.7259 344.699 96.9553 344.699C114.02 344.699 129.992 340.901 141.94 334.004C153.379 327.4 159.677 318.776 159.677 309.72C159.677 300.575 153.278 291.836 141.648 285.13C129.51 278.119 113.334 274.258 96.1173 274.258Z",
    fill: "url(#paint38_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1173 274.258C79.053 274.258 63.0806 278.055 51.133 284.952C39.6933 291.557 33.3958 300.181 33.3958 309.237C33.3958 318.382 39.7949 327.12 51.425 333.827C63.563 340.838 79.7259 344.699 96.9553 344.699C114.02 344.699 129.992 340.901 141.94 334.004C153.379 327.4 159.677 318.776 159.677 309.72C159.677 300.575 153.278 291.836 141.648 285.13C129.51 278.119 113.334 274.258 96.1173 274.258Z",
    fill: "url(#paint39_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9425 348.598C78.6974 348.598 61.4934 344.457 48.4793 336.938C34.9573 329.127 27.5044 318.585 27.5044 307.243C27.5044 296.002 34.8431 285.562 48.1873 277.865C61.0109 270.46 78.0371 266.37 96.1172 266.37C114.362 266.37 131.566 270.511 144.58 278.03C158.102 285.841 165.555 296.383 165.555 307.725C165.555 318.966 158.217 329.406 144.872 337.103C132.049 344.521 115.023 348.598 96.9425 348.598ZM96.1172 272.263C79.0529 272.263 63.0805 276.061 51.1329 282.958C39.6932 289.563 33.3957 298.187 33.3957 307.243C33.3957 316.388 39.7948 325.126 51.4249 331.832C63.5629 338.843 79.7258 342.705 96.9552 342.705C114.02 342.705 129.992 338.907 141.939 332.01C153.379 325.405 159.677 316.781 159.677 307.725C159.677 298.58 153.278 289.842 141.647 283.136C129.509 276.125 113.334 272.263 96.1172 272.263Z",
    fill: "url(#paint40_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1335 322.548C58.3576 314.597 58.2941 301.693 71.9811 293.792C73.3143 293.03 74.7236 292.332 76.2091 291.709L67.6896 284.698C60.2113 287.721 55.0311 291.277 51.1967 296.066C39.6554 310.431 50.5238 327.552 75.4727 334.309L81.7449 326.498C78.266 325.533 75.0029 324.212 72.1335 322.548Z",
    fill: "url(#paint41_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.901 305.883L131.985 306.556C132.862 312.323 129.51 318.254 121.904 322.636C117.232 325.329 111.557 327.107 105.551 327.958L109.36 336.087C132.925 332.48 148.11 319.931 145.901 305.883Z",
    fill: "url(#paint42_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.765 293.881C127.884 297.424 131.3 301.933 131.998 306.556L145.914 305.883C144.809 298.86 140.086 293.042 131.427 288.038L121.536 293.754C121.6 293.804 121.688 293.843 121.765 293.881Z",
    fill: "url(#paint43_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.523 293.754L131.414 288.039C114.108 278.043 87.6105 276.658 67.6641 284.698L76.1835 291.709C89.8324 286.019 109.081 286.705 121.523 293.754Z",
    fill: "url(#paint44_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4919 291.976L95.9648 301.375C99.3167 301.223 102.757 301.896 105.335 303.382C107.024 304.36 108.103 305.554 108.573 306.811L124.355 304.398C123.161 301.591 120.66 298.924 116.851 296.726C110.731 293.183 102.491 291.595 94.4919 291.976Z",
    fill: "url(#paint45_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.386 313.098C100.752 315.778 93.2225 315.765 88.5628 313.073C88.2073 312.869 87.8772 312.641 87.5725 312.412L74.2029 317.81C75.0536 318.483 75.9931 319.118 77.0469 319.728C88.093 326.104 106.008 326.142 116.991 319.804C119.263 318.496 121.054 317.01 122.374 315.422L107.532 311.409C106.986 312.006 106.275 312.577 105.386 313.098Z",
    fill: "url(#paint46_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2835 303.483L76.6787 296.79C66.9531 302.531 66.1278 311.472 74.1902 317.81L87.5598 312.412C84.0047 309.758 84.2332 305.96 88.2835 303.483Z",
    fill: "url(#paint47_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5122 303.344C90.5818 302.15 93.2481 301.489 95.9652 301.375L94.4924 291.976C88.0679 292.268 81.8084 293.83 76.9202 296.65C76.844 296.701 76.7678 296.739 76.6917 296.79L88.2964 303.483C88.3599 303.445 88.4361 303.394 88.5122 303.344Z",
    fill: "url(#paint48_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.53 308.971C165.01 319.741 157.722 329.686 144.885 337.104C132.062 344.509 115.035 348.599 96.9554 348.599C78.7103 348.599 61.5063 344.458 48.4922 336.939C35.2369 329.28 27.8221 318.992 27.53 307.917V317.125L27.5173 317.277C27.6316 328.518 35.0592 338.958 48.4795 346.706C61.4936 354.225 78.7103 358.366 96.9427 358.366C115.023 358.366 132.049 354.289 144.873 346.871C157.887 339.352 165.187 329.242 165.53 318.319L165.517 318.141V308.971H165.53Z",
    fill: "url(#paint49_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.648 282.437C129.51 275.426 113.347 271.565 96.1173 271.565C79.053 271.565 63.0806 275.363 51.133 282.259C39.6933 288.864 33.3958 297.488 33.3958 306.544C33.3958 306.709 33.4084 306.874 33.4084 307.027C33.637 298.149 39.9091 289.715 51.133 283.237C63.0806 276.341 79.053 272.543 96.1173 272.543C113.334 272.543 129.51 276.404 141.648 283.415C153.075 290.007 159.448 298.555 159.664 307.522C159.664 307.357 159.677 307.192 159.677 307.027C159.677 297.882 153.265 289.156 141.648 282.437Z",
    fill: "url(#paint50_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.872 336.417C132.049 343.822 115.023 347.912 96.9425 347.912C78.6974 347.912 61.4934 343.772 48.4793 336.252C35.1478 328.555 27.7202 318.191 27.5171 307.052C27.5171 307.217 27.5044 307.382 27.5044 307.548C27.5044 318.89 34.9573 329.432 48.4793 337.243C61.4934 344.762 78.7101 348.903 96.9425 348.903C115.023 348.903 132.049 344.826 144.872 337.408C158.204 329.711 165.555 319.271 165.555 308.03C165.555 307.865 165.543 307.7 165.543 307.548C165.339 318.585 158.013 328.822 144.872 336.417Z",
    fill: "url(#paint51_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.458 346.744C137.458 347.912 137.864 348.725 138.512 349.131C138.537 349.144 147.73 354.428 147.755 354.428C148.428 354.809 147.996 353.945 149.025 353.348C151.094 352.154 152.783 349.246 152.783 346.871C152.783 345.689 153.875 345.689 153.202 345.296C153.189 345.283 143.857 339.987 143.832 339.974C143.159 339.606 142.232 339.669 141.216 340.266C139.134 341.46 137.458 344.356 137.458 346.744Z",
    fill: "url(#paint52_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.79 352.079C146.79 354.454 148.466 355.419 150.548 354.225C152.618 353.031 154.306 350.123 154.306 347.748C154.306 345.372 152.631 344.407 150.548 345.601C148.466 346.795 146.79 349.691 146.79 352.079Z",
    fill: "url(#paint53_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.371 345.499C151.361 344.928 152.262 344.852 152.935 345.182C152.313 345.004 151.526 345.144 150.688 345.627C148.618 346.82 146.93 349.729 146.93 352.104C146.93 353.349 147.387 354.2 148.111 354.555C147.196 354.301 146.6 353.387 146.6 351.977C146.612 349.602 148.288 346.706 150.371 345.499Z",
    fill: "url(#paint54_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.495 354.733C145.495 356.829 146.219 358.315 147.387 359.026C147.425 359.052 208.128 395.542 208.153 395.568C209.372 396.253 208.597 394.704 210.451 393.624C214.184 391.465 217.206 386.245 217.206 381.965C217.206 379.843 219.161 379.831 217.967 379.12C217.929 379.094 156.998 342.565 156.96 342.54C155.741 341.879 154.078 342.007 152.237 343.061C148.517 345.22 145.495 350.453 145.495 354.733Z",
    fill: "url(#paint55_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.426 391.325C206.426 395.605 209.448 397.332 213.181 395.186C216.913 393.027 219.935 387.806 219.935 383.526C219.935 379.246 216.913 377.518 213.181 379.665C209.461 381.824 206.426 387.044 206.426 391.325Z",
    fill: "url(#paint56_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.863 379.501C214.653 378.472 216.279 378.332 217.485 378.929C216.355 378.611 214.958 378.853 213.447 379.729C209.714 381.888 206.693 387.109 206.693 391.389C206.693 393.624 207.518 395.161 208.826 395.809C207.175 395.352 206.109 393.7 206.109 391.16C206.109 386.88 209.13 381.66 212.863 379.501Z",
    fill: "url(#paint57_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M7.16457 306.011C10.7704 322.243 35.2623 330.613 61.8872 324.707C88.4994 318.801 107.164 300.842 103.558 284.609C99.9518 268.377 75.4599 260.007 48.835 265.913C22.2228 271.819 3.57141 289.779 7.16457 306.011Z",
    fill: "url(#paint58_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M141.648 285.117C129.51 278.106 113.347 274.245 96.1175 274.245C85.1984 274.245 74.7236 275.807 65.4551 278.741C99.3171 288.801 125.752 310.139 136.747 336.672C138.55 335.833 140.277 334.944 141.927 333.992C153.367 327.387 159.664 318.763 159.664 309.707C159.677 300.575 153.265 291.836 141.648 285.117Z",
    fill: "url(#paint59_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.868 370.749C360.802 370.749 374.53 364.352 374.53 356.46C374.53 348.569 360.802 342.171 343.868 342.171C326.933 342.171 313.205 348.569 313.205 356.46C313.205 364.352 326.933 370.749 343.868 370.749Z",
    fill: "url(#paint60_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.625 352.078C393.559 352.078 407.287 345.681 407.287 337.789C407.287 329.898 393.559 323.5 376.625 323.5C359.69 323.5 345.962 329.898 345.962 337.789C345.962 345.681 359.69 352.078 376.625 352.078Z",
    fill: "url(#paint61_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.002 345.855C329.936 345.855 343.665 339.457 343.665 331.566C343.665 323.674 329.936 317.277 313.002 317.277C296.068 317.277 282.34 323.674 282.34 331.566C282.34 339.457 296.068 345.855 313.002 345.855Z",
    fill: "url(#paint62_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.229 329.381H349.543V335.973H349.556C349.556 336.037 349.543 336.1 349.543 336.164C349.543 343.67 359.993 349.767 372.892 349.767C385.792 349.767 396.242 343.683 396.242 336.164C396.242 336.1 396.229 336.037 396.229 335.973H396.242V329.381H396.229Z",
    fill: "url(#paint63_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 348.307C359.98 348.307 349.53 342.223 349.53 334.704V335.974H349.543C349.543 336.037 349.53 336.101 349.53 336.164C349.53 343.671 359.98 349.767 372.879 349.767C385.767 349.767 396.229 343.683 396.229 336.164C396.229 336.101 396.216 336.037 396.216 335.974H396.229V334.704C396.229 342.223 385.779 348.307 372.879 348.307Z",
    fill: "url(#paint64_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.228 335.288V335.097H396.216C396.216 335.161 396.228 335.224 396.228 335.288Z",
    fill: "url(#paint65_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.028 349.106C380.243 349.068 380.459 349.017 380.688 348.967V331.693H380.028V349.106Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.961 348.421C383.177 348.357 383.405 348.307 383.621 348.243V331.706H382.961V348.421Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.893 347.456C386.122 347.367 386.325 347.265 386.554 347.176V331.706H385.893V347.456Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.095 349.526C377.311 349.5 377.539 349.488 377.755 349.462V331.706H377.095V349.526Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.759 344.14C391.988 343.962 392.204 343.784 392.419 343.594V331.693H391.759V344.14Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.692 340.978C394.934 340.597 395.162 340.216 395.353 339.822V331.706H394.692V340.978Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.826 346.071C389.042 345.956 389.271 345.842 389.487 345.715V331.693H388.826V346.071Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.162 349.729C374.378 349.716 374.606 349.716 374.822 349.703V331.693H374.162V349.729Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.229 349.716C371.445 349.729 371.661 349.729 371.889 349.742V331.706H371.229V349.716Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.376 349.031C365.592 349.069 365.807 349.119 366.036 349.17V331.706H365.376V349.031Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.296 349.5C368.512 349.526 368.728 349.539 368.956 349.564V331.706H368.296V349.5Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.443 348.319C362.659 348.382 362.875 348.446 363.103 348.497V331.693H362.443V348.319Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.711 340.393C350.914 340.749 351.117 341.092 351.371 341.435V331.693H350.711V340.393Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.644 343.861C353.847 344.039 354.076 344.204 354.304 344.369V331.706H353.644V343.861Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51 347.303C359.726 347.392 359.942 347.481 360.17 347.557V331.706H359.51V347.303Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.577 345.88C356.793 345.994 357.009 346.109 357.237 346.223V331.693H356.577V345.88Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 343.086C385.775 343.086 396.229 336.996 396.229 329.483C396.229 321.97 385.775 315.88 372.879 315.88C359.984 315.88 349.53 321.97 349.53 329.483C349.53 336.996 359.984 343.086 372.879 343.086Z",
    fill: "url(#paint66_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88 342.718C360.259 342.718 350 336.875 349.581 329.584C349.569 329.737 349.543 329.902 349.543 330.054C349.543 337.561 359.993 343.657 372.892 343.657C385.792 343.657 396.242 337.574 396.242 330.054C396.242 329.889 396.216 329.737 396.203 329.584C395.759 336.875 385.5 342.718 372.88 342.718Z",
    fill: "url(#paint67_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 339.644C382.514 339.644 390.325 335.095 390.325 329.483C390.325 323.871 382.514 319.322 372.879 319.322C363.245 319.322 355.434 323.871 355.434 329.483C355.434 335.095 363.245 339.644 372.879 339.644Z",
    fill: "url(#paint68_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.464 319.817C382.783 319.817 390.375 324.072 390.871 329.432C390.883 329.254 390.921 329.077 390.921 328.886C390.921 323.272 383.113 318.725 373.464 318.725C363.827 318.725 356.018 323.272 356.018 328.886C356.018 329.077 356.044 329.254 356.069 329.432C356.552 324.085 364.144 319.817 373.464 319.817Z",
    fill: "url(#paint69_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88 320.402C382.199 320.402 389.792 324.669 390.287 330.017C390.299 329.839 390.337 329.661 390.337 329.471C390.337 323.857 382.529 319.31 372.892 319.31C363.255 319.31 355.447 323.857 355.447 329.471C355.447 329.661 355.472 329.839 355.498 330.017C355.968 324.669 363.56 320.402 372.88 320.402Z",
    fill: "url(#paint70_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.144 316.376C390.388 318.166 393.93 321.723 393.042 324.314C392.153 326.918 387.189 327.565 381.945 325.787C376.701 323.996 373.159 320.44 374.047 317.849C374.924 315.258 379.901 314.597 385.144 316.376Z",
    fill: "url(#paint71_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.225 326.283C373.794 326.359 373.349 326.473 372.88 326.588C372.473 326.689 372.054 326.816 371.584 326.969C371.127 327.121 370.683 327.286 370.277 327.464L371.673 328.277C371.813 328.226 371.965 328.163 372.13 328.112C372.296 328.061 372.473 327.998 372.638 327.934C373.438 327.655 374.187 327.413 374.886 327.235C375.584 327.045 376.244 326.918 376.866 326.854C377.488 326.791 378.072 326.804 378.631 326.905C379.19 327.007 379.736 327.197 380.244 327.502C380.853 327.858 381.247 328.239 381.412 328.633C381.577 329.039 381.577 329.445 381.412 329.852C381.247 330.258 380.955 330.678 380.536 331.084C380.117 331.49 379.621 331.871 379.05 332.24L380.942 333.332L379.368 334.234L377.45 333.129C376.485 333.611 375.457 334.043 374.34 334.437C373.235 334.818 372.156 335.123 371.127 335.339L370.112 332.849C370.645 332.748 371.191 332.621 371.75 332.481C372.219 332.367 372.753 332.214 373.337 332.024C373.921 331.833 374.467 331.63 374.987 331.389L373.616 330.601C373.133 330.792 372.626 330.97 372.105 331.135C371.331 331.389 370.62 331.592 369.985 331.744C369.35 331.884 368.766 331.973 368.233 331.998C367.699 332.024 367.217 331.986 366.76 331.884C366.315 331.782 365.884 331.617 365.477 331.376C364.919 331.046 364.538 330.703 364.347 330.309C364.157 329.928 364.093 329.522 364.195 329.115C364.284 328.696 364.512 328.29 364.868 327.858C365.223 327.439 365.681 327.032 366.239 326.651L364.665 325.737L366.226 324.835L367.814 325.749C368.283 325.521 368.766 325.318 369.261 325.127C369.743 324.937 370.239 324.771 370.721 324.619C371.204 324.467 371.661 324.327 372.118 324.213C372.562 324.098 372.981 323.984 373.349 323.882L374.225 326.283ZM368.956 328.798C369.109 328.887 369.299 328.925 369.528 328.899C369.756 328.887 370.048 328.823 370.391 328.721L369.21 328.036C368.74 328.366 368.664 328.62 368.956 328.798ZM376.46 330.042C376.32 329.954 376.104 329.928 375.838 329.954C375.571 329.979 375.266 330.042 374.924 330.144L376.079 330.805C376.371 330.614 376.536 330.449 376.587 330.335C376.638 330.22 376.587 330.119 376.46 330.042Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.225 325.711C373.794 325.787 373.349 325.901 372.88 326.015C372.473 326.117 372.054 326.244 371.584 326.396C371.127 326.549 370.683 326.714 370.277 326.892L371.673 327.705C371.813 327.654 371.965 327.59 372.13 327.54C372.296 327.489 372.473 327.425 372.638 327.362C373.438 327.082 374.187 326.841 374.886 326.663C375.584 326.473 376.244 326.346 376.866 326.282C377.488 326.219 378.072 326.231 378.631 326.333C379.19 326.435 379.736 326.625 380.244 326.93C380.853 327.286 381.247 327.667 381.412 328.06C381.577 328.467 381.577 328.873 381.412 329.28C381.247 329.686 380.955 330.105 380.536 330.512C380.117 330.918 379.621 331.299 379.05 331.667L380.942 332.76L379.368 333.662L377.45 332.557C376.485 333.039 375.457 333.471 374.34 333.865C373.235 334.246 372.156 334.551 371.127 334.767L370.112 332.277C370.645 332.175 371.191 332.049 371.75 331.909C372.219 331.794 372.753 331.642 373.337 331.452C373.921 331.261 374.467 331.058 374.987 330.816L373.616 330.029C373.133 330.22 372.626 330.397 372.105 330.562C371.331 330.816 370.62 331.02 369.985 331.172C369.35 331.312 368.766 331.401 368.233 331.426C367.699 331.452 367.217 331.413 366.76 331.312C366.315 331.21 365.884 331.045 365.477 330.804C364.919 330.474 364.538 330.131 364.347 329.737C364.157 329.356 364.093 328.949 364.195 328.543C364.284 328.124 364.512 327.717 364.868 327.286C365.223 326.866 365.681 326.46 366.239 326.079L364.665 325.164L366.226 324.263L367.814 325.177C368.283 324.949 368.766 324.745 369.261 324.555C369.743 324.364 370.239 324.199 370.721 324.047C371.204 323.894 371.661 323.755 372.118 323.64C372.562 323.526 372.981 323.412 373.349 323.31L374.225 325.711ZM368.956 328.213C369.109 328.302 369.299 328.34 369.528 328.314C369.756 328.302 370.048 328.238 370.391 328.137L369.21 327.451C368.74 327.781 368.664 328.035 368.956 328.213ZM376.46 329.457C376.32 329.369 376.104 329.343 375.838 329.369C375.571 329.394 375.266 329.457 374.924 329.559L376.079 330.22C376.371 330.029 376.536 329.864 376.587 329.75C376.638 329.635 376.587 329.534 376.46 329.457Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.229 321.57H349.543V328.162H349.556C349.556 328.226 349.543 328.289 349.543 328.353C349.543 335.859 359.993 341.956 372.892 341.956C385.792 341.956 396.242 335.872 396.242 328.353C396.242 328.289 396.229 328.226 396.229 328.162H396.242V321.57H396.229Z",
    fill: "url(#paint72_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 340.482C359.98 340.482 349.53 334.398 349.53 326.879V328.149H349.543C349.543 328.213 349.53 328.276 349.53 328.34C349.53 335.846 359.98 341.943 372.879 341.943C385.767 341.943 396.229 335.859 396.229 328.34C396.229 328.276 396.216 328.213 396.216 328.149H396.229V326.879C396.229 334.398 385.779 340.482 372.879 340.482Z",
    fill: "url(#paint73_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.228 327.476V327.286H396.216C396.216 327.349 396.228 327.413 396.228 327.476Z",
    fill: "url(#paint74_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.028 341.283C380.243 341.245 380.459 341.194 380.688 341.143V323.882H380.028V341.283Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.961 340.597C383.177 340.534 383.405 340.483 383.621 340.419V323.882H382.961V340.597Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.893 339.632C386.122 339.543 386.325 339.441 386.554 339.352V323.882H385.893V339.632Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.095 341.715C377.311 341.689 377.539 341.677 377.755 341.651V323.882H377.095V341.715Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.759 336.317C391.988 336.139 392.204 335.961 392.419 335.771V323.882H391.759V336.317Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.692 333.154C394.934 332.773 395.162 332.392 395.353 331.998V323.882H394.692V333.154Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.826 338.26C389.042 338.146 389.271 338.032 389.487 337.904V323.882H388.826V338.26Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.162 341.905C374.378 341.893 374.606 341.893 374.822 341.88V323.882H374.162V341.905Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.229 341.893C371.445 341.905 371.661 341.905 371.889 341.905V323.882H371.229V341.893Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.376 341.207C365.592 341.245 365.807 341.296 366.036 341.347V323.882H365.376V341.207Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.296 341.677C368.512 341.702 368.728 341.715 368.956 341.74V323.882H368.296V341.677Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.443 340.496C362.659 340.559 362.875 340.623 363.103 340.673V323.882H362.443V340.496Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.711 332.583C350.914 332.938 351.117 333.281 351.371 333.624V323.882H350.711V332.583Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.644 336.037C353.847 336.215 354.076 336.38 354.304 336.545V323.882H353.644V336.037Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51 339.479C359.726 339.568 359.942 339.657 360.17 339.733V323.882H359.51V339.479Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.577 338.07C356.793 338.184 357.009 338.298 357.237 338.413V323.882H356.577V338.07Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 335.262C385.775 335.262 396.229 329.172 396.229 321.659C396.229 314.146 385.775 308.056 372.879 308.056C359.984 308.056 349.53 314.146 349.53 321.659C349.53 329.172 359.984 335.262 372.879 335.262Z",
    fill: "url(#paint75_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88 334.893C360.259 334.893 350 329.051 349.581 321.76C349.569 321.913 349.543 322.078 349.543 322.23C349.543 329.737 359.993 335.833 372.892 335.833C385.792 335.833 396.242 329.749 396.242 322.23C396.242 322.065 396.216 321.913 396.203 321.76C395.759 329.063 385.5 334.893 372.88 334.893Z",
    fill: "url(#paint76_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 331.82C382.514 331.82 390.325 327.271 390.325 321.659C390.325 316.047 382.514 311.498 372.879 311.498C363.245 311.498 355.434 316.047 355.434 321.659C355.434 327.271 363.245 331.82 372.879 331.82Z",
    fill: "url(#paint77_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.464 312.006C382.783 312.006 390.375 316.274 390.871 321.621C390.883 321.443 390.921 321.266 390.921 321.075C390.921 315.461 383.113 310.914 373.464 310.914C363.827 310.914 356.018 315.461 356.018 321.075C356.018 321.266 356.044 321.443 356.069 321.621C356.552 316.261 364.144 312.006 373.464 312.006Z",
    fill: "url(#paint78_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88 312.59C382.199 312.59 389.792 316.858 390.287 322.205C390.299 322.027 390.337 321.85 390.337 321.659C390.337 316.045 382.529 311.498 372.892 311.498C363.255 311.498 355.447 316.045 355.447 321.659C355.447 321.85 355.472 322.027 355.498 322.205C355.968 316.845 363.56 312.59 372.88 312.59Z",
    fill: "url(#paint79_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.144 308.564C390.388 310.355 393.93 313.911 393.042 316.502C392.153 319.094 387.189 319.754 381.945 317.976C376.701 316.185 373.159 312.629 374.047 310.038C374.924 307.434 379.901 306.773 385.144 308.564Z",
    fill: "url(#paint80_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.225 318.471C373.794 318.548 373.349 318.662 372.88 318.776C372.473 318.878 372.054 319.005 371.584 319.157C371.127 319.31 370.683 319.475 370.277 319.653L371.673 320.465C371.813 320.415 371.965 320.351 372.13 320.3C372.296 320.249 372.473 320.186 372.638 320.122C373.438 319.843 374.187 319.602 374.886 319.424C375.584 319.233 376.244 319.106 376.866 319.043C377.488 318.979 378.072 318.992 378.631 319.094C379.19 319.195 379.736 319.386 380.244 319.691C380.853 320.046 381.247 320.427 381.412 320.821C381.577 321.227 381.577 321.634 381.412 322.04C381.247 322.447 380.955 322.866 380.536 323.272C380.117 323.679 379.621 324.06 379.05 324.428L380.942 325.521L379.368 326.422L377.45 325.317C376.485 325.8 375.457 326.232 374.34 326.626C373.235 327.007 372.156 327.311 371.127 327.527L370.112 325.038C370.645 324.936 371.191 324.809 371.75 324.67C372.219 324.555 372.753 324.403 373.337 324.212C373.921 324.022 374.467 323.819 374.987 323.577L373.616 322.79C373.133 322.98 372.626 323.158 372.105 323.323C371.331 323.577 370.62 323.78 369.985 323.933C369.35 324.073 368.766 324.161 368.233 324.187C367.699 324.212 367.217 324.174 366.76 324.073C366.315 323.971 365.884 323.806 365.477 323.565C364.919 323.234 364.538 322.891 364.347 322.498C364.157 322.117 364.093 321.71 364.195 321.304C364.284 320.885 364.512 320.478 364.868 320.046C365.223 319.627 365.681 319.221 366.239 318.84L364.665 317.925L366.226 317.023L367.814 317.938C368.283 317.709 368.766 317.506 369.261 317.316C369.743 317.125 370.239 316.96 370.721 316.807C371.204 316.655 371.661 316.515 372.118 316.401C372.562 316.287 372.981 316.172 373.349 316.071L374.225 318.471ZM368.956 320.973C369.109 321.062 369.299 321.1 369.528 321.075C369.756 321.062 370.048 320.999 370.391 320.897L369.21 320.211C368.74 320.542 368.664 320.796 368.956 320.973ZM376.46 322.218C376.32 322.129 376.104 322.104 375.838 322.129C375.571 322.155 375.266 322.218 374.924 322.32L376.079 322.98C376.371 322.79 376.536 322.625 376.587 322.51C376.638 322.396 376.587 322.294 376.46 322.218Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.225 317.887C373.794 317.963 373.349 318.077 372.88 318.192C372.473 318.293 372.054 318.42 371.584 318.573C371.127 318.725 370.683 318.89 370.277 319.068L371.673 319.881C371.813 319.83 371.965 319.767 372.13 319.716C372.296 319.665 372.473 319.602 372.638 319.538C373.438 319.259 374.187 319.017 374.886 318.839C375.584 318.649 376.244 318.522 376.866 318.458C377.488 318.395 378.072 318.408 378.631 318.509C379.19 318.611 379.736 318.801 380.244 319.106C380.853 319.462 381.247 319.843 381.412 320.237C381.577 320.643 381.577 321.049 381.412 321.456C381.247 321.862 380.955 322.281 380.536 322.688C380.117 323.094 379.621 323.475 379.05 323.844L380.942 324.936L379.368 325.838L377.45 324.733C376.485 325.215 375.457 325.647 374.34 326.041C373.235 326.422 372.156 326.727 371.127 326.943L370.112 324.453C370.645 324.352 371.191 324.225 371.75 324.085C372.219 323.971 372.753 323.818 373.337 323.628C373.921 323.437 374.467 323.234 374.987 322.993L373.616 322.205C373.133 322.396 372.626 322.574 372.105 322.739C371.331 322.993 370.62 323.196 369.985 323.348C369.35 323.488 368.766 323.577 368.233 323.602C367.699 323.628 367.217 323.59 366.76 323.488C366.315 323.387 365.884 323.221 365.477 322.98C364.919 322.65 364.538 322.307 364.347 321.913C364.157 321.532 364.093 321.126 364.195 320.719C364.284 320.3 364.512 319.894 364.868 319.462C365.223 319.043 365.681 318.636 366.239 318.255L364.665 317.341L366.226 316.439L367.814 317.353C368.283 317.125 368.766 316.922 369.261 316.731C369.743 316.541 370.239 316.375 370.721 316.223C371.204 316.071 371.661 315.931 372.118 315.817C372.562 315.702 372.981 315.588 373.349 315.486L374.225 317.887ZM368.956 320.389C369.109 320.478 369.299 320.516 369.528 320.491C369.756 320.478 370.048 320.414 370.391 320.313L369.21 319.627C368.74 319.957 368.664 320.211 368.956 320.389ZM376.46 321.634C376.32 321.545 376.104 321.519 375.838 321.545C375.571 321.57 375.266 321.634 374.924 321.735L376.079 322.396C376.371 322.205 376.536 322.04 376.587 321.926C376.638 321.812 376.587 321.723 376.46 321.634Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.229 313.747H349.543V320.339H349.556C349.556 320.402 349.543 320.466 349.543 320.529C349.543 328.035 359.993 334.132 372.892 334.132C385.792 334.132 396.242 328.048 396.242 320.529C396.242 320.466 396.229 320.402 396.229 320.339H396.242V313.747H396.229Z",
    fill: "url(#paint81_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 332.671C359.98 332.671 349.53 326.587 349.53 319.068V320.338H349.543C349.543 320.402 349.53 320.465 349.53 320.529C349.53 328.035 359.98 334.132 372.879 334.132C385.767 334.132 396.229 328.048 396.229 320.529C396.229 320.465 396.216 320.402 396.216 320.338H396.229V319.068C396.229 326.575 385.779 332.671 372.879 332.671Z",
    fill: "url(#paint82_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.228 319.652V319.462H396.216C396.216 319.525 396.228 319.589 396.228 319.652Z",
    fill: "url(#paint83_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.028 333.471C380.243 333.433 380.459 333.383 380.688 333.332V316.058H380.028V333.471Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.961 332.773C383.177 332.709 383.405 332.659 383.621 332.595V316.058H382.961V332.773Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.893 331.808C386.122 331.719 386.325 331.617 386.554 331.528V316.058H385.893V331.808Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.095 333.891C377.311 333.865 377.539 333.853 377.755 333.827V316.071H377.095V333.891Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.759 328.492C391.988 328.314 392.204 328.137 392.419 327.946V316.045H391.759V328.492Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.692 325.33C394.934 324.949 395.162 324.568 395.353 324.174V316.058H394.692V325.33Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.826 330.436C389.042 330.322 389.271 330.207 389.487 330.08V316.058H388.826V330.436Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.162 334.081C374.378 334.068 374.606 334.068 374.822 334.055V316.045H374.162V334.081Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.229 334.068C371.445 334.081 371.661 334.081 371.889 334.094V316.058H371.229V334.068Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.376 333.395C365.592 333.433 365.807 333.484 366.036 333.535V316.071H365.376V333.395Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.296 333.853C368.512 333.878 368.728 333.891 368.956 333.916V316.058H368.296V333.853Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.443 332.671C362.659 332.734 362.875 332.798 363.103 332.849V316.045H362.443V332.671Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.711 324.758C350.914 325.114 351.117 325.457 351.371 325.8V316.058H350.711V324.758Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.644 328.213C353.847 328.391 354.076 328.556 354.304 328.721V316.058H353.644V328.213Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51 331.655C359.726 331.744 359.942 331.833 360.17 331.909V316.058H359.51V331.655Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.577 330.245C356.793 330.36 357.009 330.474 357.237 330.588V316.058H356.577V330.245Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 327.438C385.775 327.438 396.229 321.348 396.229 313.835C396.229 306.323 385.775 300.232 372.879 300.232C359.984 300.232 349.53 306.323 349.53 313.835C349.53 321.348 359.984 327.438 372.879 327.438Z",
    fill: "url(#paint84_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88 327.07C360.259 327.07 350 321.227 349.581 313.937C349.569 314.089 349.543 314.254 349.543 314.406C349.543 321.913 359.993 328.009 372.892 328.009C385.792 328.009 396.242 321.926 396.242 314.406C396.242 314.241 396.216 314.089 396.203 313.937C395.759 321.24 385.5 327.07 372.88 327.07Z",
    fill: "url(#paint85_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 323.996C382.514 323.996 390.325 319.447 390.325 313.835C390.325 308.223 382.514 303.674 372.879 303.674C363.245 303.674 355.434 308.223 355.434 313.835C355.434 319.447 363.245 323.996 372.879 323.996Z",
    fill: "url(#paint86_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.464 304.182C382.783 304.182 390.375 308.437 390.871 313.796C390.883 313.619 390.921 313.441 390.921 313.25C390.921 307.636 383.113 303.089 373.464 303.089C363.827 303.089 356.018 307.636 356.018 313.25C356.018 313.441 356.044 313.619 356.069 313.796C356.552 308.449 364.144 304.182 373.464 304.182Z",
    fill: "url(#paint87_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88 304.766C382.199 304.766 389.792 309.034 390.287 314.381C390.299 314.203 390.337 314.025 390.337 313.835C390.337 308.221 382.529 303.674 372.892 303.674C363.255 303.674 355.447 308.221 355.447 313.835C355.447 314.025 355.472 314.203 355.498 314.381C355.968 309.021 363.56 304.766 372.88 304.766Z",
    fill: "url(#paint88_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.144 300.74C390.388 302.531 393.93 306.088 393.042 308.679C392.153 311.282 387.189 311.93 381.945 310.152C376.701 308.361 373.159 304.805 374.047 302.214C374.924 299.61 379.901 298.95 385.144 300.74Z",
    fill: "url(#paint89_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.225 310.647C373.794 310.723 373.349 310.838 372.88 310.952C372.473 311.054 372.054 311.181 371.584 311.333C371.127 311.485 370.683 311.651 370.277 311.828L371.673 312.641C371.813 312.59 371.965 312.527 372.13 312.476C372.296 312.425 372.473 312.362 372.638 312.298C373.438 312.019 374.187 311.778 374.886 311.6C375.584 311.409 376.244 311.282 376.866 311.219C377.488 311.155 378.072 311.168 378.631 311.269C379.19 311.371 379.736 311.562 380.244 311.866C380.853 312.222 381.247 312.603 381.412 312.997C381.577 313.403 381.577 313.81 381.412 314.216C381.247 314.623 380.955 315.042 380.536 315.448C380.117 315.855 379.621 316.236 379.05 316.604L380.942 317.696L379.368 318.598L377.45 317.493C376.485 317.976 375.457 318.408 374.34 318.801C373.235 319.182 372.156 319.487 371.127 319.703L370.112 317.214C370.645 317.112 371.191 316.985 371.75 316.845C372.219 316.731 372.753 316.579 373.337 316.388C373.921 316.198 374.467 315.994 374.987 315.753L373.616 314.966C373.133 315.156 372.626 315.334 372.105 315.499C371.331 315.753 370.62 315.956 369.985 316.109C369.35 316.248 368.766 316.337 368.233 316.363C367.699 316.388 367.217 316.35 366.76 316.248C366.315 316.147 365.884 315.982 365.477 315.74C364.919 315.41 364.538 315.067 364.347 314.673C364.157 314.292 364.093 313.886 364.195 313.479C364.284 313.06 364.512 312.654 364.868 312.222C365.223 311.803 365.681 311.396 366.239 311.015L364.665 310.101L366.226 309.199L367.814 310.114C368.283 309.885 368.766 309.682 369.261 309.491C369.743 309.301 370.239 309.136 370.721 308.983C371.204 308.831 371.661 308.691 372.118 308.577C372.562 308.462 372.981 308.348 373.349 308.247L374.225 310.647ZM368.956 313.149C369.109 313.238 369.299 313.276 369.528 313.251C369.756 313.238 370.048 313.175 370.391 313.073L369.21 312.387C368.74 312.717 368.664 312.971 368.956 313.149ZM376.46 314.407C376.32 314.318 376.104 314.292 375.838 314.318C375.571 314.343 375.266 314.407 374.924 314.508L376.079 315.169C376.371 314.978 376.536 314.813 376.587 314.699C376.638 314.585 376.587 314.483 376.46 314.407Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.225 310.063C373.794 310.139 373.349 310.254 372.88 310.368C372.473 310.47 372.054 310.597 371.584 310.749C371.127 310.901 370.683 311.067 370.277 311.244L371.673 312.057C371.813 312.006 371.965 311.943 372.13 311.892C372.296 311.841 372.473 311.778 372.638 311.714C373.438 311.435 374.187 311.194 374.886 311.016C375.584 310.825 376.244 310.698 376.866 310.635C377.488 310.571 378.072 310.584 378.631 310.685C379.19 310.787 379.736 310.978 380.244 311.282C380.853 311.638 381.247 312.019 381.412 312.426C381.577 312.832 381.577 313.238 381.412 313.645C381.247 314.051 380.955 314.47 380.536 314.877C380.117 315.283 379.621 315.664 379.05 316.033L380.942 317.125L379.368 318.027L377.45 316.922C376.485 317.404 375.457 317.836 374.34 318.23C373.235 318.611 372.156 318.916 371.127 319.132L370.112 316.642C370.645 316.541 371.191 316.414 371.75 316.274C372.219 316.16 372.753 316.007 373.337 315.817C373.921 315.626 374.467 315.423 374.987 315.182L373.616 314.394C373.133 314.585 372.626 314.763 372.105 314.928C371.331 315.182 370.62 315.385 369.985 315.537C369.35 315.677 368.766 315.766 368.233 315.791C367.699 315.817 367.217 315.779 366.76 315.677C366.315 315.575 365.884 315.41 365.477 315.169C364.919 314.839 364.538 314.496 364.347 314.102C364.157 313.721 364.093 313.315 364.195 312.908C364.284 312.489 364.512 312.083 364.868 311.651C365.223 311.232 365.681 310.825 366.239 310.444L364.665 309.53L366.226 308.628L367.814 309.542C368.283 309.314 368.766 309.111 369.261 308.92C369.743 308.729 370.239 308.564 370.721 308.412C371.204 308.26 371.661 308.12 372.118 308.006C372.562 307.891 372.981 307.777 373.349 307.675L374.225 310.063ZM368.956 312.565C369.109 312.654 369.299 312.692 369.528 312.667C369.756 312.654 370.048 312.591 370.391 312.489L369.21 311.803C368.74 312.146 368.664 312.4 368.956 312.565ZM376.46 313.823C376.32 313.734 376.104 313.708 375.838 313.734C375.571 313.759 375.266 313.823 374.924 313.924L376.079 314.585C376.371 314.394 376.536 314.229 376.587 314.115C376.638 314 376.587 313.899 376.46 313.823Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.229 305.897H349.543V312.489H349.556C349.556 312.553 349.543 312.616 349.543 312.68C349.543 320.186 359.993 326.283 372.892 326.283C385.792 326.283 396.242 320.199 396.242 312.68C396.242 312.616 396.229 312.553 396.229 312.489H396.242V305.897H396.229Z",
    fill: "url(#paint90_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 324.822C359.98 324.822 349.53 318.738 349.53 311.219V312.489H349.543C349.543 312.552 349.53 312.616 349.53 312.679C349.53 320.186 359.98 326.282 372.879 326.282C385.767 326.282 396.229 320.199 396.229 312.679C396.229 312.616 396.216 312.552 396.216 312.489H396.229V311.219C396.229 318.725 385.779 324.822 372.879 324.822Z",
    fill: "url(#paint91_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.228 311.803V311.612H396.216C396.216 311.676 396.228 311.739 396.228 311.803Z",
    fill: "url(#paint92_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.028 325.622C380.243 325.584 380.459 325.533 380.688 325.483V308.209H380.028V325.622Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.961 324.924C383.177 324.86 383.405 324.809 383.621 324.746V308.209H382.961V324.924Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.893 323.959C386.122 323.87 386.325 323.768 386.554 323.679V308.209H385.893V323.959Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.095 326.041C377.311 326.016 377.539 326.003 377.755 325.978V308.221H377.095V326.041Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.759 320.643C391.988 320.465 392.204 320.287 392.419 320.097V308.196H391.759V320.643Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.692 317.481C394.934 317.1 395.162 316.719 395.353 316.325V308.209H394.692V317.481Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.826 322.587C389.042 322.472 389.271 322.358 389.487 322.231V308.209H388.826V322.587Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.162 326.232C374.378 326.219 374.606 326.219 374.822 326.206V308.196H374.162V326.232Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.229 326.219C371.445 326.232 371.661 326.232 371.889 326.245V308.209H371.229V326.219Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.376 325.533C365.592 325.572 365.807 325.622 366.036 325.673V308.209H365.376V325.533Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.296 326.003C368.512 326.029 368.728 326.042 368.956 326.067V308.209H368.296V326.003Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.443 324.822C362.659 324.885 362.875 324.949 363.103 325V308.196H362.443V324.822Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.711 316.909C350.914 317.265 351.117 317.608 351.371 317.951V308.209H350.711V316.909Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.644 320.364C353.847 320.542 354.076 320.707 354.304 320.872V308.209H353.644V320.364Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51 323.806C359.726 323.895 359.942 323.983 360.17 324.06V308.196H359.51V323.806Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.577 322.396C356.793 322.511 357.009 322.625 357.237 322.739V308.209H356.577V322.396Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 319.589C385.775 319.589 396.229 313.499 396.229 305.986C396.229 298.473 385.775 292.383 372.879 292.383C359.984 292.383 349.53 298.473 349.53 305.986C349.53 313.499 359.984 319.589 372.879 319.589Z",
    fill: "url(#paint93_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88 319.22C360.259 319.22 350 313.377 349.581 306.087C349.569 306.239 349.543 306.404 349.543 306.557C349.543 314.063 359.993 320.16 372.892 320.16C385.792 320.16 396.242 314.076 396.242 306.557C396.242 306.392 396.216 306.239 396.203 306.087C395.759 313.39 385.5 319.22 372.88 319.22Z",
    fill: "url(#paint94_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 316.147C382.514 316.147 390.325 311.597 390.325 305.986C390.325 300.374 382.514 295.825 372.879 295.825C363.245 295.825 355.434 300.374 355.434 305.986C355.434 311.597 363.245 316.147 372.879 316.147Z",
    fill: "url(#paint95_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.464 296.333C382.783 296.333 390.375 300.601 390.871 305.948C390.883 305.77 390.921 305.592 390.921 305.402C390.921 299.788 383.113 295.241 373.464 295.241C363.827 295.241 356.018 299.788 356.018 305.402C356.018 305.592 356.044 305.77 356.069 305.948C356.552 300.588 364.144 296.333 373.464 296.333Z",
    fill: "url(#paint96_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88 296.917C382.199 296.917 389.792 301.185 390.287 306.532C390.299 306.354 390.337 306.176 390.337 305.986C390.337 300.372 382.529 295.825 372.892 295.825C363.255 295.825 355.447 300.372 355.447 305.986C355.447 306.176 355.472 306.354 355.498 306.532C355.968 301.172 363.56 296.917 372.88 296.917Z",
    fill: "url(#paint97_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.144 292.891C390.388 294.682 393.93 298.238 393.042 300.829C392.153 303.433 387.189 304.081 381.945 302.302C376.701 300.512 373.159 296.955 374.047 294.364C374.924 291.76 379.901 291.1 385.144 292.891Z",
    fill: "url(#paint98_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.225 302.798C373.794 302.874 373.349 302.989 372.88 303.103C372.473 303.204 372.054 303.331 371.584 303.484C371.127 303.636 370.683 303.801 370.277 303.979L371.673 304.792C371.813 304.741 371.965 304.678 372.13 304.627C372.296 304.576 372.473 304.513 372.638 304.449C373.438 304.17 374.187 303.928 374.886 303.751C375.584 303.56 376.244 303.433 376.866 303.37C377.488 303.306 378.072 303.319 378.631 303.42C379.19 303.522 379.736 303.712 380.244 304.017C380.853 304.373 381.247 304.754 381.412 305.148C381.577 305.554 381.577 305.961 381.412 306.367C381.247 306.773 380.955 307.193 380.536 307.599C380.117 308.005 379.621 308.387 379.05 308.755L380.942 309.847L379.368 310.749L377.45 309.644C376.485 310.127 375.457 310.558 374.34 310.952C373.235 311.333 372.156 311.638 371.127 311.854L370.112 309.365C370.645 309.263 371.191 309.136 371.75 308.996C372.219 308.882 372.753 308.729 373.337 308.539C373.921 308.348 374.467 308.145 374.987 307.904L373.616 307.116C373.133 307.307 372.626 307.485 372.105 307.65C371.331 307.904 370.62 308.107 369.985 308.26C369.35 308.399 368.766 308.488 368.233 308.514C367.699 308.539 367.217 308.501 366.76 308.399C366.315 308.298 365.884 308.133 365.477 307.891C364.919 307.561 364.538 307.218 364.347 306.824C364.157 306.443 364.093 306.037 364.195 305.63C364.284 305.211 364.512 304.805 364.868 304.373C365.223 303.954 365.681 303.547 366.239 303.166L364.665 302.252L366.226 301.35L367.814 302.265C368.283 302.036 368.766 301.833 369.261 301.642C369.743 301.452 370.239 301.287 370.721 301.134C371.204 300.982 371.661 300.842 372.118 300.728C372.562 300.613 372.981 300.499 373.349 300.397L374.225 302.798ZM368.956 305.3C369.109 305.389 369.299 305.427 369.528 305.402C369.756 305.389 370.048 305.326 370.391 305.224L369.21 304.538C368.74 304.868 368.664 305.122 368.956 305.3ZM376.46 306.545C376.32 306.456 376.104 306.431 375.838 306.456C375.571 306.481 375.266 306.545 374.924 306.646L376.079 307.307C376.371 307.116 376.536 306.951 376.587 306.837C376.638 306.723 376.587 306.634 376.46 306.545Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.225 302.214C373.794 302.29 373.349 302.404 372.88 302.518C372.473 302.62 372.054 302.747 371.584 302.899C371.127 303.052 370.683 303.217 370.277 303.395L371.673 304.208C371.813 304.157 371.965 304.093 372.13 304.043C372.296 303.992 372.473 303.928 372.638 303.865C373.438 303.585 374.187 303.344 374.886 303.166C375.584 302.976 376.244 302.849 376.866 302.785C377.488 302.722 378.072 302.734 378.631 302.836C379.19 302.937 379.736 303.128 380.244 303.433C380.853 303.788 381.247 304.169 381.412 304.563C381.577 304.97 381.577 305.376 381.412 305.783C381.247 306.189 380.955 306.608 380.536 307.015C380.117 307.421 379.621 307.802 379.05 308.17L380.942 309.263L379.368 310.164L377.45 309.059C376.485 309.542 375.457 309.974 374.34 310.368C373.235 310.761 372.156 311.054 371.127 311.27L370.112 308.78C370.645 308.678 371.191 308.551 371.75 308.412C372.219 308.297 372.753 308.145 373.337 307.954C373.921 307.764 374.467 307.561 374.987 307.319L373.616 306.532C373.133 306.722 372.626 306.9 372.105 307.065C371.331 307.319 370.62 307.523 369.985 307.675C369.35 307.815 368.766 307.904 368.233 307.929C367.699 307.954 367.217 307.916 366.76 307.815C366.315 307.713 365.884 307.548 365.477 307.307C364.919 306.976 364.538 306.634 364.347 306.24C364.157 305.859 364.093 305.452 364.195 305.046C364.284 304.627 364.512 304.22 364.868 303.788C365.223 303.369 365.681 302.963 366.239 302.582L364.665 301.667L366.226 300.766L367.814 301.68C368.283 301.451 368.766 301.248 369.261 301.058C369.743 300.867 370.239 300.702 370.721 300.55C371.204 300.397 371.661 300.258 372.118 300.143C372.562 300.029 372.981 299.915 373.349 299.813L374.225 302.214ZM368.956 304.716C369.109 304.805 369.299 304.843 369.528 304.817C369.756 304.805 370.048 304.741 370.391 304.639L369.21 303.954C368.74 304.297 368.664 304.538 368.956 304.716ZM376.46 305.973C376.32 305.884 376.104 305.859 375.838 305.884C375.571 305.91 375.266 305.973 374.924 306.075L376.079 306.735C376.371 306.545 376.536 306.38 376.587 306.265C376.638 306.151 376.587 306.049 376.46 305.973Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.229 298.39H349.543V304.982H349.556C349.556 305.046 349.543 305.109 349.543 305.173C349.543 312.679 359.993 318.776 372.892 318.776C385.792 318.776 396.242 312.692 396.242 305.173C396.242 305.109 396.229 305.046 396.229 304.982H396.242V298.39H396.229Z",
    fill: "url(#paint99_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 317.315C359.98 317.315 349.53 311.231 349.53 303.712V304.982H349.543C349.543 305.046 349.53 305.109 349.53 305.173C349.53 312.679 359.98 318.776 372.879 318.776C385.767 318.776 396.229 312.692 396.229 305.173C396.229 305.109 396.216 305.046 396.216 304.982H396.229V303.712C396.229 311.231 385.779 317.315 372.879 317.315Z",
    fill: "url(#paint100_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.228 304.296V304.105H396.216C396.216 304.169 396.228 304.232 396.228 304.296Z",
    fill: "url(#paint101_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.028 318.116C380.243 318.077 380.459 318.027 380.688 317.976V300.702H380.028V318.116Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.961 317.417C383.177 317.353 383.405 317.303 383.621 317.239V300.702H382.961V317.417Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.893 316.464C386.122 316.375 386.325 316.273 386.554 316.184V300.714H385.893V316.464Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.095 318.534C377.311 318.509 377.539 318.496 377.755 318.471V300.714H377.095V318.534Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.759 313.149C391.988 312.972 392.204 312.794 392.419 312.603V300.702H391.759V313.149Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.692 309.974C394.934 309.593 395.162 309.212 395.353 308.818V300.702H394.692V309.974Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.826 315.08C389.042 314.966 389.271 314.851 389.487 314.724V300.702H388.826V315.08Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.162 318.738C374.378 318.725 374.606 318.725 374.822 318.712V300.702H374.162V318.738Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.229 318.725C371.445 318.737 371.661 318.737 371.889 318.75V300.714H371.229V318.725Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.376 318.039C365.592 318.077 365.807 318.128 366.036 318.179V300.714H365.376V318.039Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.296 318.509C368.512 318.534 368.728 318.547 368.956 318.572V300.714H368.296V318.509Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.443 317.315C362.659 317.379 362.875 317.442 363.103 317.493V300.689H362.443V317.315Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.711 309.403C350.914 309.758 351.117 310.101 351.371 310.444V300.702H350.711V309.403Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.644 312.857C353.847 313.035 354.076 313.2 354.304 313.365V300.702H353.644V312.857Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51 316.299C359.726 316.388 359.942 316.477 360.17 316.553V300.689H359.51V316.299Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.577 314.889C356.793 315.004 357.009 315.118 357.237 315.232V300.702H356.577V314.889Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 312.095C385.775 312.095 396.229 306.005 396.229 298.492C396.229 290.979 385.775 284.889 372.879 284.889C359.984 284.889 349.53 290.979 349.53 298.492C349.53 306.005 359.984 312.095 372.879 312.095Z",
    fill: "url(#paint102_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88 311.726C360.259 311.726 350 305.884 349.581 298.593C349.569 298.746 349.543 298.911 349.543 299.063C349.543 306.57 359.993 312.666 372.892 312.666C385.792 312.666 396.242 306.582 396.242 299.063C396.242 298.898 396.216 298.746 396.203 298.593C395.759 305.884 385.5 311.726 372.88 311.726Z",
    fill: "url(#paint103_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 308.653C382.514 308.653 390.325 304.104 390.325 298.492C390.325 292.88 382.514 288.331 372.879 288.331C363.245 288.331 355.434 292.88 355.434 298.492C355.434 304.104 363.245 308.653 372.879 308.653Z",
    fill: "url(#paint104_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.464 288.827C382.783 288.827 390.375 293.082 390.871 298.442C390.883 298.264 390.921 298.086 390.921 297.895C390.921 292.281 383.113 287.734 373.464 287.734C363.827 287.734 356.018 292.281 356.018 297.895C356.018 298.086 356.044 298.264 356.069 298.442C356.552 293.094 364.144 288.827 373.464 288.827Z",
    fill: "url(#paint105_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88 289.411C382.199 289.411 389.792 293.678 390.287 299.025C390.299 298.848 390.337 298.67 390.337 298.479C390.337 292.865 382.529 288.318 372.892 288.318C363.255 288.318 355.447 292.865 355.447 298.479C355.447 298.67 355.472 298.848 355.498 299.025C355.968 293.678 363.56 289.411 372.88 289.411Z",
    fill: "url(#paint106_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.144 285.384C390.388 287.175 393.93 290.732 393.042 293.323C392.153 295.926 387.189 296.574 381.945 294.796C376.701 293.005 373.159 289.449 374.047 286.858C374.924 284.254 379.901 283.606 385.144 285.384Z",
    fill: "url(#paint107_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.225 295.291C373.794 295.367 373.349 295.482 372.88 295.596C372.473 295.698 372.054 295.825 371.584 295.977C371.127 296.129 370.683 296.295 370.277 296.472L371.673 297.285C371.813 297.234 371.965 297.171 372.13 297.12C372.296 297.069 372.473 297.006 372.638 296.942C373.438 296.663 374.187 296.422 374.886 296.244C375.584 296.053 376.244 295.926 376.866 295.863C377.488 295.799 378.072 295.812 378.631 295.914C379.19 296.015 379.736 296.206 380.244 296.51C380.853 296.866 381.247 297.247 381.412 297.641C381.577 298.047 381.577 298.454 381.412 298.86C381.247 299.267 380.955 299.686 380.536 300.092C380.117 300.499 379.621 300.88 379.05 301.248L380.942 302.34L379.368 303.242L377.45 302.137C376.485 302.62 375.457 303.052 374.34 303.445C373.235 303.826 372.156 304.131 371.127 304.347L370.112 301.858C370.645 301.756 371.191 301.629 371.75 301.489C372.219 301.375 372.753 301.223 373.337 301.032C373.921 300.842 374.467 300.638 374.987 300.397L373.616 299.61C373.133 299.8 372.626 299.978 372.105 300.143C371.331 300.397 370.62 300.6 369.985 300.753C369.35 300.892 368.766 300.981 368.233 301.007C367.699 301.032 367.217 300.994 366.76 300.892C366.315 300.791 365.884 300.626 365.477 300.384C364.919 300.054 364.538 299.711 364.347 299.317C364.157 298.936 364.093 298.53 364.195 298.124C364.284 297.704 364.512 297.298 364.868 296.866C365.223 296.447 365.681 296.041 366.239 295.659L364.665 294.745L366.226 293.843L367.814 294.758C368.283 294.529 368.766 294.326 369.261 294.135C369.743 293.945 370.239 293.78 370.721 293.627C371.204 293.475 371.661 293.335 372.118 293.221C372.562 293.107 372.981 292.992 373.349 292.891L374.225 295.291ZM368.956 297.793C369.109 297.882 369.299 297.92 369.528 297.895C369.756 297.882 370.048 297.819 370.391 297.717L369.21 297.031C368.74 297.374 368.664 297.628 368.956 297.793ZM376.46 299.051C376.32 298.962 376.104 298.936 375.838 298.962C375.571 298.987 375.266 299.051 374.924 299.152L376.079 299.813C376.371 299.622 376.536 299.457 376.587 299.343C376.638 299.229 376.587 299.127 376.46 299.051Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.225 294.707C373.794 294.783 373.349 294.898 372.88 295.012C372.473 295.114 372.054 295.241 371.584 295.393C371.127 295.545 370.683 295.711 370.277 295.888L371.673 296.701C371.813 296.65 371.965 296.587 372.13 296.536C372.296 296.485 372.473 296.422 372.638 296.358C373.438 296.079 374.187 295.838 374.886 295.66C375.584 295.469 376.244 295.342 376.866 295.279C377.488 295.215 378.072 295.228 378.631 295.33C379.19 295.431 379.736 295.622 380.244 295.927C380.853 296.282 381.247 296.663 381.412 297.057C381.577 297.463 381.577 297.87 381.412 298.276C381.247 298.683 380.955 299.102 380.536 299.508C380.117 299.915 379.621 300.296 379.05 300.664L380.942 301.756L379.368 302.658L377.45 301.553C376.485 302.036 375.457 302.468 374.34 302.861C373.235 303.255 372.156 303.547 371.127 303.763L370.112 301.274C370.645 301.172 371.191 301.045 371.75 300.905C372.219 300.791 372.753 300.639 373.337 300.448C373.921 300.258 374.467 300.054 374.987 299.813L373.616 299.026C373.133 299.216 372.626 299.394 372.105 299.559C371.331 299.813 370.62 300.016 369.985 300.169C369.35 300.308 368.766 300.397 368.233 300.423C367.699 300.448 367.217 300.41 366.76 300.308C366.315 300.207 365.884 300.042 365.477 299.8C364.919 299.47 364.538 299.127 364.347 298.733C364.157 298.352 364.093 297.946 364.195 297.54C364.284 297.12 364.512 296.714 364.868 296.282C365.223 295.863 365.681 295.457 366.239 295.076L364.665 294.161L366.226 293.259L367.814 294.174C368.283 293.945 368.766 293.742 369.261 293.551C369.743 293.361 370.239 293.196 370.721 293.043C371.204 292.891 371.661 292.751 372.118 292.637C372.562 292.523 372.981 292.408 373.349 292.307L374.225 294.707ZM368.956 297.222C369.109 297.311 369.299 297.349 369.528 297.324C369.756 297.311 370.048 297.247 370.391 297.146L369.21 296.46C368.74 296.79 368.664 297.044 368.956 297.222ZM376.46 298.467C376.32 298.378 376.104 298.352 375.838 298.378C375.571 298.403 375.266 298.467 374.924 298.568L376.079 299.229C376.371 299.038 376.536 298.873 376.587 298.759C376.638 298.645 376.587 298.543 376.46 298.467Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.229 290.96H349.543V297.552H349.556C349.556 297.615 349.543 297.679 349.543 297.742C349.543 305.249 359.993 311.345 372.892 311.345C385.792 311.345 396.242 305.262 396.242 297.742C396.242 297.679 396.229 297.615 396.229 297.552H396.242V290.96H396.229Z",
    fill: "url(#paint108_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 309.885C359.98 309.885 349.53 303.801 349.53 296.282V297.552H349.543C349.543 297.615 349.53 297.679 349.53 297.742C349.53 305.249 359.98 311.345 372.879 311.345C385.767 311.345 396.229 305.262 396.229 297.742C396.229 297.679 396.216 297.615 396.216 297.552H396.229V296.282C396.229 303.788 385.779 309.885 372.879 309.885Z",
    fill: "url(#paint109_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.228 296.866V296.676H396.216C396.216 296.739 396.228 296.803 396.228 296.866Z",
    fill: "url(#paint110_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.028 310.685C380.243 310.647 380.459 310.596 380.688 310.546V293.272H380.028V310.685Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.961 309.987C383.177 309.923 383.405 309.872 383.621 309.809V293.272H382.961V309.987Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.893 309.034C386.122 308.945 386.325 308.844 386.554 308.755V293.272H385.893V309.034Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.095 311.105C377.311 311.079 377.539 311.066 377.755 311.041V293.272H377.095V311.105Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.759 305.719C391.988 305.541 392.204 305.364 392.419 305.173V293.272H391.759V305.719Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.692 302.544C394.934 302.163 395.162 301.782 395.353 301.388V293.272H394.692V302.544Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.826 307.65C389.042 307.535 389.271 307.421 389.487 307.294V293.272H388.826V307.65Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.162 311.295C374.378 311.282 374.606 311.282 374.822 311.27V293.272H374.162V311.295Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.229 311.295C371.445 311.308 371.661 311.308 371.889 311.308V293.272H371.229V311.295Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.376 310.609C365.592 310.647 365.807 310.698 366.036 310.749V293.272H365.376V310.609Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.296 311.066C368.512 311.092 368.728 311.105 368.956 311.13V293.272H368.296V311.066Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.443 309.885C362.659 309.949 362.875 310.012 363.103 310.063V293.272H362.443V309.885Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.711 301.972C350.914 302.328 351.117 302.671 351.371 303.014V293.272H350.711V301.972Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.644 305.427C353.847 305.605 354.076 305.77 354.304 305.935V293.272H353.644V305.427Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51 308.869C359.726 308.958 359.942 309.047 360.17 309.123V293.272H359.51V308.869Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.577 307.459C356.793 307.574 357.009 307.688 357.237 307.802V293.272H356.577V307.459Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 304.652C385.775 304.652 396.229 298.562 396.229 291.049C396.229 283.536 385.775 277.446 372.879 277.446C359.984 277.446 349.53 283.536 349.53 291.049C349.53 298.562 359.984 304.652 372.879 304.652Z",
    fill: "url(#paint111_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88 304.296C360.259 304.296 350 298.454 349.581 291.163C349.569 291.316 349.543 291.481 349.543 291.633C349.543 299.139 359.993 305.236 372.892 305.236C385.792 305.236 396.242 299.152 396.242 291.633C396.242 291.468 396.216 291.316 396.203 291.163C395.759 298.454 385.5 304.296 372.88 304.296Z",
    fill: "url(#paint112_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 301.21C382.514 301.21 390.325 296.66 390.325 291.049C390.325 285.437 382.514 280.888 372.879 280.888C363.245 280.888 355.434 285.437 355.434 291.049C355.434 296.66 363.245 301.21 372.879 301.21Z",
    fill: "url(#paint113_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.464 281.396C382.783 281.396 390.375 285.663 390.871 291.01C390.883 290.833 390.921 290.655 390.921 290.464C390.921 284.85 383.113 280.303 373.464 280.303C363.827 280.303 356.018 284.85 356.018 290.464C356.018 290.655 356.044 290.833 356.069 291.01C356.552 285.663 364.144 281.396 373.464 281.396Z",
    fill: "url(#paint114_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88 281.98C382.199 281.98 389.792 286.248 390.287 291.595C390.299 291.417 390.337 291.239 390.337 291.049C390.337 285.435 382.529 280.888 372.892 280.888C363.255 280.888 355.447 285.435 355.447 291.049C355.447 291.239 355.472 291.417 355.498 291.595C355.968 286.235 363.56 281.98 372.88 281.98Z",
    fill: "url(#paint115_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.144 277.954C390.388 279.745 393.93 283.301 393.042 285.892C392.153 288.483 387.189 289.144 381.945 287.365C376.701 285.575 373.159 282.018 374.047 279.427C374.924 276.823 379.901 276.163 385.144 277.954Z",
    fill: "url(#paint116_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.225 287.861C373.794 287.937 373.349 288.052 372.88 288.166C372.473 288.267 372.054 288.394 371.584 288.547C371.127 288.699 370.683 288.864 370.277 289.042L371.673 289.855C371.813 289.804 371.965 289.741 372.13 289.69C372.296 289.639 372.473 289.576 372.638 289.512C373.438 289.233 374.187 288.991 374.886 288.814C375.584 288.623 376.244 288.496 376.866 288.433C377.488 288.369 378.072 288.382 378.631 288.483C379.19 288.585 379.736 288.775 380.244 289.08C380.853 289.436 381.247 289.817 381.412 290.211C381.577 290.617 381.577 291.024 381.412 291.43C381.247 291.836 380.955 292.256 380.536 292.662C380.117 293.068 379.621 293.45 379.05 293.818L380.942 294.91L379.368 295.812L377.45 294.707C376.485 295.19 375.457 295.621 374.34 296.015C373.235 296.396 372.156 296.701 371.127 296.917L370.112 294.428C370.645 294.326 371.191 294.199 371.75 294.059C372.219 293.945 372.753 293.792 373.337 293.602C373.921 293.411 374.467 293.208 374.987 292.967L373.616 292.179C373.133 292.37 372.626 292.548 372.105 292.713C371.331 292.967 370.62 293.17 369.985 293.323C369.35 293.462 368.766 293.551 368.233 293.577C367.699 293.602 367.217 293.564 366.76 293.462C366.315 293.361 365.884 293.195 365.477 292.954C364.919 292.624 364.538 292.281 364.347 291.887C364.157 291.506 364.093 291.1 364.195 290.693C364.284 290.274 364.512 289.868 364.868 289.436C365.223 289.017 365.681 288.61 366.239 288.229L364.665 287.315L366.226 286.413L367.814 287.328C368.283 287.099 368.766 286.896 369.261 286.705C369.743 286.515 370.239 286.35 370.721 286.197C371.204 286.045 371.661 285.905 372.118 285.791C372.562 285.676 372.981 285.562 373.349 285.46L374.225 287.861ZM368.956 290.363C369.109 290.452 369.299 290.49 369.528 290.465C369.756 290.452 370.048 290.389 370.391 290.287L369.21 289.601C368.74 289.944 368.664 290.185 368.956 290.363ZM376.46 291.621C376.32 291.532 376.104 291.506 375.838 291.532C375.571 291.557 375.266 291.621 374.924 291.722L376.079 292.383C376.371 292.192 376.536 292.027 376.587 291.913C376.638 291.798 376.587 291.697 376.46 291.621Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.225 287.277C373.794 287.353 373.349 287.467 372.88 287.581C372.473 287.683 372.054 287.81 371.584 287.962C371.127 288.115 370.683 288.28 370.277 288.458L371.673 289.271C371.813 289.22 371.965 289.156 372.13 289.105C372.296 289.055 372.473 288.991 372.638 288.928C373.438 288.648 374.187 288.407 374.886 288.229C375.584 288.039 376.244 287.912 376.866 287.848C377.488 287.785 378.072 287.797 378.631 287.899C379.19 288 379.736 288.191 380.244 288.496C380.853 288.851 381.247 289.233 381.412 289.626C381.577 290.033 381.577 290.439 381.412 290.846C381.247 291.252 380.955 291.671 380.536 292.078C380.117 292.484 379.621 292.865 379.05 293.233L380.942 294.326L379.368 295.227L377.45 294.122C376.485 294.605 375.457 295.037 374.34 295.431C373.235 295.812 372.156 296.117 371.127 296.332L370.112 293.843C370.645 293.741 371.191 293.614 371.75 293.475C372.219 293.36 372.753 293.208 373.337 293.017C373.921 292.827 374.467 292.624 374.987 292.382L373.616 291.595C373.133 291.785 372.626 291.963 372.105 292.128C371.331 292.382 370.62 292.586 369.985 292.738C369.35 292.878 368.766 292.967 368.233 292.992C367.699 293.017 367.217 292.979 366.76 292.878C366.315 292.776 365.884 292.611 365.477 292.37C364.919 292.039 364.538 291.697 364.347 291.303C364.157 290.922 364.093 290.515 364.195 290.109C364.284 289.69 364.512 289.283 364.868 288.851C365.223 288.432 365.681 288.026 366.239 287.645L364.665 286.73L366.226 285.829L367.814 286.743C368.283 286.514 368.766 286.311 369.261 286.121C369.743 285.93 370.239 285.765 370.721 285.613C371.204 285.46 371.661 285.321 372.118 285.206C372.562 285.092 372.981 284.978 373.349 284.876L374.225 287.277ZM368.956 289.779C369.109 289.868 369.299 289.906 369.528 289.88C369.756 289.868 370.048 289.804 370.391 289.702L369.21 289.017C368.74 289.36 368.664 289.614 368.956 289.779ZM376.46 291.036C376.32 290.947 376.104 290.922 375.838 290.947C375.571 290.973 375.266 291.036 374.924 291.138L376.079 291.798C376.371 291.608 376.536 291.443 376.587 291.328C376.638 291.214 376.587 291.112 376.46 291.036Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.229 283.428H349.543V290.02H349.556C349.556 290.084 349.543 290.147 349.543 290.211C349.543 297.717 359.993 303.814 372.892 303.814C385.792 303.814 396.242 297.73 396.242 290.211C396.242 290.147 396.229 290.084 396.229 290.02H396.242V283.428H396.229Z",
    fill: "url(#paint117_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 302.341C359.98 302.341 349.53 296.257 349.53 288.738V290.008H349.543C349.543 290.071 349.53 290.135 349.53 290.198C349.53 297.705 359.98 303.801 372.879 303.801C385.767 303.801 396.229 297.718 396.229 290.198C396.229 290.135 396.216 290.071 396.216 290.008H396.229V288.738C396.229 296.257 385.779 302.341 372.879 302.341Z",
    fill: "url(#paint118_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.228 289.335V289.144H396.216C396.216 289.208 396.228 289.271 396.228 289.335Z",
    fill: "url(#paint119_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.028 303.14C380.243 303.102 380.459 303.052 380.688 303.001V285.727H380.028V303.14Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.961 302.455C383.177 302.392 383.405 302.341 383.621 302.277V285.74H382.961V302.455Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.893 301.49C386.122 301.401 386.325 301.299 386.554 301.21V285.74H385.893V301.49Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.095 303.572C377.311 303.547 377.539 303.534 377.755 303.509V285.752H377.095V303.572Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.759 298.174C391.988 297.996 392.204 297.819 392.419 297.628V285.727H391.759V298.174Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.692 295.012C394.934 294.631 395.162 294.25 395.353 293.856V285.74H394.692V295.012Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.826 300.118C389.042 300.004 389.271 299.889 389.487 299.762V285.74H388.826V300.118Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.162 303.763C374.378 303.75 374.606 303.75 374.822 303.737V285.727H374.162V303.763Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.229 303.75C371.445 303.763 371.661 303.763 371.889 303.763V285.727H371.229V303.75Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.376 303.065C365.592 303.103 365.807 303.154 366.036 303.204V285.74H365.376V303.065Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.296 303.535C368.512 303.56 368.728 303.573 368.956 303.598V285.74H368.296V303.535Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.443 302.353C362.659 302.416 362.875 302.48 363.103 302.531V285.727H362.443V302.353Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.711 294.441C350.914 294.796 351.117 295.139 351.371 295.482V285.74H350.711V294.441Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.644 297.895C353.847 298.073 354.076 298.238 354.304 298.403V285.74H353.644V297.895Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51 301.337C359.726 301.426 359.942 301.515 360.17 301.591V285.727H359.51V301.337Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.577 299.928C356.793 300.042 357.009 300.156 357.237 300.27V285.74H356.577V299.928Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 297.12C385.775 297.12 396.229 291.03 396.229 283.517C396.229 276.004 385.775 269.914 372.879 269.914C359.984 269.914 349.53 276.004 349.53 283.517C349.53 291.03 359.984 297.12 372.879 297.12Z",
    fill: "url(#paint120_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88 296.752C360.259 296.752 350 290.909 349.581 283.619C349.569 283.771 349.543 283.936 349.543 284.089C349.543 291.595 359.993 297.692 372.892 297.692C385.792 297.692 396.242 291.608 396.242 284.089C396.242 283.923 396.216 283.771 396.203 283.619C395.759 290.922 385.5 296.752 372.88 296.752Z",
    fill: "url(#paint121_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.879 293.678C382.514 293.678 390.325 289.129 390.325 283.517C390.325 277.906 382.514 273.356 372.879 273.356C363.245 273.356 355.434 277.906 355.434 283.517C355.434 289.129 363.245 293.678 372.879 293.678Z",
    fill: "url(#paint122_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.464 273.864C382.783 273.864 390.375 278.119 390.871 283.479C390.883 283.301 390.921 283.123 390.921 282.933C390.921 277.319 383.113 272.772 373.464 272.772C363.827 272.772 356.018 277.319 356.018 282.933C356.018 283.123 356.044 283.301 356.069 283.479C356.552 278.119 364.144 273.864 373.464 273.864Z",
    fill: "url(#paint123_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88 274.449C382.199 274.449 389.792 278.716 390.287 284.064C390.299 283.886 390.337 283.708 390.337 283.517C390.337 277.903 382.529 273.356 372.892 273.356C363.255 273.356 355.447 277.903 355.447 283.517C355.447 283.708 355.472 283.886 355.498 284.064C355.968 278.704 363.56 274.449 372.88 274.449Z",
    fill: "url(#paint124_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.144 270.422C390.388 272.213 393.93 275.769 393.042 278.36C392.153 280.964 387.189 281.612 381.945 279.834C376.701 278.043 373.159 274.487 374.047 271.895C374.924 269.292 379.901 268.631 385.144 270.422Z",
    fill: "url(#paint125_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.225 280.329C373.794 280.405 373.349 280.52 372.88 280.634C372.473 280.736 372.054 280.863 371.584 281.015C371.127 281.168 370.683 281.333 370.277 281.51L371.673 282.323C371.813 282.273 371.965 282.209 372.13 282.158C372.296 282.107 372.473 282.044 372.638 281.98C373.438 281.701 374.187 281.46 374.886 281.282C375.584 281.091 376.244 280.964 376.866 280.901C377.488 280.837 378.072 280.85 378.631 280.952C379.19 281.053 379.736 281.244 380.244 281.549C380.853 281.904 381.247 282.285 381.412 282.679C381.577 283.085 381.577 283.492 381.412 283.898C381.247 284.305 380.955 284.724 380.536 285.13C380.117 285.537 379.621 285.918 379.05 286.286L380.942 287.378L379.368 288.28L377.45 287.175C376.485 287.658 375.457 288.09 374.34 288.483C373.235 288.864 372.156 289.169 371.127 289.385L370.112 286.896C370.645 286.794 371.191 286.667 371.75 286.527C372.219 286.413 372.753 286.261 373.337 286.07C373.921 285.88 374.467 285.676 374.987 285.435L373.616 284.648C373.133 284.838 372.626 285.016 372.105 285.181C371.331 285.435 370.62 285.638 369.985 285.791C369.35 285.93 368.766 286.019 368.233 286.045C367.699 286.07 367.217 286.032 366.76 285.93C366.315 285.829 365.884 285.664 365.477 285.422C364.919 285.092 364.538 284.749 364.347 284.356C364.157 283.974 364.093 283.568 364.195 283.162C364.284 282.742 364.512 282.336 364.868 281.904C365.223 281.485 365.681 281.079 366.239 280.698L364.665 279.783L366.226 278.881L367.814 279.796C368.283 279.567 368.766 279.364 369.261 279.173C369.743 278.983 370.239 278.818 370.721 278.665C371.204 278.513 371.661 278.373 372.118 278.259C372.562 278.145 372.981 278.03 373.349 277.929L374.225 280.329ZM368.956 282.831C369.109 282.92 369.299 282.958 369.528 282.933C369.756 282.92 370.048 282.857 370.391 282.755L369.21 282.069C368.74 282.4 368.664 282.654 368.956 282.831ZM376.46 284.076C376.32 283.987 376.104 283.962 375.838 283.987C375.571 284.013 375.266 284.076 374.924 284.178L376.079 284.838C376.371 284.648 376.536 284.483 376.587 284.368C376.638 284.254 376.587 284.152 376.46 284.076Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.225 279.745C373.794 279.821 373.349 279.935 372.88 280.05C372.473 280.151 372.054 280.278 371.584 280.431C371.127 280.583 370.683 280.748 370.277 280.926L371.673 281.739C371.813 281.688 371.965 281.625 372.13 281.574C372.296 281.523 372.473 281.459 372.638 281.396C373.438 281.117 374.187 280.875 374.886 280.697C375.584 280.507 376.244 280.38 376.866 280.316C377.488 280.253 378.072 280.266 378.631 280.367C379.19 280.469 379.736 280.659 380.244 280.964C380.853 281.32 381.247 281.701 381.412 282.107C381.577 282.514 381.577 282.92 381.412 283.327C381.247 283.733 380.955 284.152 380.536 284.559C380.117 284.965 379.621 285.346 379.05 285.714L380.942 286.807L379.368 287.708L377.45 286.603C376.485 287.086 375.457 287.518 374.34 287.912C373.235 288.293 372.156 288.598 371.127 288.813L370.112 286.324C370.645 286.222 371.191 286.095 371.75 285.956C372.219 285.841 372.753 285.689 373.337 285.498C373.921 285.308 374.467 285.105 374.987 284.863L373.616 284.076C373.133 284.266 372.626 284.444 372.105 284.609C371.331 284.863 370.62 285.067 369.985 285.219C369.35 285.359 368.766 285.448 368.233 285.473C367.699 285.498 367.217 285.46 366.76 285.359C366.315 285.257 365.884 285.092 365.477 284.851C364.919 284.52 364.538 284.177 364.347 283.784C364.157 283.403 364.093 282.996 364.195 282.59C364.284 282.171 364.512 281.764 364.868 281.332C365.223 280.913 365.681 280.507 366.239 280.126L364.665 279.211L366.226 278.31L367.814 279.224C368.283 278.995 368.766 278.792 369.261 278.602C369.743 278.411 370.239 278.246 370.721 278.094C371.204 277.941 371.661 277.801 372.118 277.687C372.562 277.573 372.981 277.459 373.349 277.357L374.225 279.745ZM368.956 282.247C369.109 282.336 369.299 282.374 369.528 282.349C369.756 282.336 370.048 282.272 370.391 282.171L369.21 281.485C368.74 281.815 368.664 282.069 368.956 282.247ZM376.46 283.492C376.32 283.403 376.104 283.377 375.838 283.403C375.571 283.428 375.266 283.492 374.924 283.593L376.079 284.254C376.371 284.063 376.536 283.898 376.587 283.784C376.638 283.682 376.587 283.581 376.46 283.492Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.593 323.158H285.907V329.75H285.92C285.92 329.813 285.907 329.877 285.907 329.94C285.907 337.447 296.357 343.543 309.256 343.543C322.156 343.543 332.606 337.459 332.606 329.94C332.606 329.877 332.593 329.813 332.593 329.75H332.606V323.158H332.593Z",
    fill: "url(#paint126_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 342.082C296.357 342.082 285.907 335.998 285.907 328.479V329.749H285.92C285.92 329.813 285.907 329.876 285.907 329.94C285.907 337.446 296.357 343.543 309.256 343.543C322.144 343.543 332.606 337.459 332.606 329.94C332.606 329.876 332.593 329.813 332.593 329.749H332.606V328.479C332.593 335.985 322.144 342.082 309.256 342.082Z",
    fill: "url(#paint127_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.593 329.064V328.873H332.58C332.593 328.937 332.593 329 332.593 329.064Z",
    fill: "url(#paint128_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.404 342.883C316.62 342.845 316.836 342.794 317.065 342.743V325.469H316.404V342.883Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.338 342.184C319.553 342.121 319.782 342.07 319.998 342.006V325.469H319.338V342.184Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27 341.219C322.499 341.13 322.702 341.028 322.93 340.939V325.469H322.27V341.219Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.471 343.301C313.687 343.276 313.916 343.263 314.132 343.238V325.481H313.471V343.301Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.136 337.904C328.365 337.726 328.581 337.548 328.796 337.358V325.457H328.136V337.904Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.069 334.741C331.31 334.36 331.539 333.979 331.729 333.585V325.469H331.069V334.741Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.203 339.847C325.419 339.733 325.648 339.618 325.864 339.491V325.469H325.203V339.847Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.539 343.492C310.754 343.48 310.983 343.48 311.199 343.467V325.457H310.539V343.492Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.606 343.48C307.822 343.492 308.037 343.492 308.266 343.492V325.457H307.606V343.48Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.74 342.794C301.956 342.832 302.172 342.883 302.4 342.933V325.469H301.74V342.794Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.673 343.264C304.888 343.289 305.104 343.302 305.333 343.327V325.469H304.673V343.264Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.807 342.082C299.023 342.146 299.239 342.209 299.467 342.26V325.457H298.807V342.082Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.075 334.17C287.278 334.525 287.481 334.868 287.735 335.211V325.469H287.075V334.17Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.008 337.624C290.211 337.802 290.44 337.967 290.669 338.132V325.469H290.008V337.624Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.874 341.066C296.09 341.155 296.306 341.244 296.534 341.32V325.457H295.874V341.066Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.941 339.657C293.157 339.771 293.373 339.885 293.601 339.999V325.469H292.941V339.657Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 336.849C322.152 336.849 332.606 330.759 332.606 323.246C332.606 315.733 322.152 309.643 309.256 309.643C296.361 309.643 285.907 315.733 285.907 323.246C285.907 330.759 296.361 336.849 309.256 336.849Z",
    fill: "url(#paint129_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 336.481C296.636 336.481 286.377 330.639 285.958 323.348C285.945 323.501 285.92 323.666 285.92 323.818C285.92 331.325 296.369 337.421 309.269 337.421C322.169 337.421 332.618 331.337 332.618 323.818C332.618 323.653 332.593 323.501 332.58 323.348C332.123 330.651 321.877 336.481 309.256 336.481Z",
    fill: "url(#paint130_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 333.407C318.891 333.407 326.701 328.858 326.701 323.246C326.701 317.635 318.891 313.085 309.256 313.085C299.622 313.085 291.811 317.635 291.811 323.246C291.811 328.858 299.622 333.407 309.256 333.407Z",
    fill: "url(#paint131_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.828 313.593C319.147 313.593 326.74 317.848 327.235 323.208C327.248 323.03 327.286 322.852 327.286 322.662C327.286 317.048 319.477 312.501 309.84 312.501C300.204 312.501 292.395 317.048 292.395 322.662C292.395 322.852 292.421 323.03 292.446 323.208C292.916 317.848 300.508 313.593 309.828 313.593Z",
    fill: "url(#paint132_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 314.178C318.576 314.178 326.168 318.433 326.663 323.793C326.676 323.615 326.714 323.437 326.714 323.246C326.714 317.632 318.906 313.085 309.256 313.085C299.619 313.085 291.811 317.632 291.811 323.246C291.811 323.437 291.836 323.615 291.862 323.793C292.332 318.433 299.924 314.178 309.256 314.178Z",
    fill: "url(#paint133_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.509 310.151C326.752 311.942 330.295 315.498 329.406 318.089C328.517 320.693 323.553 321.341 318.309 319.563C313.065 317.772 309.523 314.216 310.412 311.624C311.3 309.021 316.265 308.36 321.509 310.151Z",
    fill: "url(#paint134_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.602 320.058C310.171 320.134 309.726 320.249 309.257 320.363C308.85 320.465 308.431 320.592 307.961 320.744C307.504 320.897 307.06 321.062 306.654 321.239L308.05 322.052C308.19 322.002 308.342 321.938 308.507 321.887C308.672 321.836 308.85 321.773 309.015 321.709C309.815 321.43 310.564 321.189 311.263 321.011C311.961 320.82 312.621 320.693 313.243 320.63C313.865 320.566 314.449 320.579 315.008 320.681C315.567 320.782 316.113 320.973 316.621 321.278C317.23 321.633 317.624 322.014 317.789 322.408C317.954 322.814 317.954 323.221 317.789 323.627C317.624 324.034 317.332 324.453 316.913 324.859C316.494 325.266 315.998 325.647 315.427 326.015L317.319 327.107L315.745 328.009L313.827 326.904C312.862 327.387 311.834 327.819 310.717 328.212C309.612 328.593 308.533 328.898 307.504 329.114L306.489 326.625C307.022 326.523 307.568 326.396 308.127 326.256C308.596 326.142 309.13 325.99 309.714 325.799C310.298 325.609 310.844 325.405 311.364 325.164L309.993 324.377C309.51 324.567 309.003 324.745 308.482 324.91C307.708 325.164 306.996 325.367 306.362 325.52C305.727 325.659 305.143 325.748 304.61 325.774C304.076 325.799 303.594 325.761 303.137 325.659C302.692 325.558 302.261 325.393 301.854 325.151C301.296 324.821 300.915 324.478 300.724 324.085C300.534 323.704 300.47 323.297 300.572 322.891C300.661 322.471 300.889 322.065 301.245 321.633C301.6 321.214 302.057 320.808 302.616 320.427L301.042 319.512L302.616 318.61L304.203 319.525C304.673 319.296 305.155 319.093 305.651 318.902C306.133 318.712 306.628 318.547 307.111 318.394C307.593 318.242 308.05 318.102 308.507 317.988C308.952 317.874 309.371 317.759 309.739 317.658L310.602 320.058ZM305.333 322.56C305.486 322.649 305.676 322.687 305.905 322.662C306.133 322.649 306.425 322.586 306.768 322.484L305.587 321.798C305.117 322.129 305.029 322.383 305.333 322.56ZM312.824 323.805C312.685 323.716 312.469 323.691 312.202 323.716C311.935 323.742 311.631 323.805 311.288 323.907L312.443 324.567C312.735 324.377 312.9 324.212 312.951 324.097C313.002 323.996 312.964 323.894 312.824 323.805Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.602 319.474C310.171 319.55 309.726 319.664 309.257 319.779C308.85 319.88 308.431 320.007 307.961 320.16C307.504 320.312 307.06 320.477 306.654 320.655L308.05 321.468C308.19 321.417 308.342 321.354 308.507 321.303C308.672 321.252 308.85 321.188 309.015 321.125C309.815 320.846 310.564 320.604 311.263 320.426C311.961 320.236 312.621 320.109 313.243 320.045C313.865 319.982 314.449 319.995 315.008 320.096C315.567 320.198 316.113 320.388 316.621 320.693C317.23 321.049 317.624 321.43 317.789 321.824C317.954 322.23 317.954 322.636 317.789 323.043C317.624 323.449 317.332 323.868 316.913 324.275C316.494 324.681 315.998 325.062 315.427 325.431L317.319 326.523L315.745 327.425L313.827 326.32C312.862 326.802 311.834 327.234 310.717 327.628C309.612 328.022 308.533 328.314 307.504 328.53L306.489 326.04C307.022 325.939 307.568 325.812 308.127 325.672C308.596 325.558 309.13 325.405 309.714 325.215C310.298 325.024 310.844 324.821 311.364 324.58L309.993 323.792C309.51 323.983 309.003 324.161 308.482 324.326C307.708 324.58 306.996 324.783 306.362 324.935C305.727 325.075 305.143 325.164 304.61 325.189C304.076 325.215 303.594 325.177 303.137 325.075C302.68 324.973 302.261 324.808 301.854 324.567C301.296 324.237 300.915 323.894 300.724 323.5C300.534 323.119 300.47 322.713 300.572 322.306C300.661 321.887 300.889 321.481 301.245 321.049C301.6 320.63 302.057 320.223 302.616 319.842L301.054 318.928L302.629 318.026L304.216 318.94C304.686 318.712 305.168 318.508 305.663 318.318C306.146 318.127 306.641 317.962 307.123 317.81C307.606 317.658 308.063 317.518 308.52 317.403C308.964 317.289 309.383 317.175 309.752 317.073L310.602 319.474ZM305.333 321.976C305.486 322.065 305.676 322.103 305.905 322.078C306.133 322.065 306.425 322.001 306.768 321.9L305.587 321.214C305.117 321.557 305.029 321.811 305.333 321.976ZM312.824 323.233C312.685 323.144 312.469 323.119 312.202 323.144C311.935 323.17 311.631 323.233 311.288 323.335L312.443 323.995C312.735 323.805 312.9 323.64 312.951 323.525C313.002 323.411 312.964 323.31 312.824 323.233Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.593 315.334H285.907V321.926H285.92C285.92 321.989 285.907 322.053 285.907 322.116C285.907 329.623 296.357 335.719 309.256 335.719C322.156 335.719 332.606 329.636 332.606 322.116C332.606 322.053 332.593 321.989 332.593 321.926H332.606V315.334H332.593Z",
    fill: "url(#paint135_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 334.258C296.357 334.258 285.907 328.174 285.907 320.655V321.925H285.92C285.92 321.989 285.907 322.052 285.907 322.116C285.907 329.622 296.357 335.719 309.256 335.719C322.144 335.719 332.606 329.635 332.606 322.116C332.606 322.052 332.593 321.989 332.593 321.925H332.606V320.655C332.593 328.174 322.144 334.258 309.256 334.258Z",
    fill: "url(#paint136_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.593 321.239V321.049H332.58C332.593 321.112 332.593 321.176 332.593 321.239Z",
    fill: "url(#paint137_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.404 335.059C316.62 335.021 316.836 334.97 317.065 334.919V317.646H316.404V335.059Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.338 334.36C319.553 334.297 319.782 334.246 319.998 334.183V317.646H319.338V334.36Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27 333.407C322.499 333.318 322.702 333.217 322.93 333.128V317.658H322.27V333.407Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.471 335.478C313.687 335.452 313.916 335.439 314.132 335.414V317.658H313.471V335.478Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.136 330.093C328.365 329.915 328.581 329.737 328.796 329.547V317.646H328.136V330.093Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.069 326.917C331.31 326.536 331.539 326.155 331.729 325.762V317.646H331.069V326.917Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.203 332.023C325.419 331.909 325.648 331.795 325.864 331.668V317.646H325.203V332.023Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.539 335.681C310.754 335.669 310.983 335.669 311.199 335.656V317.646H310.539V335.681Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.606 335.668C307.822 335.681 308.037 335.681 308.266 335.693V317.658H307.606V335.668Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.74 334.982C301.956 335.02 302.172 335.071 302.4 335.122V317.658H301.74V334.982Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.673 335.452C304.888 335.478 305.104 335.49 305.333 335.516V317.658H304.673V335.452Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.807 334.259C299.023 334.322 299.239 334.386 299.467 334.437V317.633H298.807V334.259Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.075 326.346C287.278 326.701 287.481 327.044 287.735 327.387V317.646H287.075V326.346Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.008 329.801C290.211 329.978 290.44 330.144 290.669 330.309V317.646H290.008V329.801Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.874 333.243C296.09 333.332 296.306 333.42 296.534 333.497V317.633H295.874V333.243Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.941 331.833C293.157 331.947 293.373 332.061 293.601 332.176V317.646H292.941V331.833Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 329.039C322.152 329.039 332.606 322.948 332.606 315.436C332.606 307.923 322.152 301.833 309.256 301.833C296.361 301.833 285.907 307.923 285.907 315.436C285.907 322.948 296.361 329.039 309.256 329.039Z",
    fill: "url(#paint138_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 328.67C296.636 328.67 286.377 322.828 285.958 315.537C285.945 315.69 285.92 315.855 285.92 316.007C285.92 323.513 296.369 329.61 309.269 329.61C322.169 329.61 332.618 323.526 332.618 316.007C332.618 315.842 332.593 315.69 332.58 315.537C332.123 322.828 321.877 328.67 309.256 328.67Z",
    fill: "url(#paint139_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 325.596C318.891 325.596 326.701 321.047 326.701 315.435C326.701 309.824 318.891 305.274 309.256 305.274C299.622 305.274 291.811 309.824 291.811 315.435C291.811 321.047 299.622 325.596 309.256 325.596Z",
    fill: "url(#paint140_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.828 305.77C319.147 305.77 326.74 310.038 327.235 315.385C327.248 315.207 327.286 315.029 327.286 314.839C327.286 309.225 319.477 304.678 309.84 304.678C300.204 304.678 292.395 309.225 292.395 314.839C292.395 315.029 292.421 315.207 292.446 315.385C292.916 310.038 300.508 305.77 309.828 305.77Z",
    fill: "url(#paint141_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 306.354C318.576 306.354 326.168 310.622 326.663 315.969C326.676 315.791 326.714 315.613 326.714 315.423C326.714 309.809 318.906 305.262 309.256 305.262C299.619 305.262 291.811 309.809 291.811 315.423C291.811 315.613 291.836 315.791 291.862 315.969C292.332 310.622 299.924 306.354 309.256 306.354Z",
    fill: "url(#paint142_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.509 302.328C326.752 304.119 330.295 307.675 329.406 310.266C328.517 312.87 323.553 313.517 318.309 311.739C313.065 309.948 309.523 306.392 310.412 303.801C311.3 301.197 316.265 300.549 321.509 302.328Z",
    fill: "url(#paint143_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.602 312.235C310.171 312.311 309.726 312.425 309.257 312.539C308.85 312.641 308.431 312.768 307.961 312.92C307.504 313.073 307.06 313.238 306.654 313.416L308.05 314.229C308.19 314.178 308.342 314.114 308.507 314.063C308.672 314.013 308.85 313.949 309.015 313.886C309.815 313.606 310.564 313.365 311.263 313.187C311.961 312.997 312.621 312.87 313.243 312.806C313.865 312.743 314.449 312.755 315.008 312.857C315.567 312.958 316.113 313.149 316.621 313.454C317.23 313.809 317.624 314.19 317.789 314.584C317.954 314.991 317.954 315.397 317.789 315.804C317.624 316.21 317.332 316.629 316.913 317.036C316.494 317.442 315.998 317.823 315.427 318.191L317.319 319.284L315.745 320.185L313.827 319.08C312.862 319.563 311.834 319.995 310.717 320.389C309.612 320.782 308.533 321.075 307.504 321.291L306.489 318.801C307.022 318.699 307.568 318.572 308.127 318.433C308.596 318.318 309.13 318.166 309.714 317.975C310.298 317.785 310.844 317.582 311.364 317.34L309.993 316.553C309.51 316.743 309.003 316.921 308.482 317.086C307.708 317.34 306.996 317.544 306.362 317.696C305.727 317.836 305.143 317.925 304.61 317.95C304.076 317.975 303.594 317.937 303.137 317.836C302.68 317.734 302.261 317.569 301.854 317.328C301.296 316.997 300.915 316.655 300.724 316.261C300.534 315.88 300.47 315.473 300.572 315.067C300.661 314.648 300.889 314.241 301.245 313.809C301.6 313.39 302.057 312.984 302.616 312.603L301.054 311.688L302.629 310.787L304.216 311.701C304.686 311.472 305.168 311.269 305.663 311.079C306.146 310.888 306.641 310.723 307.123 310.571C307.606 310.418 308.063 310.279 308.52 310.164C308.964 310.05 309.383 309.936 309.752 309.834L310.602 312.235ZM305.333 314.737C305.486 314.826 305.676 314.864 305.905 314.838C306.133 314.826 306.425 314.762 306.768 314.66L305.587 313.975C305.117 314.318 305.029 314.572 305.333 314.737ZM312.824 315.994C312.685 315.905 312.469 315.88 312.202 315.905C311.935 315.931 311.631 315.994 311.288 316.096L312.443 316.756C312.735 316.566 312.9 316.401 312.951 316.286C313.002 316.172 312.964 316.07 312.824 315.994Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.602 311.651C310.171 311.727 309.726 311.841 309.257 311.955C308.85 312.057 308.431 312.184 307.961 312.336C307.504 312.489 307.06 312.654 306.654 312.832L308.05 313.645C308.19 313.594 308.342 313.53 308.507 313.48C308.672 313.429 308.85 313.365 309.015 313.302C309.815 313.022 310.564 312.781 311.263 312.603C311.961 312.413 312.621 312.286 313.243 312.222C313.865 312.159 314.449 312.171 315.008 312.273C315.567 312.375 316.113 312.565 316.621 312.87C317.23 313.225 317.624 313.607 317.789 314C317.954 314.407 317.954 314.813 317.789 315.22C317.624 315.626 317.332 316.045 316.913 316.452C316.494 316.858 315.998 317.239 315.427 317.607L317.319 318.7L315.745 319.602L313.827 318.496C312.862 318.979 311.834 319.411 310.717 319.805C309.612 320.186 308.533 320.491 307.504 320.707L306.489 318.217C307.022 318.115 307.568 317.988 308.127 317.849C308.596 317.734 309.13 317.582 309.714 317.391C310.298 317.201 310.844 316.998 311.364 316.756L309.993 315.969C309.51 316.159 309.003 316.337 308.482 316.502C307.708 316.756 306.996 316.96 306.362 317.112C305.727 317.252 305.143 317.341 304.61 317.366C304.076 317.391 303.594 317.353 303.137 317.252C302.692 317.15 302.261 316.985 301.854 316.744C301.296 316.414 300.915 316.071 300.724 315.677C300.534 315.296 300.47 314.889 300.572 314.483C300.661 314.064 300.889 313.657 301.245 313.225C301.6 312.806 302.057 312.4 302.616 312.019L301.042 311.104L302.616 310.203L304.203 311.117C304.673 310.888 305.155 310.685 305.651 310.495C306.133 310.304 306.628 310.139 307.111 309.987C307.593 309.834 308.05 309.695 308.507 309.58C308.952 309.466 309.371 309.352 309.739 309.25L310.602 311.651ZM305.333 314.153C305.486 314.242 305.676 314.28 305.905 314.254C306.133 314.242 306.425 314.178 306.768 314.076L305.587 313.391C305.117 313.734 305.029 313.988 305.333 314.153ZM312.824 315.41C312.685 315.321 312.469 315.296 312.202 315.321C311.935 315.347 311.631 315.41 311.288 315.512L312.443 316.172C312.735 315.982 312.9 315.817 312.951 315.702C313.002 315.588 312.964 315.486 312.824 315.41Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.593 307.51H285.907V314.102H285.92C285.92 314.165 285.907 314.229 285.907 314.292C285.907 321.799 296.357 327.895 309.256 327.895C322.156 327.895 332.606 321.811 332.606 314.292C332.606 314.229 332.593 314.165 332.593 314.102H332.606V307.51H332.593Z",
    fill: "url(#paint144_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 326.435C296.357 326.435 285.907 320.351 285.907 312.832V314.102H285.92C285.92 314.166 285.907 314.229 285.907 314.293C285.907 321.799 296.357 327.896 309.256 327.896C322.144 327.896 332.606 321.812 332.606 314.293C332.606 314.229 332.593 314.166 332.593 314.102H332.606V312.832C332.593 320.351 322.144 326.435 309.256 326.435Z",
    fill: "url(#paint145_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.593 313.416V313.226H332.58C332.593 313.289 332.593 313.353 332.593 313.416Z",
    fill: "url(#paint146_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.404 327.235C316.62 327.197 316.836 327.146 317.065 327.095V309.822H316.404V327.235Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.338 326.549C319.553 326.486 319.782 326.435 319.998 326.371V309.834H319.338V326.549Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27 325.584C322.499 325.495 322.702 325.393 322.93 325.305V309.834H322.27V325.584Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.471 327.654C313.687 327.629 313.916 327.616 314.132 327.591V309.834H313.471V327.654Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.136 322.269C328.365 322.091 328.581 321.913 328.796 321.723V309.822H328.136V322.269Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.069 319.106C331.31 318.725 331.539 318.344 331.729 317.951V309.834H331.069V319.106Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.203 324.2C325.419 324.085 325.648 323.971 325.864 323.844V309.822H325.203V324.2Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.539 327.858C310.754 327.845 310.983 327.845 311.199 327.832V309.822H310.539V327.858Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.606 327.845C307.822 327.858 308.037 327.858 308.266 327.858V309.822H307.606V327.845Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.74 327.159C301.956 327.197 302.172 327.248 302.4 327.299V309.834H301.74V327.159Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.673 327.629C304.888 327.654 305.104 327.667 305.333 327.692V309.834H304.673V327.629Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.807 326.448C299.023 326.511 299.239 326.575 299.467 326.626V309.822H298.807V326.448Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.075 318.522C287.278 318.878 287.481 319.221 287.735 319.564V309.822H287.075V318.522Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.008 321.99C290.211 322.167 290.44 322.332 290.669 322.498V309.834H290.008V321.99Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.874 325.432C296.09 325.521 296.306 325.609 296.534 325.686V309.822H295.874V325.432Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.941 324.009C293.157 324.123 293.373 324.238 293.601 324.352V309.822H292.941V324.009Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 321.214C322.152 321.214 332.606 315.124 332.606 307.611C332.606 300.099 322.152 294.008 309.256 294.008C296.361 294.008 285.907 300.099 285.907 307.611C285.907 315.124 296.361 321.214 309.256 321.214Z",
    fill: "url(#paint147_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 320.846C296.636 320.846 286.377 315.003 285.958 307.713C285.945 307.865 285.92 308.03 285.92 308.183C285.92 315.689 296.369 321.786 309.269 321.786C322.169 321.786 332.618 315.702 332.618 308.183C332.618 308.018 332.593 307.865 332.58 307.713C332.123 315.003 321.877 320.846 309.256 320.846Z",
    fill: "url(#paint148_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 317.773C318.891 317.773 326.701 313.223 326.701 307.612C326.701 302 318.891 297.451 309.256 297.451C299.622 297.451 291.811 302 291.811 307.612C291.811 313.223 299.622 317.773 309.256 317.773Z",
    fill: "url(#paint149_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.828 297.959C319.147 297.959 326.74 302.213 327.235 307.573C327.248 307.396 327.286 307.218 327.286 307.027C327.286 301.413 319.477 296.866 309.84 296.866C300.204 296.866 292.395 301.413 292.395 307.027C292.395 307.218 292.421 307.396 292.446 307.573C292.916 302.213 300.508 297.959 309.828 297.959Z",
    fill: "url(#paint150_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 298.531C318.576 298.531 326.168 302.798 326.663 308.146C326.676 307.968 326.714 307.79 326.714 307.599C326.714 301.986 318.906 297.438 309.256 297.438C299.619 297.438 291.811 301.986 291.811 307.599C291.811 307.79 291.836 307.968 291.862 308.146C292.332 302.798 299.924 298.531 309.256 298.531Z",
    fill: "url(#paint151_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.509 294.516C326.752 296.307 330.295 299.864 329.406 302.455C328.517 305.058 323.553 305.706 318.309 303.928C313.065 302.137 309.523 298.581 310.412 295.99C311.3 293.386 316.265 292.725 321.509 294.516Z",
    fill: "url(#paint152_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.602 304.411C310.171 304.487 309.726 304.602 309.257 304.716C308.85 304.818 308.431 304.945 307.961 305.097C307.504 305.25 307.06 305.415 306.654 305.592L308.05 306.405C308.19 306.355 308.342 306.291 308.507 306.24C308.672 306.189 308.85 306.126 309.015 306.062C309.815 305.783 310.564 305.542 311.263 305.364C311.961 305.173 312.621 305.046 313.243 304.983C313.865 304.919 314.449 304.932 315.008 305.034C315.567 305.135 316.113 305.326 316.621 305.631C317.23 305.986 317.624 306.367 317.789 306.761C317.954 307.167 317.954 307.574 317.789 307.98C317.624 308.387 317.332 308.806 316.913 309.212C316.494 309.619 315.998 310 315.427 310.368L317.319 311.46L315.745 312.362L313.827 311.257C312.862 311.74 311.834 312.172 310.717 312.565C309.612 312.959 308.533 313.251 307.504 313.467L306.489 310.978C307.022 310.876 307.568 310.749 308.127 310.609C308.596 310.495 309.13 310.343 309.714 310.152C310.298 309.962 310.844 309.759 311.364 309.517L309.993 308.73C309.51 308.92 309.003 309.098 308.482 309.263C307.708 309.517 306.996 309.72 306.362 309.873C305.727 310.013 305.143 310.101 304.61 310.127C304.076 310.152 303.594 310.114 303.137 310.013C302.692 309.911 302.261 309.746 301.854 309.504C301.296 309.174 300.915 308.831 300.724 308.438C300.534 308.057 300.47 307.65 300.572 307.244C300.661 306.825 300.889 306.418 301.245 305.986C301.6 305.567 302.057 305.161 302.616 304.78L301.042 303.865L302.616 302.963L304.203 303.878C304.673 303.649 305.155 303.446 305.651 303.255C306.133 303.065 306.628 302.9 307.111 302.747C307.593 302.595 308.05 302.455 308.507 302.341C308.952 302.227 309.371 302.112 309.739 302.011L310.602 304.411ZM305.333 306.926C305.486 307.015 305.676 307.053 305.905 307.028C306.133 307.015 306.425 306.952 306.768 306.85L305.587 306.164C305.117 306.494 305.029 306.748 305.333 306.926ZM312.824 308.171C312.685 308.082 312.469 308.057 312.202 308.082C311.935 308.107 311.631 308.171 311.288 308.272L312.443 308.933C312.735 308.742 312.9 308.577 312.951 308.463C313.002 308.349 312.964 308.247 312.824 308.171Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.602 303.839C310.171 303.915 309.726 304.03 309.257 304.144C308.85 304.245 308.431 304.372 307.961 304.525C307.504 304.677 307.06 304.842 306.654 305.02L308.05 305.833C308.19 305.782 308.342 305.719 308.507 305.668C308.672 305.617 308.85 305.554 309.015 305.49C309.815 305.211 310.564 304.969 311.263 304.792C311.961 304.601 312.621 304.474 313.243 304.411C313.865 304.347 314.449 304.36 315.008 304.461C315.567 304.563 316.113 304.753 316.621 305.058C317.23 305.414 317.624 305.795 317.789 306.189C317.954 306.595 317.954 307.002 317.789 307.408C317.624 307.814 317.332 308.234 316.913 308.64C316.494 309.047 315.998 309.428 315.427 309.796L317.319 310.888L315.745 311.79L313.827 310.685C312.862 311.168 311.834 311.599 310.717 311.993C309.612 312.374 308.533 312.679 307.504 312.895L306.489 310.406C307.022 310.304 307.568 310.177 308.127 310.037C308.596 309.923 309.13 309.77 309.714 309.58C310.298 309.389 310.844 309.186 311.364 308.945L309.993 308.157C309.51 308.348 309.003 308.526 308.482 308.691C307.708 308.945 306.996 309.148 306.362 309.301C305.727 309.44 305.143 309.529 304.61 309.555C304.076 309.58 303.594 309.542 303.137 309.44C302.692 309.339 302.261 309.174 301.854 308.932C301.296 308.602 300.915 308.259 300.724 307.865C300.534 307.484 300.47 307.078 300.572 306.671C300.661 306.252 300.889 305.846 301.245 305.414C301.6 304.995 302.057 304.588 302.616 304.207L301.042 303.293L302.616 302.391L304.203 303.306C304.673 303.077 305.155 302.874 305.651 302.683C306.133 302.493 306.628 302.328 307.111 302.175C307.593 302.023 308.05 301.883 308.507 301.769C308.952 301.654 309.371 301.54 309.739 301.438L310.602 303.839ZM305.333 306.341C305.486 306.43 305.676 306.468 305.905 306.443C306.133 306.43 306.425 306.367 306.768 306.265L305.587 305.579C305.117 305.909 305.029 306.163 305.333 306.341ZM312.824 307.586C312.685 307.497 312.469 307.472 312.202 307.497C311.935 307.522 311.631 307.586 311.288 307.687L312.443 308.348C312.735 308.157 312.9 307.992 312.951 307.878C313.002 307.764 312.964 307.662 312.824 307.586Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.471 348.053H316.785V354.645H316.798C316.798 354.708 316.785 354.772 316.785 354.835C316.785 362.342 327.235 368.438 340.135 368.438C353.034 368.438 363.484 362.354 363.484 354.835C363.484 354.772 363.471 354.708 363.471 354.645H363.484V348.053H363.471Z",
    fill: "url(#paint153_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.773 353.768V353.959C316.773 353.895 316.785 353.832 316.773 353.768Z",
    fill: "url(#paint154_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.122 366.978C327.235 366.978 316.773 360.894 316.773 353.375V354.645H316.785C316.785 354.708 316.773 354.772 316.773 354.835C316.773 362.342 327.222 368.438 340.122 368.438C353.009 368.438 363.471 362.354 363.471 354.835C363.471 354.772 363.458 354.708 363.458 354.645H363.471V353.375C363.471 360.881 353.009 366.978 340.122 366.978Z",
    fill: "url(#paint155_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.471 353.959V353.768H363.458C363.458 353.832 363.471 353.895 363.471 353.959Z",
    fill: "url(#paint156_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.27 367.778C347.486 367.74 347.702 367.689 347.93 367.638V350.364H347.27V367.778Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.203 367.079C350.419 367.016 350.648 366.965 350.863 366.901V350.364H350.203V367.079Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.136 366.114C353.365 366.025 353.568 365.923 353.796 365.834V350.364H353.136V366.114Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.337 368.197C344.553 368.171 344.782 368.159 344.998 368.133V350.377H344.337V368.197Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.002 362.798C359.23 362.62 359.446 362.443 359.662 362.252V350.351H359.002V362.798Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.935 359.636C362.176 359.255 362.405 358.874 362.595 358.48V350.364H361.935V359.636Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.069 364.742C356.285 364.628 356.513 364.513 356.729 364.386V350.364H356.069V364.742Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.404 368.387C341.62 368.374 341.848 368.374 342.064 368.361V350.351H341.404V368.387Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.471 368.387C338.687 368.4 338.903 368.4 339.131 368.4V350.364H338.471V368.387Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.605 367.701C332.821 367.74 333.037 367.79 333.266 367.841V350.377H332.605V367.701Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.538 368.159C335.754 368.184 335.97 368.197 336.199 368.222V350.364H335.538V368.159Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.672 366.977C329.888 367.04 330.104 367.104 330.333 367.155V350.351H329.672V366.977Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.941 359.065C318.144 359.42 318.347 359.763 318.601 360.106V350.364H317.941V359.065Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.874 362.519C321.077 362.697 321.305 362.862 321.534 363.027V350.364H320.874V362.519Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.74 365.961C326.956 366.05 327.171 366.139 327.4 366.215V350.351H326.74V365.961Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.807 364.552C324.022 364.666 324.238 364.78 324.467 364.894V350.364H323.807V364.552Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.122 361.745C353.017 361.745 363.471 355.654 363.471 348.142C363.471 340.629 353.017 334.539 340.122 334.539C327.226 334.539 316.773 340.629 316.773 348.142C316.773 355.654 327.226 361.745 340.122 361.745Z",
    fill: "url(#paint157_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.122 361.388C327.501 361.388 317.242 355.546 316.823 348.255C316.811 348.408 316.785 348.573 316.785 348.725C316.785 356.232 327.235 362.328 340.135 362.328C353.022 362.328 363.484 356.244 363.484 348.725C363.484 348.56 363.458 348.408 363.446 348.255C362.989 355.546 352.742 361.388 340.122 361.388Z",
    fill: "url(#paint158_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.122 358.302C349.757 358.302 357.567 353.753 357.567 348.141C357.567 342.529 349.757 337.98 340.122 337.98C330.487 337.98 322.677 342.529 322.677 348.141C322.677 353.753 330.487 358.302 340.122 358.302Z",
    fill: "url(#paint159_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.706 338.488C350.026 338.488 357.618 342.743 358.113 348.103C358.126 347.925 358.164 347.747 358.164 347.556C358.164 341.943 350.356 337.396 340.719 337.396C331.082 337.396 323.274 341.943 323.274 347.556C323.274 347.747 323.299 347.925 323.324 348.103C323.794 342.755 331.387 338.488 340.706 338.488Z",
    fill: "url(#paint160_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.122 339.072C349.441 339.072 357.034 343.34 357.529 348.687C357.542 348.509 357.58 348.331 357.58 348.141C357.58 342.527 349.771 337.98 340.135 337.98C330.498 337.98 322.689 342.527 322.689 348.141C322.689 348.331 322.715 348.509 322.74 348.687C323.21 343.327 330.803 339.072 340.122 339.072Z",
    fill: "url(#paint161_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.387 335.047C357.631 336.837 361.173 340.394 360.284 342.985C359.396 345.589 354.431 346.236 349.187 344.458C343.944 342.667 340.401 339.111 341.29 336.52C342.166 333.916 347.131 333.256 352.387 335.047Z",
    fill: "url(#paint162_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.468 344.953C341.036 345.029 340.592 345.144 340.122 345.258C339.716 345.36 339.297 345.487 338.827 345.639C338.37 345.792 337.925 345.957 337.519 346.134L338.916 346.947C339.055 346.897 339.208 346.833 339.373 346.782C339.538 346.731 339.716 346.668 339.881 346.604C340.681 346.325 341.43 346.084 342.128 345.906C342.826 345.715 343.487 345.588 344.109 345.525C344.731 345.461 345.315 345.474 345.874 345.576C346.432 345.677 346.978 345.868 347.486 346.173C348.095 346.528 348.489 346.909 348.654 347.303C348.819 347.709 348.819 348.116 348.654 348.522C348.489 348.929 348.197 349.348 347.778 349.754C347.359 350.161 346.864 350.542 346.293 350.91L348.184 352.002L346.623 352.904L344.705 351.799C343.741 352.282 342.712 352.714 341.595 353.107C340.49 353.488 339.411 353.793 338.383 354.009L337.367 351.52C337.9 351.418 338.446 351.291 339.005 351.151C339.474 351.037 340.008 350.885 340.592 350.694C341.176 350.504 341.722 350.3 342.242 350.059L340.871 349.272C340.389 349.462 339.881 349.64 339.36 349.805C338.586 350.059 337.875 350.262 337.24 350.415C336.605 350.555 336.021 350.643 335.488 350.669C334.954 350.694 334.472 350.656 334.015 350.554C333.57 350.453 333.139 350.288 332.733 350.046C332.174 349.716 331.793 349.373 331.603 348.98C331.412 348.599 331.349 348.192 331.45 347.786C331.539 347.366 331.768 346.96 332.123 346.528C332.479 346.109 332.936 345.703 333.494 345.322L331.92 344.407L333.482 343.505L335.069 344.42C335.538 344.191 336.021 343.988 336.503 343.797C336.986 343.607 337.481 343.442 337.964 343.289C338.446 343.137 338.903 342.997 339.36 342.883C339.805 342.769 340.224 342.654 340.592 342.553L341.468 344.953ZM336.199 347.455C336.351 347.544 336.542 347.582 336.77 347.557C336.999 347.544 337.291 347.481 337.633 347.379L336.453 346.693C335.983 347.036 335.894 347.278 336.199 347.455ZM343.69 348.713C343.55 348.624 343.334 348.599 343.068 348.624C342.801 348.649 342.496 348.713 342.153 348.814L343.309 349.475C343.601 349.284 343.766 349.119 343.817 349.005C343.867 348.891 343.829 348.789 343.69 348.713Z",
    fill: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.468 344.369C341.036 344.446 340.592 344.56 340.122 344.674C339.716 344.776 339.297 344.903 338.827 345.055C338.37 345.208 337.925 345.373 337.519 345.551L338.916 346.363C339.055 346.313 339.208 346.249 339.373 346.198C339.538 346.147 339.716 346.084 339.881 346.02C340.681 345.741 341.43 345.5 342.128 345.322C342.826 345.131 343.487 345.004 344.109 344.941C344.731 344.877 345.315 344.89 345.874 344.992C346.432 345.093 346.978 345.284 347.486 345.589C348.095 345.944 348.489 346.325 348.654 346.719C348.819 347.125 348.819 347.532 348.654 347.938C348.489 348.345 348.197 348.764 347.778 349.17C347.359 349.577 346.864 349.958 346.293 350.326L348.184 351.418L346.623 352.32L344.705 351.215C343.741 351.698 342.712 352.13 341.595 352.523C340.49 352.905 339.411 353.209 338.383 353.425L337.367 350.936C337.9 350.834 338.446 350.707 339.005 350.568C339.474 350.453 340.008 350.301 340.592 350.11C341.176 349.92 341.722 349.717 342.242 349.475L340.871 348.688C340.389 348.878 339.881 349.056 339.36 349.221C338.586 349.475 337.875 349.678 337.24 349.831C336.605 349.971 336.021 350.059 335.488 350.085C334.954 350.11 334.472 350.072 334.015 349.971C333.57 349.869 333.139 349.704 332.733 349.463C332.174 349.132 331.793 348.789 331.603 348.396C331.412 348.015 331.349 347.608 331.45 347.202C331.539 346.783 331.768 346.376 332.123 345.944C332.479 345.525 332.936 345.119 333.494 344.738L331.92 343.823L333.482 342.921L335.069 343.836C335.538 343.607 336.021 343.404 336.503 343.213C336.986 343.023 337.481 342.858 337.964 342.705C338.446 342.553 338.903 342.413 339.36 342.299C339.805 342.185 340.224 342.07 340.592 341.969L341.468 344.369ZM336.199 346.871C336.351 346.96 336.542 346.998 336.77 346.973C336.999 346.96 337.291 346.897 337.633 346.795L336.453 346.109C335.983 346.452 335.894 346.706 336.199 346.871ZM343.69 348.129C343.55 348.04 343.334 348.015 343.068 348.04C342.801 348.065 342.496 348.129 342.153 348.23L343.309 348.891C343.601 348.7 343.766 348.535 343.817 348.421C343.867 348.307 343.829 348.205 343.69 348.129Z",
    fill: "#FFE585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.299 295.012C370.543 296.803 374.086 300.359 373.197 302.95C372.308 305.554 367.344 306.202 362.1 304.423C356.856 302.632 353.314 299.076 354.203 296.485C355.091 293.894 360.056 293.234 365.299 295.012Z",
    fill: "url(#paint163_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.298 146.141C255.943 146.141 255.664 145.861 255.664 145.506V143.6C255.664 143.245 255.943 142.965 256.298 142.965C256.654 142.965 256.933 143.245 256.933 143.6V145.506C256.933 145.861 256.654 146.141 256.298 146.141Z",
    fill: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.298 140.424C255.943 140.424 255.664 140.145 255.664 139.789V135.979C255.664 135.623 255.943 135.344 256.298 135.344C256.654 135.344 256.933 135.623 256.933 135.979V139.789C256.933 140.145 256.654 140.424 256.298 140.424ZM256.298 132.804C255.943 132.804 255.664 132.524 255.664 132.169V128.358C255.664 128.003 255.943 127.723 256.298 127.723C256.654 127.723 256.933 128.003 256.933 128.358V132.169C256.933 132.524 256.654 132.804 256.298 132.804ZM256.298 125.183C255.943 125.183 255.664 124.904 255.664 124.548V120.738C255.664 120.382 255.943 120.102 256.298 120.102C256.654 120.102 256.933 120.382 256.933 120.738V124.548C256.933 124.904 256.654 125.183 256.298 125.183ZM256.298 117.562C255.943 117.562 255.664 117.283 255.664 116.927V113.117C255.664 112.761 255.943 112.482 256.298 112.482C256.654 112.482 256.933 112.761 256.933 113.117V116.927C256.933 117.283 256.654 117.562 256.298 117.562ZM256.298 109.941C255.943 109.941 255.664 109.662 255.664 109.306V105.496C255.664 105.14 255.943 104.861 256.298 104.861C256.654 104.861 256.933 105.14 256.933 105.496V109.306C256.933 109.662 256.654 109.941 256.298 109.941ZM256.298 102.321C255.943 102.321 255.664 102.041 255.664 101.686V97.8753C255.664 97.5197 255.943 97.2402 256.298 97.2402C256.654 97.2402 256.933 97.5197 256.933 97.8753V101.686C256.933 102.041 256.654 102.321 256.298 102.321Z",
    fill: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.299 94.7002C255.943 94.7002 255.664 94.4207 255.664 94.0651V92.5283L254.331 91.7662C254.026 91.5884 253.924 91.2073 254.089 90.9025C254.267 90.5977 254.648 90.4961 254.953 90.6612L256.921 91.7916V94.0651C256.933 94.4207 256.654 94.7002 256.299 94.7002Z",
    fill: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.321 89.9497C251.22 89.9497 251.105 89.9243 251.004 89.8608L247.677 87.9556C247.373 87.7778 247.271 87.3967 247.436 87.0919C247.614 86.7871 247.995 86.6855 248.299 86.8506L251.626 88.7558C251.931 88.9336 252.032 89.3146 251.867 89.6194C251.753 89.8354 251.537 89.9497 251.321 89.9497ZM244.655 86.152C244.541 86.152 244.44 86.1266 244.338 86.0631L241.012 84.1579C240.707 83.9801 240.605 83.5991 240.77 83.2942C240.948 82.9894 241.329 82.8878 241.634 83.0529L244.96 84.9581C245.265 85.1359 245.366 85.517 245.201 85.8218C245.1 86.0377 244.884 86.152 244.655 86.152ZM238.002 82.3543C237.901 82.3543 237.787 82.3289 237.685 82.2654L234.358 80.3603C234.054 80.1824 233.952 79.8014 234.117 79.4966C234.295 79.1917 234.689 79.0901 234.981 79.2552L238.307 81.1604C238.612 81.3382 238.713 81.7193 238.548 82.0241C238.434 82.24 238.231 82.3543 238.002 82.3543ZM231.349 78.5567C231.248 78.5567 231.134 78.5313 231.032 78.4678L227.705 76.5626C227.401 76.3848 227.299 76.0037 227.464 75.6989C227.642 75.3941 228.036 75.2925 228.328 75.4576L231.654 77.3628C231.959 77.5406 232.06 77.9216 231.895 78.2264C231.781 78.4424 231.565 78.5567 231.349 78.5567ZM224.696 74.759C224.595 74.759 224.48 74.7336 224.379 74.6701L221.052 72.7649C220.748 72.5871 220.646 72.2061 220.811 71.9012C220.989 71.5964 221.382 71.4948 221.675 71.6599L225.001 73.5651C225.306 73.7429 225.407 74.1239 225.242 74.4288C225.128 74.6447 224.912 74.759 224.696 74.759ZM218.043 70.9613C217.929 70.9613 217.827 70.9359 217.726 70.8724L214.399 68.9672C214.095 68.7894 213.993 68.4084 214.158 68.1036C214.336 67.7987 214.717 67.6971 215.021 67.8622L218.348 69.7674C218.653 69.9452 218.754 70.3263 218.589 70.6311C218.475 70.847 218.259 70.9613 218.043 70.9613ZM211.39 67.151C211.276 67.151 211.174 67.1256 211.073 67.0621L207.746 65.1569C207.442 64.9791 207.34 64.598 207.505 64.2932C207.683 63.9884 208.064 63.8868 208.368 64.0519L211.695 65.9571C212 66.1349 212.101 66.5159 211.936 66.8207C211.822 67.0367 211.606 67.151 211.39 67.151ZM204.737 63.3533C204.636 63.3533 204.521 63.3279 204.42 63.2644L201.093 61.3592C200.789 61.1814 200.687 60.8004 200.852 60.4955C201.03 60.1907 201.411 60.0891 201.715 60.2542L205.042 62.1594C205.347 62.3372 205.448 62.7182 205.283 63.0231C205.169 63.239 204.953 63.3533 204.737 63.3533ZM198.071 59.5556C197.97 59.5556 197.856 59.5302 197.754 59.4667L194.427 57.5615C194.123 57.3837 194.021 57.0027 194.186 56.6979C194.364 56.393 194.758 56.2914 195.05 56.4565L198.376 58.3617C198.681 58.5395 198.782 58.9206 198.617 59.2254C198.516 59.4413 198.3 59.5556 198.071 59.5556ZM191.418 55.758C191.317 55.758 191.203 55.7326 191.101 55.6691L187.774 53.7639C187.47 53.5861 187.368 53.205 187.533 52.9002C187.711 52.5954 188.092 52.4937 188.397 52.6589L191.723 54.564C192.028 54.7419 192.129 55.1229 191.964 55.4277C191.85 55.6436 191.634 55.758 191.418 55.758ZM184.765 51.9603C184.664 51.9603 184.549 51.9349 184.448 51.8714L181.121 49.9662C180.817 49.7884 180.715 49.4073 180.88 49.1025C181.058 48.7977 181.439 48.6961 181.743 48.8612L185.07 50.7664C185.375 50.9442 185.476 51.3252 185.311 51.6301C185.197 51.846 184.981 51.9603 184.765 51.9603ZM178.112 48.1626C178.011 48.1626 177.896 48.1372 177.795 48.0737L174.468 46.1685C174.164 45.9907 174.062 45.6097 174.227 45.3048C174.405 45 174.798 44.8984 175.09 45.0635L178.417 46.9687C178.722 47.1465 178.823 47.5276 178.658 47.8324C178.544 48.0483 178.328 48.1626 178.112 48.1626Z",
    fill: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.459 44.3648C171.358 44.3648 171.243 44.3394 171.142 44.2759L169.491 43.336C169.187 43.1582 169.085 42.7772 169.25 42.4723C169.428 42.1675 169.821 42.0659 170.113 42.231L171.764 43.1709C172.069 43.3487 172.17 43.7297 172.005 44.0346C171.891 44.2505 171.675 44.3648 171.459 44.3648Z",
    fill: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.13 220.125C325.775 220.125 325.496 219.846 325.496 219.49V217.585C325.496 217.229 325.775 216.95 326.13 216.95C326.486 216.95 326.765 217.229 326.765 217.585V219.49C326.765 219.846 326.486 220.125 326.13 220.125Z",
    fill: "#B4F759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.13 214.549C325.775 214.549 325.496 214.27 325.496 213.914V210.244C325.496 209.888 325.775 209.608 326.13 209.608C326.486 209.608 326.765 209.888 326.765 210.244V213.914C326.765 214.257 326.486 214.549 326.13 214.549ZM326.13 207.195C325.775 207.195 325.496 206.916 325.496 206.56V202.89C325.496 202.534 325.775 202.254 326.13 202.254C326.486 202.254 326.765 202.534 326.765 202.89V206.56C326.765 206.903 326.486 207.195 326.13 207.195ZM326.13 199.841C325.775 199.841 325.496 199.562 325.496 199.206V195.535C325.496 195.18 325.775 194.9 326.13 194.9C326.486 194.9 326.765 195.18 326.765 195.535V199.206C326.765 199.549 326.486 199.841 326.13 199.841ZM326.13 192.487C325.775 192.487 325.496 192.208 325.496 191.852V188.181C325.496 187.826 325.775 187.546 326.13 187.546C326.486 187.546 326.765 187.826 326.765 188.181V191.852C326.765 192.208 326.486 192.487 326.13 192.487ZM326.13 185.133C325.775 185.133 325.496 184.854 325.496 184.498V180.827C325.496 180.472 325.775 180.192 326.13 180.192C326.486 180.192 326.765 180.472 326.765 180.827V184.498C326.765 184.854 326.486 185.133 326.13 185.133ZM326.13 177.779C325.775 177.779 325.496 177.5 325.496 177.144V173.473C325.496 173.118 325.775 172.838 326.13 172.838C326.486 172.838 326.765 173.118 326.765 173.473V177.144C326.765 177.5 326.486 177.779 326.13 177.779Z",
    fill: "#B4F759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.13 170.425C325.775 170.425 325.495 170.145 325.495 169.79V168.253L324.162 167.478C323.857 167.3 323.756 166.919 323.934 166.614C324.111 166.31 324.505 166.208 324.797 166.386L326.765 167.529V169.802C326.765 170.145 326.486 170.425 326.13 170.425Z",
    fill: "#B4F759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.242 165.688C321.128 165.688 321.026 165.662 320.925 165.599L317.674 163.719C317.37 163.541 317.268 163.16 317.446 162.855C317.624 162.55 318.017 162.449 318.309 162.627L321.559 164.506C321.864 164.684 321.966 165.065 321.788 165.37C321.674 165.573 321.458 165.688 321.242 165.688ZM314.741 161.928C314.627 161.928 314.526 161.903 314.424 161.839L311.174 159.959C310.869 159.782 310.767 159.4 310.945 159.096C311.123 158.791 311.516 158.689 311.808 158.867L315.059 160.747C315.363 160.925 315.465 161.306 315.287 161.61C315.173 161.814 314.957 161.928 314.741 161.928ZM308.253 158.168C308.139 158.168 308.038 158.143 307.936 158.08L304.686 156.2C304.381 156.022 304.279 155.641 304.457 155.336C304.635 155.031 305.028 154.93 305.32 155.107L308.571 156.987C308.875 157.165 308.977 157.546 308.799 157.851C308.685 158.054 308.469 158.168 308.253 158.168ZM301.765 154.396C301.651 154.396 301.55 154.371 301.448 154.307L298.198 152.428C297.893 152.25 297.791 151.869 297.969 151.564C298.147 151.259 298.54 151.157 298.832 151.335L302.083 153.215C302.387 153.393 302.489 153.774 302.311 154.079C302.197 154.282 301.981 154.396 301.765 154.396ZM295.265 150.637C295.15 150.637 295.049 150.611 294.947 150.548L291.697 148.668C291.392 148.49 291.291 148.109 291.468 147.804C291.646 147.499 292.04 147.398 292.332 147.576L295.582 149.455C295.887 149.633 295.988 150.014 295.811 150.319C295.696 150.522 295.481 150.637 295.265 150.637ZM288.777 146.877C288.662 146.877 288.561 146.852 288.459 146.788L285.209 144.908C284.904 144.731 284.803 144.35 284.98 144.045C285.158 143.74 285.552 143.638 285.844 143.816L289.094 145.696C289.399 145.874 289.5 146.255 289.323 146.56C289.208 146.763 288.993 146.877 288.777 146.877ZM282.289 143.117C282.174 143.117 282.073 143.092 281.971 143.029L278.721 141.149C278.416 140.971 278.315 140.59 278.492 140.285C278.67 139.98 279.064 139.879 279.356 140.056L282.606 141.936C282.911 142.114 283.012 142.495 282.835 142.8C282.72 143.003 282.505 143.117 282.289 143.117ZM275.788 139.345C275.674 139.345 275.572 139.32 275.471 139.256L272.22 137.377C271.915 137.199 271.814 136.818 271.992 136.513C272.169 136.208 272.563 136.106 272.855 136.284L276.105 138.164C276.41 138.342 276.512 138.723 276.334 139.028C276.22 139.231 276.017 139.345 275.788 139.345ZM269.3 135.586C269.186 135.586 269.084 135.56 268.983 135.497L265.732 133.617C265.427 133.439 265.326 133.058 265.504 132.753C265.681 132.448 266.075 132.347 266.367 132.525L269.617 134.404C269.922 134.582 270.024 134.963 269.846 135.268C269.732 135.471 269.516 135.586 269.3 135.586ZM262.812 131.826C262.698 131.826 262.596 131.801 262.495 131.737L259.244 129.857C258.939 129.68 258.838 129.299 259.016 128.994C259.193 128.689 259.587 128.587 259.879 128.765L263.129 130.645C263.434 130.823 263.536 131.204 263.358 131.509C263.244 131.712 263.028 131.826 262.812 131.826ZM256.324 128.067C256.21 128.067 256.108 128.041 256.007 127.978L252.756 126.098C252.451 125.92 252.35 125.539 252.528 125.234C252.705 124.929 253.099 124.828 253.391 125.006L256.641 126.885C256.946 127.063 257.048 127.444 256.87 127.749C256.756 127.952 256.54 128.067 256.324 128.067ZM249.823 124.294C249.709 124.294 249.607 124.269 249.506 124.205L246.256 122.326C245.951 122.148 245.849 121.767 246.027 121.462C246.205 121.157 246.598 121.055 246.89 121.233L250.141 123.113C250.445 123.291 250.547 123.672 250.369 123.977C250.255 124.18 250.039 124.294 249.823 124.294ZM243.335 120.535C243.221 120.535 243.119 120.509 243.018 120.446L239.768 118.566C239.463 118.388 239.361 118.007 239.539 117.702C239.717 117.397 240.11 117.296 240.402 117.474L243.653 119.353C243.957 119.531 244.059 119.912 243.881 120.217C243.767 120.42 243.551 120.535 243.335 120.535ZM236.847 116.775C236.733 116.775 236.631 116.75 236.53 116.686L233.28 114.806C232.975 114.629 232.873 114.248 233.051 113.943C233.229 113.638 233.622 113.536 233.914 113.714L237.165 115.594C237.469 115.772 237.571 116.153 237.393 116.458C237.279 116.661 237.063 116.775 236.847 116.775ZM230.347 113.003C230.232 113.003 230.131 112.977 230.029 112.914L226.779 111.034C226.474 110.856 226.373 110.475 226.55 110.17C226.728 109.866 227.122 109.764 227.414 109.942L230.664 111.822C230.969 111.999 231.07 112.381 230.893 112.685C230.778 112.901 230.575 113.003 230.347 113.003ZM223.859 109.243C223.744 109.243 223.643 109.218 223.541 109.154L220.291 107.275C219.986 107.097 219.885 106.716 220.062 106.411C220.24 106.106 220.634 106.004 220.926 106.182L224.176 108.062C224.481 108.24 224.582 108.621 224.405 108.926C224.29 109.129 224.074 109.243 223.859 109.243ZM217.371 105.484C217.256 105.484 217.155 105.458 217.053 105.395L213.803 103.515C213.498 103.337 213.397 102.956 213.574 102.651C213.752 102.347 214.146 102.245 214.438 102.423L217.688 104.303C217.993 104.48 218.094 104.861 217.917 105.166C217.802 105.369 217.586 105.484 217.371 105.484ZM210.883 101.724C210.768 101.724 210.667 101.699 210.565 101.635L207.315 99.7555C207.01 99.5777 206.909 99.1966 207.086 98.8918C207.264 98.587 207.658 98.4854 207.95 98.6632L211.2 100.543C211.505 100.721 211.606 101.102 211.429 101.407C211.314 101.61 211.098 101.724 210.883 101.724ZM204.382 97.9519C204.268 97.9519 204.166 97.9265 204.064 97.863L200.814 95.9832C200.509 95.8054 200.408 95.4244 200.586 95.1195C200.763 94.8147 201.157 94.7131 201.449 94.8909L204.699 96.7707C205.004 96.9485 205.106 97.3295 204.928 97.6344C204.814 97.8503 204.598 97.9519 204.382 97.9519ZM197.894 94.1923C197.78 94.1923 197.678 94.1669 197.576 94.1034L194.326 92.2236C194.021 92.0458 193.92 91.6648 194.098 91.36C194.275 91.0551 194.669 90.9535 194.961 91.1313L198.211 93.0111C198.516 93.1889 198.618 93.57 198.44 93.8748C198.326 94.078 198.11 94.1923 197.894 94.1923ZM191.406 90.4328C191.292 90.4328 191.19 90.4074 191.088 90.3439L187.838 88.4641C187.533 88.2863 187.432 87.9052 187.61 87.6004C187.787 87.2956 188.181 87.194 188.473 87.3718L191.723 89.2515C192.028 89.4294 192.13 89.8104 191.952 90.1152C191.838 90.3185 191.622 90.4328 191.406 90.4328ZM184.905 86.6732C184.791 86.6732 184.689 86.6478 184.588 86.5843L181.337 84.7045C181.033 84.5267 180.931 84.1457 181.109 83.8408C181.287 83.536 181.68 83.4344 181.972 83.6122L185.223 85.492C185.527 85.6698 185.629 86.0508 185.451 86.3557C185.337 86.5589 185.121 86.6732 184.905 86.6732ZM178.417 82.9009C178.303 82.9009 178.201 82.8755 178.1 82.812L174.849 80.9322C174.545 80.7544 174.443 80.3734 174.621 80.0686C174.799 79.7637 175.192 79.6621 175.484 79.8399L178.735 81.7197C179.039 81.8975 179.141 82.2786 178.963 82.5834C178.849 82.7866 178.633 82.9009 178.417 82.9009Z",
    fill: "#B4F759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.929 79.1412C171.815 79.1412 171.713 79.1158 171.612 79.0523L169.961 78.0997C169.657 77.9219 169.555 77.5409 169.733 77.236C169.91 76.9312 170.304 76.8296 170.596 77.0074L172.247 77.96C172.551 78.1378 172.653 78.5189 172.475 78.8237C172.361 79.0269 172.145 79.1412 171.929 79.1412Z",
    fill: "#B4F759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.269 170.578C330.269 173.004 328.555 173.982 326.448 172.762C324.34 171.543 322.626 168.596 322.626 166.17C322.626 163.744 324.34 162.766 326.448 163.986C328.555 165.205 330.269 168.152 330.269 170.578Z",
    fill: "#B4F759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.438 94.0522C260.438 96.4782 258.724 97.4561 256.616 96.2368C254.508 95.0175 252.794 92.0708 252.794 89.6449C252.794 87.2189 254.508 86.241 256.616 87.4603C258.724 88.6796 260.438 91.6263 260.438 94.0522Z",
    fill: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0476,
    d: "M125.205 233.017C123.821 233.818 122.933 235.151 122.933 236.548C122.933 238.085 123.783 239.597 125.447 240.562C125.37 240.613 138.118 248.475 138.207 248.526L147.551 254.216C147.564 254.228 150.345 255.918 150.357 255.93C151.691 256.693 153.354 257.112 155.042 257.124C156.515 257.124 157.836 256.807 158.902 256.21C158.953 256.21 166.165 251.002 166.203 250.99C167.587 250.189 168.476 248.856 168.476 247.459C168.476 245.922 167.625 244.41 165.962 243.445C166.038 243.394 153.354 235.57 153.252 235.52L143.984 229.868C143.971 229.855 141.355 228.254 141.33 228.254C139.997 227.492 138.334 227.073 136.645 227.061C135.172 227.061 133.852 227.378 132.785 227.975C132.76 227.962 125.243 232.992 125.205 233.017Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952,
    d: "M125.573 232.903C124.253 233.665 123.301 234.998 123.301 236.332C123.301 237.793 123.986 239.304 125.573 240.218C125.421 240.307 137.546 247.865 137.724 247.966L146.752 253.453C146.777 253.466 149.431 255.092 149.469 255.104C150.751 255.841 152.363 256.247 153.989 256.247C155.398 256.247 156.693 255.955 157.709 255.384C157.81 255.384 164.705 250.43 164.781 250.392C166.101 249.63 167.054 248.296 167.054 246.963C167.054 245.502 166.368 243.991 164.781 243.076C164.933 242.987 152.871 235.468 152.694 235.367L143.742 229.93C143.717 229.918 141.216 228.394 141.178 228.381C139.895 227.644 138.283 227.238 136.658 227.225C135.248 227.225 133.953 227.517 132.938 228.089C132.836 228.076 125.65 232.852 125.573 232.903Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M125.942 232.788C124.697 233.512 123.682 234.833 123.682 236.103C123.682 237.488 124.202 238.999 125.713 239.863C125.485 240.002 136.975 247.242 137.242 247.395L145.952 252.666C145.99 252.691 148.529 254.228 148.567 254.253C149.811 254.964 151.36 255.346 152.922 255.358C154.281 255.371 155.525 255.091 156.515 254.545C156.655 254.545 163.244 249.846 163.346 249.782C164.59 249.058 165.606 247.737 165.606 246.467C165.606 245.083 165.085 243.571 163.575 242.708C163.803 242.568 152.363 235.366 152.097 235.201L143.45 229.968C143.412 229.943 141.025 228.495 140.974 228.47C139.73 227.758 138.181 227.365 136.62 227.365C135.261 227.352 134.017 227.631 133.026 228.178C132.912 228.178 126.043 232.725 125.942 232.788Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M126.31 232.674C125.129 233.36 124.063 234.681 124.063 235.875C124.063 237.183 124.431 238.695 125.84 239.507C125.536 239.685 136.404 246.62 136.759 246.823L145.165 251.891C145.215 251.929 147.628 253.39 147.691 253.415C148.897 254.089 150.383 254.47 151.894 254.482C153.202 254.495 154.395 254.228 155.36 253.72C155.55 253.72 161.823 249.262 161.962 249.186C163.143 248.5 164.21 247.179 164.21 245.985C164.21 244.677 163.841 243.165 162.432 242.353C162.737 242.175 151.919 235.265 151.564 235.062L143.235 230.032C143.184 230.007 140.911 228.623 140.848 228.597C139.642 227.924 138.156 227.543 136.645 227.53C135.337 227.518 134.144 227.784 133.179 228.292C132.989 228.28 126.45 232.585 126.31 232.674Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M126.678 232.56C125.574 233.195 124.431 234.529 124.431 235.659C124.431 236.891 124.634 238.402 125.967 239.165C125.586 239.393 135.82 246.01 136.264 246.264L144.352 251.116C144.415 251.154 146.714 252.539 146.79 252.577C147.945 253.225 149.38 253.58 150.827 253.606C152.084 253.619 153.24 253.377 154.167 252.895C154.408 252.895 160.375 248.69 160.54 248.589C161.645 247.954 162.788 246.62 162.788 245.49C162.788 244.258 162.584 242.746 161.251 241.984C161.632 241.756 151.449 235.164 150.992 234.91L142.968 230.096C142.905 230.058 140.746 228.75 140.67 228.724C139.515 228.076 138.08 227.708 136.632 227.695C135.375 227.683 134.22 227.924 133.293 228.407C133.065 228.394 126.856 232.458 126.678 232.56Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M127.047 232.446C126.005 233.042 124.812 234.376 124.812 235.43C124.812 236.586 124.863 238.098 126.107 238.822C125.637 239.088 135.261 245.401 135.795 245.706L143.565 250.354C143.654 250.405 145.812 251.713 145.901 251.751C147.018 252.374 148.39 252.717 149.774 252.742C150.98 252.755 152.084 252.526 152.973 252.082C153.265 252.082 158.915 248.119 159.118 248.005C160.16 247.408 161.353 246.074 161.353 245.02C161.353 243.864 161.302 242.352 160.058 241.641C160.528 241.374 150.954 235.087 150.421 234.783L142.714 230.172C142.638 230.121 140.594 228.889 140.505 228.864C139.388 228.241 138.017 227.898 136.633 227.873C135.426 227.86 134.322 228.076 133.433 228.534C133.128 228.495 127.25 232.319 127.047 232.446Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M127.414 232.332C126.449 232.891 125.193 234.224 125.193 235.215C125.193 236.294 125.078 237.806 126.246 238.479C125.7 238.797 134.69 244.792 135.312 245.147L142.765 249.58C142.866 249.631 144.898 250.863 145.012 250.914C146.079 251.498 147.399 251.828 148.732 251.853C149.888 251.879 150.941 251.663 151.805 251.244C152.135 251.244 157.48 247.535 157.721 247.395C158.686 246.836 159.943 245.503 159.943 244.512C159.943 243.433 160.058 241.921 158.889 241.248C159.435 240.93 150.484 234.961 149.862 234.605L142.46 230.198C142.371 230.147 140.441 228.979 140.34 228.94C139.273 228.356 137.953 228.013 136.62 227.988C135.464 227.962 134.41 228.178 133.547 228.598C133.204 228.598 127.656 232.179 127.414 232.332Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M127.77 232.217C126.869 232.737 125.561 234.071 125.561 234.985C125.561 235.989 125.294 237.488 126.373 238.123C125.751 238.478 134.118 244.168 134.829 244.575L141.978 248.804C142.092 248.868 144.009 250.024 144.136 250.062C145.165 250.621 146.422 250.938 147.691 250.964C148.783 250.989 149.799 250.798 150.637 250.405C151.018 250.405 156.046 246.95 156.325 246.785C157.226 246.264 158.534 244.93 158.534 244.016C158.534 243.013 158.801 241.514 157.722 240.879C158.344 240.523 150.015 234.858 149.304 234.439L142.206 230.248C142.105 230.184 140.289 229.105 140.175 229.054C139.146 228.495 137.889 228.178 136.62 228.139C135.528 228.114 134.512 228.305 133.674 228.698C133.28 228.711 128.049 232.051 127.77 232.217Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M128.138 232.103C127.313 232.585 125.929 233.919 125.929 234.757C125.929 235.685 125.497 237.183 126.5 237.768C125.802 238.174 133.534 243.547 134.347 244.004L141.178 248.017C141.305 248.094 143.095 249.161 143.235 249.211C144.225 249.745 145.418 250.037 146.625 250.075C147.666 250.1 148.643 249.923 149.431 249.567C149.862 249.567 154.573 246.354 154.89 246.176C155.715 245.693 157.099 244.359 157.099 243.521C157.099 242.594 157.531 241.095 156.528 240.511C157.226 240.105 149.532 234.757 148.72 234.287L141.94 230.299C141.825 230.236 140.137 229.22 139.997 229.169C139.007 228.635 137.813 228.331 136.607 228.305C135.566 228.28 134.588 228.458 133.801 228.813C133.357 228.813 128.456 231.912 128.138 232.103Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M128.507 231.988C127.745 232.433 126.31 233.766 126.31 234.541C126.31 235.392 125.726 236.891 126.64 237.424C125.866 237.869 132.976 242.937 133.865 243.445L140.378 247.242C140.518 247.319 142.181 248.322 142.346 248.373C143.285 248.868 144.428 249.16 145.584 249.198C146.574 249.224 147.501 249.071 148.263 248.741C148.745 248.741 153.138 245.782 153.481 245.579C154.243 245.134 155.677 243.8 155.677 243.026C155.677 242.175 156.261 240.676 155.347 240.142C156.122 239.698 149.05 234.656 148.161 234.135L141.686 230.362C141.559 230.286 139.984 229.346 139.832 229.283C138.892 228.788 137.75 228.495 136.594 228.457C135.604 228.432 134.677 228.584 133.915 228.915C133.433 228.927 128.862 231.785 128.507 231.988Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M128.875 231.874C128.177 232.268 126.691 233.614 126.691 234.312C126.691 235.087 125.942 236.586 126.78 237.069C125.929 237.564 132.405 242.314 133.395 242.873L139.591 246.468C139.743 246.556 141.292 247.471 141.457 247.534C142.359 248.004 143.438 248.271 144.53 248.322C145.47 248.36 146.346 248.208 147.082 247.916C147.615 247.916 151.691 245.21 152.072 244.982C152.77 244.588 154.256 243.241 154.256 242.543C154.256 241.768 155.005 240.269 154.167 239.787C155.017 239.291 148.568 234.567 147.59 233.995L141.432 230.426C141.292 230.337 139.832 229.473 139.667 229.41C138.766 228.94 137.686 228.66 136.595 228.622C135.655 228.584 134.779 228.724 134.043 229.029C133.509 229.029 129.256 231.645 128.875 231.874Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M129.243 231.76C128.621 232.116 127.059 233.462 127.059 234.084C127.059 234.783 126.145 236.282 126.907 236.713C125.98 237.247 131.833 241.692 132.9 242.302L138.791 245.681C138.956 245.782 140.378 246.62 140.569 246.684C141.419 247.128 142.448 247.383 143.476 247.421C144.365 247.459 145.19 247.332 145.901 247.065C146.472 247.065 150.256 244.601 150.662 244.372C151.285 244.017 152.846 242.67 152.846 242.048C152.846 241.349 153.76 239.851 152.999 239.419C153.925 238.885 148.098 234.453 147.031 233.843L141.178 230.477C141.026 230.388 139.68 229.588 139.502 229.525C138.651 229.08 137.623 228.826 136.582 228.775C135.693 228.737 134.868 228.864 134.157 229.131C133.585 229.131 129.662 231.506 129.243 231.76Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M129.611 231.646C129.053 231.963 127.44 233.297 127.44 233.868C127.44 234.491 126.374 235.99 127.034 236.371C126.031 236.955 131.249 241.083 132.417 241.756L137.991 244.931C138.169 245.033 139.476 245.795 139.68 245.871C140.492 246.278 141.457 246.519 142.435 246.57C143.273 246.608 144.06 246.506 144.72 246.252C145.342 246.252 148.809 244.042 149.253 243.788C149.812 243.471 151.424 242.137 151.424 241.565C151.424 240.943 152.491 239.444 151.83 239.063C152.833 238.479 147.64 234.364 146.472 233.703L140.937 230.553C140.772 230.452 139.54 229.728 139.35 229.664C138.537 229.258 137.572 229.004 136.594 228.953C135.756 228.915 134.969 229.017 134.309 229.258C133.661 229.245 130.068 231.379 129.611 231.646Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M129.979 231.531C129.497 231.811 127.821 233.144 127.821 233.64C127.821 234.173 126.589 235.685 127.173 236.015C126.094 236.637 130.69 240.46 131.934 241.184L137.191 244.144C137.381 244.258 138.562 244.944 138.778 245.02C139.552 245.401 140.454 245.63 141.368 245.68C142.155 245.719 142.892 245.63 143.527 245.414C144.199 245.414 147.348 243.458 147.831 243.178C148.313 242.899 149.989 241.565 149.989 241.07C149.989 240.536 151.221 239.025 150.637 238.695C151.716 238.072 147.145 234.262 145.901 233.538L140.67 230.591C140.492 230.49 139.375 229.842 139.172 229.753C138.397 229.372 137.496 229.143 136.581 229.093C135.794 229.054 135.058 229.143 134.423 229.347C133.737 229.347 130.462 231.239 129.979 231.531Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M130.348 231.416C129.929 231.658 128.202 232.991 128.202 233.423C128.202 233.88 126.818 235.392 127.313 235.684C126.158 236.357 130.119 239.863 131.465 240.637L136.404 243.394C136.607 243.508 137.661 244.13 137.902 244.207C138.626 244.562 139.476 244.765 140.34 244.829C141.064 244.88 141.762 244.803 142.371 244.613C143.095 244.613 145.926 242.898 146.447 242.606C146.866 242.365 148.593 241.031 148.593 240.599C148.593 240.142 149.977 238.631 149.481 238.339C150.637 237.665 146.688 234.173 145.355 233.398L140.441 230.654C140.251 230.54 139.248 229.968 139.032 229.88C138.308 229.524 137.458 229.308 136.594 229.257C135.871 229.206 135.172 229.283 134.563 229.46C133.814 229.448 130.868 231.112 130.348 231.416Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M130.716 231.302C130.373 231.505 128.57 232.839 128.57 233.195C128.57 233.576 127.021 235.087 127.44 235.328C126.208 236.04 129.548 239.24 130.97 240.066L135.604 242.606C135.82 242.733 136.759 243.267 137.013 243.356C137.699 243.673 138.486 243.876 139.286 243.927C139.959 243.978 140.606 243.914 141.178 243.762C141.94 243.762 144.466 242.301 145.012 241.984C145.355 241.781 147.158 240.447 147.158 240.091C147.158 239.71 148.707 238.199 148.288 237.958C149.519 237.246 146.193 234.058 144.771 233.233L140.162 230.705C139.946 230.578 139.07 230.083 138.842 229.994C138.156 229.676 137.369 229.473 136.569 229.41C135.896 229.359 135.248 229.41 134.677 229.562C133.877 229.562 131.274 230.972 130.716 231.302Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M131.071 231.188C130.792 231.353 128.938 232.687 128.938 232.966C128.938 233.271 127.237 234.782 127.567 234.973C126.247 235.735 128.964 238.618 130.487 239.494L134.804 241.831C135.045 241.971 135.845 242.428 136.112 242.517C136.747 242.81 137.483 242.987 138.22 243.051C138.842 243.102 139.451 243.064 139.984 242.937C140.797 242.924 143.006 241.717 143.59 241.387C143.87 241.222 145.723 239.888 145.723 239.609C145.723 239.304 147.425 237.793 147.094 237.602C148.415 236.84 145.711 233.969 144.187 233.093L139.883 230.769C139.654 230.642 138.905 230.21 138.651 230.121C138.016 229.829 137.28 229.638 136.544 229.575C135.921 229.524 135.312 229.562 134.779 229.676C133.953 229.664 131.668 230.845 131.071 231.188Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M131.44 231.074C131.237 231.188 129.319 232.534 129.319 232.75C129.319 232.979 127.453 234.478 127.707 234.63C126.31 235.43 128.405 238.009 130.005 238.936L134.004 241.057C134.258 241.197 134.944 241.578 135.223 241.679C135.82 241.946 136.493 242.111 137.179 242.175C137.75 242.225 138.309 242.2 138.816 242.111C139.68 242.098 141.584 241.146 142.194 240.79C142.397 240.676 144.314 239.33 144.314 239.114C144.314 238.885 146.181 237.386 145.927 237.234C147.323 236.434 145.241 233.868 143.628 232.941L139.642 230.82C139.4 230.68 138.766 230.324 138.499 230.223C137.902 229.956 137.229 229.791 136.544 229.715C135.972 229.664 135.414 229.677 134.906 229.766C134.03 229.778 132.075 230.705 131.44 231.074Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M131.808 230.959C131.668 231.035 129.7 232.382 129.7 232.521C129.7 232.674 127.681 234.172 127.846 234.274C126.373 235.125 127.834 237.386 129.535 238.364L133.217 240.282C133.484 240.434 134.042 240.739 134.334 240.841C134.893 241.069 135.502 241.222 136.124 241.298C136.645 241.349 137.153 241.349 137.623 241.285C138.537 241.272 140.124 240.574 140.771 240.193C140.911 240.117 142.879 238.77 142.879 238.631C142.879 238.478 144.898 236.979 144.733 236.878C146.206 236.027 144.746 233.766 143.057 232.788L139.375 230.883C139.121 230.743 138.6 230.451 138.321 230.349C137.762 230.121 137.153 229.956 136.531 229.879C136.01 229.816 135.502 229.829 135.02 229.879C134.106 229.879 132.468 230.565 131.808 230.959Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M132.176 230.845C132.113 230.883 130.068 232.23 130.068 232.293C130.068 232.369 127.885 233.868 127.973 233.919C126.424 234.808 127.262 236.764 129.04 237.793L132.405 239.495C132.684 239.66 133.116 239.876 133.433 239.99C133.941 240.193 134.499 240.333 135.058 240.409C135.528 240.473 135.985 240.485 136.429 240.447C137.394 240.435 138.664 239.977 139.35 239.584C139.413 239.546 141.457 238.199 141.457 238.136C141.457 238.059 143.641 236.561 143.552 236.51C145.101 235.621 144.276 233.665 142.486 232.636L139.121 230.934C138.854 230.782 138.448 230.566 138.156 230.464C137.648 230.261 137.09 230.121 136.531 230.045C136.061 229.981 135.604 229.969 135.16 229.994C134.182 229.982 132.874 230.439 132.176 230.845Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.953 238.986L142.384 236.141C144.009 235.201 143.806 233.563 141.927 232.483L138.867 230.984C136.988 229.905 134.157 229.791 132.532 230.718L128.1 233.563C126.475 234.503 126.678 236.141 128.557 237.221L131.617 238.72C133.496 239.799 136.328 239.926 137.953 238.986Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.042 249.477L339.779 241.628L403.25 188.956L389.525 196.805L326.042 249.477Z",
    fill: "#0CB073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.267 244.549L151.005 236.7L253.683 163.109L239.945 170.958L137.267 244.549Z",
    fill: "#1F45CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.783 148.795L254.508 140.946L340.135 219.071L326.397 226.92L240.783 148.795Z",
    fill: "url(#paint164_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.306 174.325L381.043 166.475L435.157 149.494L421.419 157.343L367.306 174.325Z",
    fill: "#CAFF82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.25 206.814L412.988 198.965L435.157 149.494L421.419 157.343L399.25 206.814Z",
    fill: "#51A245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.306 174.324L377.146 184.193L377.488 184.536L326.397 226.92L240.783 148.795L121.028 234.77L137.267 244.55L239.945 170.959L326.067 249.528L389.538 196.869L389.741 197.072L399.25 206.814L421.419 157.343L367.306 174.324Z",
    fill: "url(#paint165_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.038 158.181L434.369 150.001L420.505 157.622L367.306 174.324L368.309 175.328L421.038 158.181Z",
    fill: "url(#paint166_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.783 150.116L326.397 228.228L377.488 185.844L377.146 185.501L376.777 185.133L326.397 226.92L240.783 148.795L121.028 234.77L122.019 235.367L240.783 150.116Z",
    fill: "url(#paint167_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.39 316.121C319.941 316.121 330.117 311.378 330.117 305.528C330.117 299.678 319.941 294.935 307.39 294.935C294.838 294.935 284.663 299.678 284.663 305.528C284.663 311.378 294.838 316.121 307.39 316.121Z",
    fill: "url(#paint168_radial_195_3461)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0476,
    d: "M292.649 314.736C292.903 314.876 292.687 320.935 292.395 327.006C292.103 333.077 291.748 339.186 291.748 339.44C291.735 339.974 291.417 340.469 290.833 340.812L287.634 342.603L286.91 343.009C286.885 343.022 283 345.181 282.987 345.181C282.542 345.435 282.009 345.562 281.451 345.575C281.425 345.575 281.4 345.575 281.374 345.575C280.879 345.575 280.397 345.461 280.041 345.245L278.695 344.381C278.213 344.102 277.934 343.657 277.934 343.174C277.934 342.641 278.264 342.133 278.835 341.803C278.835 341.79 284.752 337.357 284.777 337.345L285.196 337.04C285.653 336.773 286.225 336.633 286.809 336.633C286.961 336.633 287.304 334.322 287.685 331.185C287.913 329.305 288.18 327.133 288.434 324.974C288.789 321.913 289.145 318.864 289.424 316.68C289.665 314.711 289.868 313.454 289.945 313.504L292.649 314.736Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952,
    d: "M292.179 316.121C292.433 316.26 292.23 322.027 291.951 327.806C291.684 333.585 291.329 339.389 291.316 339.643C291.29 340.152 290.998 340.634 290.44 340.952L287.355 342.679C287.342 342.679 286.656 343.073 286.656 343.073C286.618 343.085 282.898 345.143 282.847 345.143C282.416 345.372 281.895 345.499 281.362 345.511C281.336 345.511 281.311 345.511 281.285 345.511C280.803 345.511 280.346 345.384 280.003 345.194L278.708 344.356C278.251 344.089 277.972 343.67 277.972 343.2C277.972 342.692 278.276 342.209 278.822 341.879C278.81 341.853 284.447 337.624 284.485 337.599L284.879 337.306C285.31 337.052 285.869 336.913 286.415 336.913C286.567 336.913 286.923 334.69 287.291 331.718C287.52 329.927 287.786 327.857 288.04 325.799C288.408 322.891 288.777 319.995 289.043 317.937C289.284 316.07 289.488 314.889 289.564 314.94L292.179 316.121Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M291.71 317.506C291.964 317.658 291.773 323.12 291.519 328.607C291.265 334.094 290.91 339.606 290.884 339.86C290.846 340.343 290.58 340.8 290.046 341.105L287.063 342.769C287.05 342.781 286.402 343.137 286.39 343.15C286.326 343.175 282.771 345.131 282.708 345.118C282.289 345.334 281.794 345.449 281.273 345.461C281.248 345.461 281.222 345.461 281.197 345.461C280.74 345.461 280.283 345.334 279.953 345.144L278.696 344.344C278.251 344.09 277.997 343.683 277.985 343.239C277.972 342.743 278.264 342.286 278.784 341.981C278.772 341.943 284.117 337.917 284.181 337.879L284.561 337.599C284.968 337.358 285.514 337.218 286.034 337.218C286.174 337.218 286.542 335.097 286.91 332.277C287.126 330.575 287.418 328.607 287.672 326.651C288.04 323.895 288.421 321.151 288.688 319.208C288.929 317.442 289.132 316.337 289.208 316.375L291.71 317.506Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M291.24 318.89C291.494 319.043 291.328 324.212 291.075 329.407C290.833 334.602 290.491 339.822 290.452 340.063C290.402 340.52 290.16 340.952 289.653 341.244L286.783 342.845C286.77 342.857 286.148 343.2 286.123 343.213C286.034 343.251 282.644 345.093 282.555 345.08C282.149 345.283 281.666 345.385 281.171 345.398C281.146 345.398 281.12 345.398 281.108 345.398C280.676 345.398 280.219 345.271 279.914 345.093L278.708 344.318C278.289 344.077 278.035 343.696 278.022 343.264C278.01 342.794 278.289 342.362 278.771 342.07C278.746 342.006 283.812 338.196 283.888 338.145L284.244 337.879C284.625 337.65 285.158 337.51 285.653 337.51C285.793 337.51 286.161 335.478 286.516 332.823C286.732 331.198 287.024 329.343 287.291 327.489C287.659 324.885 288.065 322.307 288.319 320.478C288.548 318.814 288.764 317.772 288.84 317.811L291.24 318.89Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M290.77 320.287C291.024 320.439 290.871 325.316 290.643 330.219C290.414 335.122 290.072 340.037 290.033 340.291C289.97 340.723 289.754 341.129 289.272 341.396L286.504 342.933C286.491 342.946 285.894 343.276 285.869 343.276C285.755 343.327 282.542 345.067 282.428 345.041C282.035 345.232 281.577 345.321 281.108 345.321C281.082 345.321 281.07 345.321 281.044 345.321C280.638 345.321 280.194 345.181 279.902 345.016L278.733 344.279C278.327 344.051 278.099 343.682 278.086 343.276C278.073 342.831 278.327 342.425 278.784 342.133C278.759 342.057 283.52 338.45 283.634 338.386L283.977 338.132C284.345 337.916 284.853 337.776 285.31 337.776C285.437 337.776 285.831 335.846 286.174 333.331C286.39 331.794 286.694 330.041 286.961 328.301C287.342 325.837 287.748 323.424 288.002 321.709C288.231 320.147 288.446 319.182 288.51 319.22L290.77 320.287Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M290.3 321.671C290.554 321.823 290.414 326.409 290.199 331.019C289.983 335.63 289.653 340.253 289.602 340.494C289.538 340.901 289.335 341.282 288.891 341.536L286.225 343.009C286.199 343.022 285.64 343.339 285.615 343.339C285.488 343.39 282.428 345.029 282.301 345.003C281.933 345.181 281.476 345.257 281.032 345.257C281.006 345.257 280.993 345.257 280.968 345.257C280.587 345.257 280.143 345.118 279.876 344.965L278.759 344.254C278.378 344.038 278.149 343.695 278.137 343.314C278.124 342.895 278.353 342.501 278.784 342.234C278.746 342.145 283.228 338.742 283.355 338.665L283.672 338.424C284.015 338.234 284.51 338.081 284.942 338.081C285.056 338.081 285.463 336.239 285.793 333.89C285.996 332.442 286.313 330.791 286.593 329.152C286.974 326.84 287.405 324.58 287.647 322.992C287.875 321.519 288.091 320.63 288.154 320.668L290.3 321.671Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M289.831 323.056C290.085 323.208 289.97 327.501 289.767 331.82C289.564 336.138 289.234 340.469 289.183 340.711C289.107 341.092 288.929 341.447 288.51 341.689L285.958 343.098C285.933 343.111 285.4 343.403 285.374 343.416C285.222 343.48 282.34 345.004 282.175 344.978C281.819 345.143 281.387 345.207 280.956 345.207C280.943 345.207 280.918 345.207 280.892 345.207C280.537 345.207 280.092 345.067 279.838 344.915L278.759 344.242C278.391 344.038 278.188 343.708 278.162 343.352C278.137 342.959 278.353 342.59 278.746 342.324C278.708 342.222 282.898 339.009 283.051 338.932L283.355 338.717C283.673 338.539 284.155 338.399 284.549 338.399C284.663 338.399 285.069 336.659 285.4 334.462C285.603 333.09 285.92 331.553 286.199 330.016C286.58 327.857 287.025 325.749 287.266 324.275C287.482 322.904 287.71 322.091 287.774 322.129L289.831 323.056Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M289.373 324.453C289.627 324.606 289.526 328.607 289.335 332.62C289.145 336.646 288.865 340.685 288.764 340.914C288.751 341.27 288.523 341.6 288.129 341.828L285.678 343.175C285.653 343.188 285.158 343.467 285.12 343.48C284.942 343.556 282.225 344.978 282.047 344.94C281.704 345.093 281.285 345.143 280.879 345.143C280.866 345.143 280.841 345.143 280.828 345.143C280.498 345.143 280.067 344.991 279.825 344.864L278.784 344.216C278.441 344.013 278.238 343.708 278.213 343.378C278.187 343.01 278.391 342.654 278.746 342.413C278.695 342.298 282.606 339.288 282.784 339.199L283.063 338.996C283.355 338.831 283.812 338.691 284.193 338.691C284.295 338.691 284.726 337.04 285.044 335.008C285.247 333.725 285.577 332.29 285.856 330.867C286.25 328.861 286.707 326.917 286.935 325.546C287.151 324.275 287.38 323.539 287.431 323.564L289.373 324.453Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M288.904 325.838C289.158 325.99 289.081 329.699 288.904 333.42C288.726 337.154 288.459 340.901 288.345 341.13C288.332 341.46 288.116 341.765 287.748 341.981L285.412 343.264C285.374 343.276 284.917 343.543 284.879 343.556C284.688 343.632 282.124 344.953 281.933 344.915C281.603 345.054 281.209 345.093 280.816 345.08C280.803 345.08 280.778 345.08 280.765 345.08C280.46 345.08 280.029 344.927 279.813 344.8L278.823 344.178C278.505 343.988 278.302 343.708 278.289 343.391C278.264 343.048 278.442 342.717 278.772 342.489C278.721 342.362 282.339 339.555 282.53 339.453L282.797 339.263C283.063 339.11 283.508 338.971 283.863 338.971C283.952 338.971 284.396 337.421 284.701 335.541C284.892 334.347 285.247 333.014 285.526 331.693C285.933 329.838 286.39 328.048 286.618 326.803C286.834 325.634 287.063 324.961 287.113 324.987L288.904 325.838Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M288.434 327.222C288.688 327.374 288.624 330.791 288.459 334.22C288.294 337.662 288.04 341.117 287.913 341.333C287.9 341.638 287.697 341.93 287.355 342.12L285.12 343.34C285.082 343.365 284.65 343.594 284.612 343.619C284.396 343.708 282.009 344.927 281.781 344.877C281.463 344.991 281.095 345.029 280.727 345.016C280.714 345.016 280.701 345.016 280.676 345.016C280.397 345.016 279.965 344.864 279.775 344.75L278.822 344.165C278.518 343.988 278.34 343.721 278.314 343.429C278.289 343.098 278.441 342.794 278.746 342.578C278.683 342.438 282.022 339.834 282.238 339.707L282.479 339.529C282.733 339.39 283.152 339.25 283.469 339.25C283.558 339.25 284.003 337.789 284.307 336.075C284.498 334.957 284.853 333.738 285.145 332.518C285.552 330.816 286.034 329.178 286.25 328.047C286.453 326.981 286.694 326.384 286.745 326.409L288.434 327.222Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M287.964 328.619C288.218 328.771 288.167 331.896 288.027 335.033C287.875 338.183 287.634 341.346 287.494 341.561C287.469 341.841 287.291 342.108 286.974 342.285L284.853 343.441C284.815 343.467 284.409 343.683 284.371 343.708C284.129 343.81 281.908 344.915 281.666 344.864C281.362 344.965 281.006 344.991 280.663 344.978C280.651 344.978 280.638 344.978 280.625 344.978C280.371 344.978 279.952 344.826 279.762 344.711L278.86 344.152C278.581 343.987 278.403 343.746 278.378 343.467C278.34 343.162 278.492 342.882 278.759 342.679C278.695 342.527 281.742 340.126 281.971 339.986L282.2 339.821C282.428 339.694 282.834 339.555 283.126 339.555C283.203 339.555 283.672 338.196 283.952 336.633C284.142 335.605 284.51 334.474 284.802 333.382C285.209 331.832 285.704 330.359 285.92 329.343C286.123 328.378 286.364 327.844 286.415 327.87L287.964 328.619Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M287.494 330.003C287.748 330.156 287.723 332.988 287.583 335.833C287.456 338.691 287.215 341.549 287.063 341.765C287.037 342.019 286.872 342.26 286.58 342.425L284.561 343.517C284.523 343.543 284.155 343.746 284.104 343.771C283.838 343.873 281.781 344.876 281.527 344.826C281.235 344.914 280.905 344.927 280.575 344.915C280.562 344.915 280.549 344.915 280.536 344.915C280.308 344.915 279.889 344.749 279.724 344.66L278.86 344.14C278.594 343.987 278.441 343.759 278.403 343.517C278.365 343.238 278.492 342.984 278.734 342.793C278.657 342.616 281.425 340.431 281.679 340.279L281.882 340.126C282.085 340.012 282.479 339.872 282.733 339.872C282.809 339.872 283.279 338.602 283.558 337.205C283.749 336.252 284.117 335.236 284.422 334.245C284.841 332.848 285.336 331.527 285.552 330.626C285.755 329.762 285.996 329.305 286.034 329.33L287.494 330.003Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M287.024 331.388C287.278 331.54 287.265 334.08 287.151 336.633C287.037 339.186 286.808 341.765 286.643 341.981C286.618 342.209 286.465 342.425 286.212 342.578L284.294 343.606C284.244 343.632 283.913 343.822 283.863 343.835C283.583 343.949 281.692 344.851 281.4 344.788C281.12 344.864 280.803 344.864 280.498 344.838C280.485 344.838 280.473 344.838 280.46 344.838C280.257 344.838 279.838 344.673 279.698 344.584L278.886 344.089C278.644 343.949 278.492 343.746 278.454 343.517C278.416 343.263 278.517 343.022 278.733 342.844C278.657 342.654 281.133 340.672 281.412 340.507L281.603 340.368C281.78 340.266 282.161 340.139 282.39 340.139C282.453 340.139 282.949 338.97 283.215 337.726C283.393 336.862 283.787 335.948 284.079 335.058C284.498 333.801 285.018 332.658 285.221 331.87C285.412 331.108 285.666 330.727 285.704 330.74L287.024 331.388Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M286.555 332.785C286.809 332.938 286.821 335.186 286.707 337.447C286.605 339.708 286.39 341.994 286.212 342.21C286.186 342.413 286.047 342.603 285.818 342.743L284.015 343.708C283.964 343.734 283.66 343.899 283.609 343.924C283.304 344.051 281.577 344.839 281.273 344.775C281.006 344.839 280.714 344.826 280.422 344.801C280.409 344.801 280.397 344.801 280.397 344.801C280.219 344.801 279.813 344.636 279.686 344.559L278.911 344.102C278.695 343.975 278.556 343.785 278.518 343.581C278.479 343.353 278.556 343.137 278.746 342.972C278.657 342.769 280.841 340.99 281.146 340.813L281.324 340.686C281.489 340.597 281.844 340.47 282.047 340.47C282.098 340.47 282.619 339.39 282.86 338.31C283.038 337.523 283.431 336.723 283.736 335.948C284.168 334.843 284.688 333.865 284.891 333.179C285.082 332.519 285.336 332.201 285.374 332.227L286.555 332.785Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M286.085 334.169C286.339 334.322 286.364 336.278 286.275 338.246C286.186 340.215 285.983 342.209 285.793 342.412C285.767 342.59 285.64 342.755 285.437 342.882L283.736 343.784C283.685 343.809 283.406 343.962 283.342 343.987C283.012 344.127 281.463 344.813 281.133 344.737C280.879 344.787 280.6 344.762 280.346 344.737C280.333 344.737 280.333 344.737 280.321 344.737C280.168 344.737 279.762 344.559 279.648 344.495L278.911 344.064C278.708 343.949 278.581 343.784 278.543 343.594C278.505 343.39 278.568 343.187 278.721 343.035C278.632 342.819 280.524 341.244 280.854 341.053L281.006 340.952C281.146 340.875 281.489 340.748 281.654 340.748C281.704 340.748 282.238 339.77 282.466 338.843C282.644 338.145 283.05 337.446 283.355 336.773C283.787 335.82 284.206 334.957 284.523 334.423C284.599 333.839 284.968 333.623 284.993 333.636L286.085 334.169Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M285.615 335.554C285.869 335.707 285.907 337.37 285.831 339.047C285.755 340.724 285.564 342.426 285.349 342.629C285.323 342.781 285.209 342.921 285.031 343.023L283.444 343.861C283.381 343.899 283.139 344.026 283.076 344.051C282.733 344.191 281.336 344.775 280.981 344.699C280.74 344.737 280.486 344.699 280.245 344.674C280.232 344.674 280.232 344.674 280.219 344.674C280.092 344.674 279.686 344.496 279.597 344.445L278.911 344.051C278.734 343.95 278.607 343.797 278.569 343.632C278.518 343.454 278.569 343.277 278.696 343.137C278.594 342.908 280.206 341.536 280.549 341.333L280.689 341.244C280.803 341.181 281.121 341.054 281.273 341.054C281.311 341.054 281.87 340.165 282.073 339.403C282.251 338.78 282.657 338.196 282.974 337.625C283.419 336.824 283.838 336.113 284.155 335.707C284.219 335.211 284.599 335.072 284.625 335.084L285.615 335.554Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M285.145 336.938C285.399 337.091 285.463 338.462 285.399 339.847C285.336 341.231 285.158 342.628 284.929 342.832C284.904 342.959 284.802 343.086 284.65 343.162L283.165 343.937C283.101 343.975 282.898 344.089 282.822 344.114C282.454 344.267 281.222 344.737 280.854 344.661C280.625 344.686 280.397 344.635 280.168 344.597H280.155C280.054 344.597 279.66 344.419 279.584 344.368L278.937 344C278.772 343.911 278.67 343.784 278.619 343.632C278.568 343.479 278.594 343.314 278.683 343.2C278.581 342.959 279.902 341.79 280.27 341.574L280.384 341.498C280.473 341.447 280.778 341.32 280.892 341.32C280.917 341.32 281.616 340.558 281.692 339.923C281.958 339.415 282.288 338.907 282.606 338.45C283.05 337.802 283.482 337.243 283.799 336.951C283.85 336.557 284.256 336.494 284.269 336.506L285.145 336.938Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M284.675 338.335C284.929 338.488 285.005 339.567 284.955 340.66C284.904 341.752 284.739 342.857 284.498 343.06C284.459 343.162 284.383 343.263 284.256 343.327L282.872 344.038C282.809 344.076 282.631 344.165 282.555 344.203C282.161 344.368 281.108 344.737 280.714 344.648C280.498 344.66 280.282 344.597 280.079 344.559H280.066C279.99 344.559 279.597 344.368 279.546 344.343L278.949 344C278.809 343.924 278.708 343.809 278.67 343.695C278.619 343.555 278.632 343.428 278.682 343.314C278.581 343.06 279.609 342.095 279.99 341.866L280.092 341.803C280.155 341.765 280.447 341.638 280.536 341.638C280.562 341.638 281.273 340.964 281.323 340.494C281.59 340.075 281.92 339.669 282.25 339.313C282.695 338.818 283.139 338.411 283.456 338.246C283.495 337.954 283.914 337.967 283.926 337.967L284.675 338.335Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M284.206 339.72C284.473 339.872 284.561 340.66 284.523 341.46C284.485 342.26 284.32 343.073 284.079 343.263C284.041 343.34 283.977 343.416 283.876 343.467L282.606 344.114C282.543 344.152 282.39 344.229 282.314 344.267C281.895 344.432 281.006 344.699 280.587 344.61C280.384 344.597 280.181 344.559 280.003 344.495H279.991C279.94 344.495 279.546 344.305 279.508 344.279L278.949 343.975C278.835 343.911 278.746 343.81 278.696 343.721C278.645 343.606 278.632 343.505 278.657 343.403C278.543 343.136 279.292 342.374 279.699 342.133L279.775 342.082C279.826 342.057 280.092 341.93 280.156 341.93C280.168 341.93 280.905 341.358 280.943 341.041C281.21 340.71 281.552 340.406 281.87 340.152C282.314 339.809 282.771 339.555 283.089 339.504C283.114 339.313 283.546 339.389 283.546 339.402L284.206 339.72Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M283.736 341.104C284.002 341.256 284.104 341.752 284.079 342.26C284.053 342.768 283.876 343.251 283.647 343.479C283.609 343.53 283.558 343.581 283.482 343.619L282.314 344.203C282.238 344.241 282.123 344.305 282.047 344.343C281.616 344.521 280.892 344.673 280.447 344.584C280.257 344.559 280.079 344.521 279.914 344.444C279.889 344.444 279.508 344.254 279.482 344.241L278.975 343.962C278.873 343.898 278.797 343.835 278.746 343.759C278.683 343.67 278.657 343.581 278.657 343.492C278.543 343.2 279 342.654 279.432 342.4L279.495 342.361C279.521 342.349 279.774 342.234 279.8 342.234C279.813 342.234 280.562 341.752 280.587 341.599C280.866 341.358 281.197 341.155 281.527 341.002C281.984 340.812 282.441 340.71 282.758 340.786C282.771 340.685 283.215 340.85 283.215 340.85L283.736 341.104Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.863 344.368L279.013 343.924C278.454 343.593 278.517 343.034 279.165 342.653L280.219 342.133C280.866 341.752 281.857 341.713 282.415 342.044L283.266 342.488C283.825 342.819 283.761 343.377 283.114 343.758L282.06 344.279C281.412 344.66 280.422 344.698 279.863 344.368Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0476,
    d: "M310.5 321.989C310.767 322.142 310.627 328.797 310.412 335.478C310.196 342.159 309.904 348.865 309.904 349.132C309.891 349.703 309.548 350.237 308.926 350.605L305.498 352.523L304.723 352.955C304.698 352.968 300.521 355.292 300.508 355.279C300.038 355.546 299.454 355.698 298.858 355.711C298.832 355.711 298.794 355.711 298.769 355.711C298.235 355.711 297.728 355.584 297.334 355.355L295.899 354.428C295.379 354.123 295.087 353.653 295.074 353.133C295.074 352.561 295.429 352.015 296.039 351.659C296.026 351.647 302.527 346.782 302.552 346.769L302.857 346.541C303.34 346.261 303.962 346.096 304.584 346.096C304.762 346.096 305.104 343.442 305.473 339.86C305.676 337.853 305.917 335.542 306.145 333.255C306.476 329.877 306.818 326.511 307.072 324.11C307.301 321.964 307.491 320.592 307.58 320.643L310.5 321.989Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952,
    d: "M310.018 323.513C310.285 323.666 310.158 330.004 309.955 336.354C309.751 342.705 309.459 349.094 309.447 349.36C309.421 349.906 309.104 350.415 308.507 350.757L305.193 352.612C305.181 352.612 304.444 353.031 304.444 353.031C304.393 353.056 300.407 355.266 300.356 355.254C299.899 355.508 299.327 355.635 298.756 355.647C298.731 355.647 298.705 355.647 298.667 355.647C298.159 355.647 297.651 355.52 297.283 355.304L295.887 354.403C295.391 354.111 295.099 353.666 295.099 353.158C295.087 352.612 295.43 352.091 296.014 351.748C296.001 351.723 302.172 347.087 302.222 347.049L302.514 346.833C302.971 346.566 303.581 346.401 304.165 346.401C304.33 346.401 304.685 343.848 305.041 340.457C305.244 338.539 305.498 336.342 305.727 334.157C306.069 330.944 306.425 327.756 306.679 325.482C306.907 323.437 307.098 322.142 307.187 322.192L310.018 323.513Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M309.536 325.038C309.802 325.19 309.688 331.198 309.497 337.231C309.307 343.264 309.015 349.322 308.99 349.589C308.952 350.11 308.66 350.593 308.088 350.923L304.889 352.701C304.876 352.714 304.178 353.095 304.165 353.107C304.089 353.133 300.28 355.229 300.204 355.216C299.759 355.457 299.213 355.572 298.667 355.584C298.642 355.584 298.616 355.584 298.591 355.584C298.109 355.584 297.613 355.445 297.258 355.241L295.912 354.378C295.442 354.098 295.163 353.666 295.15 353.196C295.138 352.676 295.455 352.18 296.014 351.85C295.988 351.799 301.854 347.392 301.918 347.354L302.197 347.151C302.641 346.897 303.225 346.744 303.771 346.744C303.924 346.744 304.305 344.306 304.647 341.092C304.851 339.263 305.117 337.18 305.358 335.11C305.714 332.062 306.082 329.039 306.336 326.905C306.565 324.974 306.768 323.755 306.844 323.806L309.536 325.038Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M309.053 326.561C309.32 326.714 309.231 332.404 309.04 338.119C308.863 343.835 308.571 349.563 308.533 349.83C308.482 350.325 308.215 350.783 307.682 351.087L304.597 352.802C304.584 352.815 303.911 353.183 303.898 353.196C303.809 353.234 300.165 355.215 300.077 355.203C299.645 355.418 299.124 355.533 298.591 355.533C298.566 355.533 298.54 355.533 298.515 355.533C298.058 355.533 297.563 355.393 297.233 355.203L295.937 354.377C295.48 354.11 295.214 353.704 295.214 353.247C295.201 352.751 295.493 352.281 296.014 351.964C295.988 351.9 301.537 347.709 301.626 347.658L301.892 347.455C302.311 347.213 302.87 347.061 303.403 347.061C303.556 347.061 303.936 344.737 304.279 341.701C304.482 339.961 304.749 337.992 305.003 336.036C305.358 333.153 305.752 330.308 305.993 328.301C306.209 326.472 306.425 325.342 306.501 325.393L309.053 326.561Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M308.571 328.086C308.85 328.238 308.761 333.611 308.583 338.996C308.406 344.381 308.126 349.792 308.088 350.059C308.025 350.516 307.784 350.96 307.276 351.253L304.305 352.904C304.279 352.916 303.644 353.272 303.632 353.272C303.517 353.323 300.051 355.19 299.937 355.165C299.518 355.368 299.023 355.469 298.515 355.469C298.49 355.469 298.464 355.469 298.439 355.469C298.007 355.469 297.525 355.33 297.207 355.152L295.95 354.352C295.519 354.098 295.265 353.717 295.252 353.285C295.239 352.815 295.506 352.37 296.001 352.065C295.963 351.989 301.194 348.026 301.308 347.963L301.562 347.772C301.956 347.544 302.502 347.391 302.997 347.391C303.137 347.391 303.543 345.169 303.873 342.324C304.076 340.672 304.355 338.818 304.609 336.976C304.978 334.258 305.384 331.591 305.625 329.699C305.841 327.984 306.057 326.93 306.133 326.968L308.571 328.086Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M308.088 329.597C308.367 329.749 308.291 334.792 308.126 339.859C307.961 344.927 307.669 350.008 307.631 350.274C307.555 350.706 307.339 351.125 306.869 351.392L304.012 352.967C303.987 352.98 303.39 353.31 303.365 353.323C303.225 353.386 299.949 355.139 299.797 355.114C299.391 355.304 298.908 355.393 298.426 355.393C298.4 355.393 298.388 355.393 298.362 355.393C297.956 355.393 297.474 355.241 297.182 355.075L295.975 354.313C295.569 354.072 295.328 353.704 295.303 353.297C295.277 352.853 295.531 352.421 295.988 352.141C295.95 352.053 300.864 348.306 301.003 348.23L301.245 348.052C301.613 347.836 302.133 347.683 302.603 347.683C302.73 347.683 303.149 345.575 303.479 342.908C303.67 341.358 303.974 339.605 304.228 337.878C304.609 335.325 305.028 332.836 305.269 331.07C305.485 329.457 305.701 328.492 305.777 328.53L308.088 329.597Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M307.593 331.121C307.872 331.274 307.809 335.999 307.656 340.736C307.504 345.474 307.212 350.237 307.161 350.491C307.085 350.897 306.882 351.278 306.437 351.545L303.695 353.056C303.669 353.069 303.098 353.387 303.073 353.399C302.908 353.463 299.81 355.114 299.645 355.076C299.251 355.254 298.794 355.317 298.337 355.317C298.311 355.317 298.299 355.317 298.273 355.317C297.892 355.317 297.423 355.165 297.143 355.012L295.988 354.288C295.594 354.06 295.366 353.717 295.353 353.336C295.328 352.917 295.569 352.51 295.988 352.243C295.937 352.142 300.546 348.624 300.698 348.522L300.914 348.357C301.257 348.166 301.765 348.014 302.197 348.014C302.324 348.014 302.755 346.02 303.073 343.518C303.263 342.057 303.581 340.419 303.847 338.793C304.228 336.405 304.673 334.081 304.901 332.455C305.117 330.956 305.345 330.067 305.409 330.105L307.593 331.121Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M307.11 332.646C307.39 332.798 307.339 337.205 307.199 341.625C307.06 346.045 306.818 350.491 306.704 350.732C306.691 351.113 306.438 351.469 306.019 351.71L303.39 353.145C303.365 353.158 302.832 353.463 302.794 353.476C302.603 353.552 299.683 355.089 299.492 355.038C299.124 355.203 298.68 355.254 298.235 355.254C298.223 355.254 298.197 355.254 298.172 355.254C297.816 355.254 297.347 355.101 297.093 354.949L295.975 354.25C295.607 354.034 295.391 353.717 295.366 353.349C295.341 352.955 295.556 352.574 295.937 352.32C295.887 352.193 300.165 348.903 300.356 348.802L300.559 348.649C300.876 348.471 301.372 348.319 301.765 348.319C301.879 348.319 302.324 346.426 302.641 344.115C302.832 342.743 303.162 341.219 303.428 339.707C303.822 337.497 304.279 335.338 304.508 333.839C304.711 332.455 304.952 331.642 305.015 331.668L307.11 332.646Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M306.628 334.17C306.907 334.335 306.869 338.399 306.742 342.502C306.615 346.604 306.374 350.719 306.26 350.961C306.247 351.316 306.006 351.646 305.625 351.875L303.111 353.247C303.073 353.272 302.578 353.539 302.54 353.564C302.324 353.653 299.581 355.063 299.378 355.025C299.023 355.165 298.604 355.215 298.185 355.203C298.172 355.203 298.147 355.203 298.134 355.203C297.816 355.203 297.347 355.038 297.105 354.911L296.039 354.25C295.696 354.047 295.493 353.742 295.468 353.412C295.442 353.044 295.633 352.688 295.988 352.434C295.925 352.294 299.899 349.22 300.102 349.106L300.292 348.966C300.584 348.801 301.054 348.649 301.435 348.649C301.537 348.649 302.006 346.871 302.311 344.737C302.502 343.454 302.844 342.044 303.111 340.647C303.517 338.602 303.987 336.621 304.216 335.249C304.419 333.966 304.66 333.242 304.723 333.268L306.628 334.17Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M306.146 335.694C306.425 335.859 306.399 339.606 306.285 343.378C306.158 347.15 305.942 350.948 305.803 351.189C305.79 351.52 305.574 351.824 305.206 352.028L302.806 353.336C302.768 353.361 302.298 353.615 302.26 353.628C302.032 353.73 299.467 355.025 299.226 354.974C298.883 355.101 298.477 355.139 298.083 355.127C298.07 355.127 298.045 355.127 298.032 355.127C297.74 355.127 297.271 354.962 297.055 354.835L296.039 354.2C295.722 354.009 295.518 353.73 295.493 353.412C295.468 353.069 295.633 352.739 295.963 352.498C295.899 352.345 299.543 349.5 299.785 349.36L299.962 349.233C300.229 349.081 300.686 348.929 301.029 348.929C301.118 348.929 301.613 347.265 301.905 345.309C302.095 344.115 302.438 342.819 302.73 341.536C303.149 339.657 303.632 337.853 303.847 336.608C304.051 335.44 304.305 334.779 304.355 334.817L306.146 335.694Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M305.663 337.205C305.942 337.37 305.929 340.799 305.828 344.254C305.714 347.709 305.498 351.176 305.345 351.417C305.32 351.722 305.13 352.002 304.787 352.192L302.501 353.424C302.463 353.45 302.032 353.691 301.981 353.704C301.727 353.805 299.34 354.999 299.073 354.948C298.743 355.063 298.362 355.088 297.994 355.063C297.981 355.063 297.969 355.063 297.943 355.063C297.677 355.063 297.22 354.898 297.016 354.783L296.039 354.186C295.734 354.009 295.556 353.755 295.518 353.462C295.48 353.145 295.632 352.84 295.925 352.611C295.848 352.446 299.188 349.817 299.441 349.677L299.607 349.563C299.848 349.423 300.292 349.284 300.597 349.284C300.686 349.284 301.181 347.721 301.473 345.956C301.651 344.851 302.019 343.67 302.311 342.489C302.73 340.774 303.238 339.148 303.454 338.03C303.657 336.963 303.911 336.392 303.949 336.417L305.663 337.205Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M305.168 338.729C305.447 338.894 305.46 342.006 305.358 345.131C305.257 348.268 305.041 351.418 304.876 351.646C304.85 351.926 304.673 352.18 304.368 352.358L302.197 353.526C302.146 353.552 301.752 353.768 301.702 353.793C301.422 353.907 299.213 354.987 298.934 354.923C298.616 355.025 298.261 355.025 297.905 355.012C297.893 355.012 297.88 355.012 297.867 355.012C297.626 355.012 297.169 354.834 296.991 354.733L296.064 354.174C295.785 354.009 295.607 353.768 295.582 353.501C295.544 353.209 295.671 352.917 295.937 352.713C295.861 352.523 298.883 350.135 299.162 349.97L299.302 349.868C299.518 349.741 299.937 349.602 300.216 349.602C300.292 349.602 300.813 348.154 301.092 346.566C301.27 345.55 301.651 344.47 301.943 343.416C302.375 341.867 302.895 340.419 303.111 339.415C303.314 338.463 303.568 337.967 303.606 337.993L305.168 338.729Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M304.685 340.253C304.964 340.419 304.99 343.2 304.901 346.007C304.812 348.814 304.609 351.646 304.431 351.875C304.406 352.116 304.241 352.358 303.961 352.51L301.904 353.615C301.854 353.64 301.498 353.844 301.435 353.869C301.13 353.996 299.099 354.961 298.794 354.898C298.489 354.987 298.159 354.974 297.829 354.961C297.816 354.961 297.803 354.961 297.791 354.961C297.575 354.961 297.131 354.784 296.965 354.695L296.089 354.161C295.835 354.009 295.67 353.793 295.632 353.552C295.594 353.285 295.696 353.018 295.924 352.828C295.835 352.624 298.54 350.452 298.845 350.275L298.972 350.186C299.162 350.071 299.568 349.932 299.81 349.932C299.873 349.932 300.419 348.598 300.686 347.176C300.863 346.248 301.257 345.283 301.549 344.343C301.993 342.959 302.527 341.689 302.73 340.812C302.933 339.974 303.187 339.555 303.225 339.58L304.685 340.253Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M304.203 341.777C304.482 341.943 304.52 344.407 304.444 346.896C304.368 349.386 304.165 351.888 303.974 352.116C303.949 352.332 303.797 352.535 303.543 352.688L301.6 353.717C301.549 353.755 301.219 353.933 301.156 353.958C300.826 354.098 298.972 354.936 298.642 354.872C298.35 354.936 298.045 354.923 297.728 354.898C297.715 354.898 297.702 354.898 297.69 354.898C297.499 354.898 297.055 354.72 296.915 354.631L296.077 354.136C295.836 353.996 295.696 353.793 295.645 353.577C295.607 353.336 295.696 353.094 295.887 352.916C295.798 352.701 298.185 350.757 298.515 350.567L298.629 350.478C298.794 350.376 299.175 350.249 299.404 350.249C299.467 350.249 300.026 349.017 300.28 347.785C300.457 346.947 300.864 346.096 301.168 345.27C301.613 344.051 302.171 342.959 302.375 342.209C302.578 341.485 302.844 341.142 302.87 341.155L304.203 341.777Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M303.721 343.302C304 343.467 304.051 345.613 303.974 347.772C303.911 349.932 303.708 352.116 303.505 352.345C303.479 352.535 303.34 352.713 303.124 352.84L301.295 353.805C301.232 353.844 300.94 353.996 300.876 354.021C300.521 354.161 298.858 354.898 298.502 354.834C298.223 354.885 297.931 354.86 297.652 354.834C297.639 354.834 297.639 354.834 297.626 354.834C297.461 354.834 297.029 354.644 296.915 354.58L296.128 354.123C295.912 353.996 295.772 353.818 295.734 353.628C295.684 353.412 295.76 353.196 295.925 353.031C295.823 352.802 297.905 351.075 298.248 350.871L298.35 350.795C298.502 350.706 298.858 350.579 299.048 350.579C299.099 350.579 299.683 349.462 299.924 348.407C300.102 347.658 300.508 346.921 300.826 346.21C301.283 345.156 301.727 344.191 302.057 343.619C302.121 342.971 302.527 342.743 302.552 342.755L303.721 343.302Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M303.238 344.813C303.517 344.978 303.581 346.794 303.517 348.636C303.454 350.478 303.276 352.332 303.048 352.548C303.022 352.713 302.895 352.866 302.705 352.98L300.991 353.882C300.927 353.92 300.673 354.059 300.597 354.085C300.216 354.237 298.731 354.86 298.35 354.783C298.096 354.822 297.817 354.783 297.55 354.745C297.537 354.745 297.537 354.745 297.525 354.745C297.385 354.745 296.953 354.555 296.864 354.504L296.128 354.072C295.937 353.958 295.81 353.805 295.76 353.628C295.709 353.437 295.76 353.247 295.887 353.094C295.785 352.853 297.537 351.341 297.918 351.125L298.007 351.062C298.134 350.986 298.477 350.859 298.629 350.859C298.667 350.859 299.277 349.843 299.505 348.979C299.683 348.319 300.102 347.696 300.419 347.086C300.889 346.197 301.334 345.41 301.664 344.965C301.714 344.432 302.133 344.28 302.159 344.292L303.238 344.813Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M302.755 346.338C303.035 346.503 303.111 348.001 303.06 349.526C303.009 351.05 302.832 352.574 302.603 352.79C302.565 352.93 302.463 353.057 302.311 353.145L300.711 353.971C300.648 354.009 300.419 354.136 300.343 354.162C299.949 354.327 298.629 354.835 298.235 354.746C297.994 354.771 297.74 354.708 297.499 354.682H297.486C297.385 354.682 296.953 354.492 296.877 354.441L296.179 354.047C296.013 353.946 295.886 353.806 295.848 353.666C295.798 353.501 295.823 353.336 295.925 353.196C295.81 352.93 297.258 351.659 297.651 351.431L297.715 351.38C297.816 351.329 298.134 351.189 298.261 351.189C298.299 351.189 299.073 350.313 299.137 349.602C299.416 349.068 299.746 348.522 300.076 348.027C300.546 347.316 301.016 346.693 301.346 346.376C301.384 345.944 301.829 345.88 301.841 345.88L302.755 346.338Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M302.26 347.861C302.54 348.027 302.628 349.208 302.59 350.402C302.552 351.596 302.374 352.815 302.133 353.018C302.095 353.132 302.006 353.234 301.879 353.31L300.394 354.072C300.318 354.11 300.127 354.212 300.051 354.25C299.632 354.428 298.489 354.822 298.07 354.733C297.842 354.746 297.613 354.669 297.385 354.644H297.372C297.296 354.644 296.864 354.441 296.813 354.415L296.166 354.06C296.013 353.971 295.912 353.856 295.861 353.729C295.81 353.59 295.81 353.45 295.874 353.323C295.76 353.044 296.89 351.989 297.296 351.748L297.347 351.71C297.423 351.672 297.728 351.545 297.816 351.545C297.842 351.545 298.642 350.783 298.692 350.249C298.972 349.805 299.315 349.373 299.645 348.992C300.127 348.446 300.597 347.988 300.94 347.811C300.978 347.493 301.422 347.493 301.435 347.506L302.26 347.861Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M301.778 349.385C302.057 349.551 302.159 350.414 302.133 351.278C302.108 352.154 301.943 353.043 301.676 353.247C301.638 353.323 301.562 353.412 301.46 353.463L300.089 354.161C300.013 354.199 299.86 354.288 299.772 354.314C299.327 354.491 298.375 354.783 297.918 354.682C297.702 354.669 297.486 354.631 297.296 354.555H297.283C297.232 354.555 296.813 354.352 296.775 354.326L296.178 353.996C296.051 353.92 295.963 353.831 295.899 353.717C295.836 353.602 295.823 353.475 295.861 353.374C295.734 353.082 296.547 352.256 296.991 352.002L297.029 351.977C297.08 351.951 297.372 351.824 297.423 351.824C297.435 351.824 298.261 351.176 298.299 350.821C298.578 350.465 298.921 350.148 299.264 349.881C299.746 349.5 300.229 349.22 300.571 349.157C300.597 348.941 301.054 349.03 301.067 349.043L301.778 349.385Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M301.295 350.91C301.575 351.075 301.702 351.608 301.676 352.167C301.664 352.726 301.461 353.247 301.219 353.488C301.168 353.539 301.118 353.59 301.054 353.64L299.797 354.263C299.721 354.314 299.594 354.364 299.505 354.403C299.035 354.593 298.261 354.758 297.791 354.669C297.588 354.644 297.398 354.593 297.22 354.517C297.194 354.517 296.775 354.314 296.763 354.301L296.217 354.009C296.115 353.945 296.026 353.869 295.976 353.793C295.912 353.704 295.887 353.602 295.887 353.513C295.76 353.209 296.255 352.599 296.712 352.332L296.737 352.32C296.763 352.307 297.029 352.18 297.067 352.18C297.08 352.18 297.931 351.634 297.944 351.456C298.236 351.202 298.578 350.986 298.934 350.821C299.429 350.605 299.924 350.491 300.267 350.567C300.28 350.465 300.762 350.63 300.762 350.63L301.295 350.91Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.144 354.44L296.229 353.97C295.62 353.627 295.696 353.018 296.394 352.611L297.537 352.053C298.235 351.646 299.289 351.608 299.899 351.951L300.813 352.421C301.422 352.764 301.346 353.373 300.648 353.78L299.505 354.339C298.807 354.745 297.753 354.796 297.144 354.44Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.52 261.989C301.41 262.484 292.293 274.906 291.113 277.814C289.932 280.723 290.77 294.478 290.77 294.478C290.77 294.478 290.554 293.945 291.849 294.504C294.338 295.571 293.766 296.485 293.766 296.485L297.575 281.802L307.25 272.772C307.25 272.759 307.631 261.493 304.52 261.989Z",
    fill: "url(#paint169_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.25 272.759C307.25 272.759 307.377 270.32 306.92 267.285C302.997 270.422 296.382 278.589 295.392 281.027C294.617 282.933 294.541 289.207 294.579 293.386L297.588 281.789L307.25 272.759Z",
    fill: "#CED3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.155 346.832C305.155 346.832 305.155 349.322 305.155 350.49C305.155 351.659 299.061 355.075 297.994 355.177C296.928 355.279 294.147 354.059 295.556 352.84C296.966 351.621 300.038 348.992 300.038 347.378C300.038 345.765 305.155 346.832 305.155 346.832Z",
    fill: "#4E0070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.165 346.668C304.165 347.468 304.228 348.649 304.228 349.284C304.228 350.453 298.947 353.997 297.88 354.098C297.258 354.149 295.747 353.412 295.595 352.803C295.582 352.815 295.557 352.828 295.544 352.841C294.135 354.06 296.915 355.279 297.982 355.178C299.048 355.076 305.143 351.672 305.143 350.491C305.143 349.323 305.143 346.833 305.143 346.833C305.143 346.833 304.749 346.757 304.165 346.668Z",
    fill: "#CED3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.796 335.605C286.796 335.605 287.672 338.755 288.142 339.911C288.599 341.066 283.558 343.899 281.743 344.686C279.94 345.474 276.829 343.848 278.175 342.883C279.521 341.905 282.39 339.504 282.162 337.79C281.933 336.062 286.796 335.605 286.796 335.605Z",
    fill: "#4E0070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.142 339.911C287.685 338.755 286.796 335.605 286.796 335.605C286.796 335.605 286.377 335.643 285.793 335.745C286.06 336.57 286.555 338.45 286.656 339.276C286.809 340.546 282.657 342.857 281.006 343.581C280.041 344 278.67 343.67 277.946 343.15C277.388 344.115 280.105 345.41 281.755 344.686C283.558 343.899 288.612 341.066 288.142 339.911Z",
    fill: "#CED3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.854 291.748C301.854 291.748 289.259 296.663 281.933 300.74C274.607 304.817 272.613 307.014 272.588 309.948C272.55 313.644 281.933 338.653 281.933 338.653C281.933 338.653 283.355 339.212 284.904 338.653C288.256 337.447 287.494 336.431 287.494 336.431L283.609 312.514L315.757 301.667L301.854 291.748Z",
    fill: "url(#paint170_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.31 297.781L308.736 296.65L282.987 310.393C281.832 311.003 281.222 312.298 281.463 313.581L286.174 338.095C288.015 337.142 287.482 336.418 287.482 336.418L283.596 312.502L308.977 303.941L310.31 297.781Z",
    fill: "#CED3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.901 294.745C308.901 294.745 298.858 311.752 297.639 314.952C296.166 318.826 299.569 347.963 299.569 347.963C299.569 347.963 300.623 348.941 302.883 349.017C305.13 349.106 305.803 348.268 305.803 348.268C305.803 348.268 307.948 320.731 308.228 319.156C308.507 317.581 318.918 311.802 321.813 309.275C327.197 304.55 323.197 291.76 323.197 291.76L308.901 294.745Z",
    fill: "url(#paint171_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.095 264.744C302.019 268.161 300.75 292.496 300.75 292.496C300.75 292.496 303.454 296.167 309.459 297.78C316.176 299.596 324.353 296.65 324.353 296.65C324.353 296.65 324.162 287.416 324.099 281.014C324.048 274.765 324.645 270.193 324.251 267.513C324.023 266.014 320.772 264.007 315.77 261.759C310.767 259.486 302.184 261.073 302.095 264.744Z",
    fill: "url(#paint172_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.093 264.897C318.093 267.564 311.262 270.371 311.262 270.371C311.262 270.371 307.872 267.615 307.872 264.897C307.872 263.271 310.158 261.963 312.976 261.963C315.808 261.95 318.093 263.271 318.093 264.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.113 293.157C291.113 293.157 290.034 295.38 289.665 296.142C289.31 296.904 289.373 300.448 290.44 301.235C291.506 302.023 293.754 299.152 293.754 299.152L294.185 294.186L291.113 293.157Z",
    fill: "#FFD4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.418 257.67C308.253 256.616 309.561 255.511 311.364 255.193C313.167 254.876 314.779 255.473 314.983 256.514L316.938 264.11C317.154 265.38 315.579 266.713 313.395 267.094C311.224 267.475 309.282 266.751 309.053 265.494L308.418 257.67Z",
    fill: "#FFD4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.284 260.337C314.602 259.181 314.741 257.429 314.513 255.777C313.878 255.219 312.672 254.965 311.364 255.193C309.561 255.511 308.241 256.616 308.418 257.67C308.418 257.67 309.053 265.494 309.066 265.494C309.117 265.773 309.256 266.015 309.459 266.243C311.783 265.24 313.726 262.357 314.284 260.337Z",
    fill: "#F1D5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.676 252.361C304.203 255.308 305.879 264.757 308.875 264.681C311.872 264.618 314.589 260.871 315.275 258.419C315.96 255.968 315.821 250.862 313.167 249.706C310.501 248.551 307.174 249.376 305.676 252.361Z",
    fill: "#FFD4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.959 294.872L319.464 297.577C319.464 306.887 316.709 307.84 310.793 312.4C306.146 315.969 305.498 317.061 305.498 322.561C305.498 327.044 304.939 343.086 304.724 348.84C305.511 348.611 305.79 348.281 305.79 348.281C305.79 348.281 307.936 320.744 308.215 319.17C308.495 317.595 318.906 311.816 321.801 309.288C325.508 306.024 324.784 298.975 323.959 294.872Z",
    fill: "#CED3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.073 251.878C302.527 253.872 304.089 255.765 307.631 255.485C311.173 255.219 312.735 254.393 312.735 254.393C312.735 254.393 312.875 257.251 313.281 257.327C313.687 257.391 313.967 255.219 314.843 255.562C315.731 255.905 315.02 259.016 315.77 259.55C316.519 260.096 316.811 258.28 316.811 256.095C316.811 253.91 317.293 248.36 312.456 248.017C307.644 247.687 303.53 250.227 303.073 251.878Z",
    fill: "url(#paint173_linear_195_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.505 312.996L282.263 300.727C281.895 300.511 281.704 300.219 281.692 299.927V298.873C281.704 298.504 281.971 299.139 282.492 298.847L294.553 291.887C295.518 291.328 296.991 291.265 297.829 291.747L319.071 304.017C319.35 304.182 319.553 303.496 319.629 303.712C319.655 303.788 319.642 304.753 319.642 304.817C319.655 305.198 319.375 305.592 318.842 305.896L306.78 312.857C305.815 313.416 304.342 313.479 303.505 312.996Z",
    fill: "#2D3259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.504 311.955L282.263 299.686C281.425 299.203 281.526 298.352 282.504 297.793L294.566 290.833C295.531 290.274 297.003 290.21 297.841 290.693L319.083 302.962C319.921 303.445 319.819 304.296 318.842 304.855L306.78 311.815C305.815 312.387 304.342 312.438 303.504 311.955Z",
    fill: "#858FD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.927 311.866C304.444 311.866 304.025 311.765 303.72 311.6L282.479 299.33C282.352 299.254 282.123 299.089 282.123 298.873C282.123 298.644 282.339 298.39 282.707 298.174L294.769 291.214C295.214 290.96 295.81 290.808 296.407 290.808C296.89 290.808 297.309 290.909 297.613 291.074L318.855 303.344C318.982 303.42 319.21 303.585 319.21 303.801C319.21 304.03 318.994 304.284 318.626 304.5L306.564 311.46C306.12 311.714 305.523 311.866 304.927 311.866Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.558 309.046L287.304 299.089C286.961 298.885 286.999 298.542 287.405 298.314L293.88 294.58C294.274 294.351 294.884 294.326 295.226 294.529L312.481 304.487C312.824 304.69 312.786 305.033 312.38 305.261L305.904 309.008C305.511 309.224 304.914 309.25 304.558 309.046Z",
    fill: "#858FD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.261 295.291L295.366 295.926C295.506 296.002 295.734 296.002 295.874 295.926C296.014 295.85 296.014 295.71 295.874 295.634L294.769 294.999C294.63 294.922 294.401 294.922 294.261 294.999C294.122 295.075 294.122 295.214 294.261 295.291ZM296.153 296.383L296.674 296.688C296.813 296.764 297.042 296.764 297.182 296.688C297.321 296.612 297.321 296.472 297.182 296.396L296.661 296.091C296.521 296.015 296.293 296.015 296.153 296.091C296.014 296.18 296.014 296.307 296.153 296.383ZM297.461 297.145L297.982 297.45C298.121 297.526 298.35 297.526 298.489 297.45C298.629 297.374 298.629 297.234 298.489 297.158L297.969 296.853C297.829 296.777 297.601 296.777 297.461 296.853C297.321 296.929 297.321 297.056 297.461 297.145ZM298.781 297.894L299.302 298.199C299.442 298.275 299.67 298.275 299.81 298.199C299.95 298.123 299.95 297.983 299.81 297.907L299.289 297.602C299.15 297.526 298.921 297.526 298.781 297.602C298.642 297.691 298.642 297.818 298.781 297.894ZM300.089 298.657L300.61 298.961C300.749 299.038 300.978 299.038 301.118 298.961C301.257 298.885 301.257 298.745 301.118 298.669L300.597 298.364C300.457 298.288 300.229 298.288 300.089 298.364C299.95 298.441 299.95 298.58 300.089 298.657ZM301.397 299.419L301.917 299.723C302.057 299.8 302.286 299.8 302.425 299.723C302.565 299.647 302.565 299.508 302.425 299.431L301.905 299.126C301.765 299.05 301.537 299.05 301.397 299.126C301.257 299.203 301.257 299.33 301.397 299.419ZM302.705 300.168L303.225 300.473C303.365 300.549 303.593 300.549 303.733 300.473C303.873 300.397 303.873 300.257 303.733 300.181L303.213 299.876C303.073 299.8 302.844 299.8 302.705 299.876C302.565 299.965 302.565 300.092 302.705 300.168ZM304.025 300.93L304.546 301.235C304.685 301.311 304.914 301.311 305.054 301.235C305.193 301.159 305.193 301.019 305.054 300.943L304.533 300.638C304.393 300.562 304.165 300.562 304.025 300.638C303.885 300.714 303.885 300.854 304.025 300.93ZM305.333 301.692L305.853 301.997C305.993 302.073 306.222 302.073 306.361 301.997C306.501 301.921 306.501 301.781 306.361 301.705L305.841 301.4C305.701 301.324 305.473 301.324 305.333 301.4C305.193 301.476 305.193 301.603 305.333 301.692ZM306.641 302.441L307.161 302.746C307.301 302.823 307.529 302.823 307.669 302.746C307.809 302.67 307.809 302.53 307.669 302.454L307.149 302.149C307.009 302.073 306.78 302.073 306.641 302.149C306.501 302.226 306.501 302.365 306.641 302.441ZM307.948 303.204L308.469 303.508C308.609 303.585 308.837 303.585 308.977 303.508C309.117 303.432 309.117 303.292 308.977 303.216L308.456 302.911C308.317 302.835 308.088 302.835 307.948 302.911C307.809 302.988 307.809 303.115 307.948 303.204ZM309.269 303.953L309.789 304.258C309.929 304.334 310.158 304.334 310.297 304.258C310.437 304.182 310.437 304.042 310.297 303.966L309.777 303.661C309.637 303.585 309.409 303.585 309.269 303.661C309.129 303.75 309.129 303.877 309.269 303.953ZM310.602 304.728L311.123 305.033C311.262 305.109 311.491 305.109 311.63 305.033C311.77 304.956 311.77 304.817 311.63 304.74L311.11 304.436C310.97 304.359 310.742 304.359 310.602 304.436C310.462 304.512 310.462 304.652 310.602 304.728ZM293.081 296.015L293.538 296.281C293.703 296.37 293.957 296.37 294.109 296.281L294.553 296.027C294.718 295.938 294.706 295.786 294.553 295.697L294.096 295.43C293.931 295.342 293.677 295.342 293.525 295.43L293.081 295.684C292.928 295.773 292.928 295.926 293.081 296.015ZM295.43 297.031L295.874 296.777C296.039 296.688 296.026 296.535 295.874 296.447L295.417 296.18C295.252 296.091 294.998 296.091 294.845 296.18L294.401 296.434C294.236 296.523 294.249 296.675 294.401 296.764L294.858 297.031C295.011 297.132 295.264 297.132 295.43 297.031ZM295.709 297.526L296.166 297.793C296.331 297.882 296.585 297.882 296.737 297.793L297.182 297.539C297.347 297.45 297.334 297.297 297.182 297.209L296.725 296.942C296.56 296.853 296.306 296.853 296.153 296.942L295.709 297.196C295.544 297.285 295.544 297.437 295.709 297.526ZM297.017 298.288L297.474 298.555C297.639 298.644 297.893 298.644 298.045 298.555L298.489 298.301C298.654 298.212 298.642 298.06 298.489 297.971L298.032 297.704C297.867 297.615 297.613 297.615 297.461 297.704L297.017 297.958C296.852 298.047 296.852 298.199 297.017 298.288ZM299.81 298.707L299.353 298.441C299.188 298.352 298.934 298.352 298.781 298.441L298.337 298.695C298.172 298.784 298.185 298.936 298.337 299.025L298.794 299.292C298.959 299.38 299.213 299.38 299.365 299.292L299.81 299.038C299.962 298.949 299.962 298.809 299.81 298.707ZM301.118 299.469L300.661 299.203C300.495 299.114 300.242 299.114 300.089 299.203L299.645 299.457C299.48 299.546 299.492 299.698 299.645 299.787L300.102 300.054C300.267 300.143 300.521 300.143 300.673 300.054L301.118 299.8C301.283 299.711 301.283 299.558 301.118 299.469ZM302.425 300.231L301.968 299.965C301.803 299.876 301.549 299.876 301.397 299.965L300.953 300.219C300.787 300.308 300.8 300.46 300.953 300.549L301.41 300.816C301.575 300.905 301.829 300.905 301.981 300.816L302.425 300.562C302.59 300.473 302.59 300.32 302.425 300.231ZM303.746 300.981L303.289 300.714C303.124 300.625 302.87 300.625 302.717 300.714L302.273 300.968C302.108 301.057 302.121 301.209 302.273 301.298L302.73 301.565C302.895 301.654 303.149 301.654 303.301 301.565L303.746 301.311C303.898 301.222 303.898 301.082 303.746 300.981ZM305.054 301.743L304.596 301.476C304.431 301.387 304.178 301.387 304.025 301.476L303.581 301.73C303.416 301.819 303.428 301.972 303.581 302.06L304.038 302.327C304.203 302.416 304.457 302.416 304.609 302.327L305.054 302.073C305.206 301.984 305.206 301.832 305.054 301.743ZM306.361 302.492L305.904 302.226C305.739 302.137 305.485 302.137 305.333 302.226L304.889 302.48C304.723 302.568 304.736 302.721 304.889 302.81L305.346 303.077C305.511 303.165 305.765 303.165 305.917 303.077L306.361 302.823C306.526 302.734 306.526 302.594 306.361 302.492ZM306.196 303.585L306.653 303.851C306.818 303.94 307.072 303.94 307.225 303.851L307.669 303.597C307.834 303.508 307.821 303.356 307.669 303.267L307.212 303C307.047 302.911 306.793 302.911 306.641 303L306.196 303.254C306.031 303.343 306.031 303.496 306.196 303.585ZM308.99 304.016L308.532 303.75C308.367 303.661 308.113 303.661 307.961 303.75L307.517 304.004C307.352 304.093 307.364 304.245 307.517 304.334L307.974 304.601C308.139 304.69 308.393 304.69 308.545 304.601L308.99 304.347C309.142 304.258 309.142 304.105 308.99 304.016ZM310.907 305.121L309.866 304.524C309.701 304.436 309.447 304.436 309.294 304.524L308.85 304.779C308.685 304.867 308.698 305.02 308.85 305.109L309.891 305.706C310.056 305.795 310.31 305.795 310.462 305.706L310.907 305.452C311.059 305.363 311.059 305.21 310.907 305.121ZM291.874 296.713L292.916 297.31C293.081 297.399 293.335 297.399 293.487 297.31L293.931 297.056C294.096 296.967 294.084 296.815 293.931 296.726L292.89 296.129C292.725 296.04 292.471 296.04 292.319 296.129L291.874 296.383C291.709 296.472 291.709 296.624 291.874 296.713ZM293.766 297.806L294.223 298.072C294.388 298.161 294.642 298.161 294.795 298.072L295.239 297.818C295.404 297.729 295.391 297.577 295.239 297.488L294.782 297.221C294.617 297.132 294.363 297.132 294.211 297.221L293.766 297.475C293.601 297.564 293.601 297.717 293.766 297.806ZM295.531 298.834C295.696 298.923 295.95 298.923 296.102 298.834L296.547 298.58C296.712 298.491 296.699 298.339 296.547 298.25L296.09 297.983C295.925 297.894 295.671 297.894 295.518 297.983L295.074 298.237C294.909 298.326 294.922 298.479 295.074 298.568L295.531 298.834ZM296.839 299.584C297.004 299.673 297.258 299.673 297.41 299.584L297.855 299.33C298.02 299.241 298.007 299.088 297.855 298.999L297.397 298.733C297.232 298.644 296.978 298.644 296.826 298.733L296.382 298.987C296.217 299.076 296.229 299.228 296.382 299.317L296.839 299.584ZM298.147 299.482L297.702 299.736C297.537 299.825 297.55 299.977 297.702 300.066L298.159 300.333C298.324 300.422 298.578 300.422 298.731 300.333L299.175 300.079C299.34 299.99 299.327 299.838 299.175 299.749L298.718 299.482C298.566 299.393 298.299 299.393 298.147 299.482ZM299.48 300.231L298.972 300.524C298.832 300.613 298.832 300.74 298.972 300.828L299.48 301.121C299.619 301.209 299.861 301.209 300 301.121L300.508 300.828C300.648 300.74 300.648 300.613 300.508 300.524L300 300.231C299.861 300.143 299.632 300.143 299.48 300.231ZM300.787 300.981L300.28 301.273C300.14 301.362 300.14 301.489 300.28 301.578L300.787 301.87C300.927 301.959 301.168 301.959 301.308 301.87L301.816 301.578C301.956 301.489 301.956 301.362 301.816 301.273L301.308 300.981C301.168 300.905 300.94 300.905 300.787 300.981ZM302.108 301.743L301.6 302.035C301.46 302.124 301.46 302.251 301.6 302.34L302.108 302.632C302.248 302.721 302.489 302.721 302.629 302.632L303.136 302.34C303.276 302.251 303.276 302.124 303.136 302.035L302.629 301.743C302.476 301.654 302.248 301.654 302.108 301.743ZM303.416 302.505L302.908 302.797C302.768 302.886 302.768 303.013 302.908 303.102L303.416 303.394C303.555 303.483 303.797 303.483 303.936 303.394L304.444 303.102C304.584 303.013 304.584 302.886 304.444 302.797L303.936 302.505C303.797 302.416 303.555 302.416 303.416 302.505ZM304.723 303.254L304.216 303.547C304.076 303.635 304.076 303.762 304.216 303.851L304.723 304.143C304.863 304.232 305.104 304.232 305.244 304.143L305.752 303.851C305.892 303.762 305.892 303.635 305.752 303.547L305.244 303.254C305.104 303.178 304.876 303.178 304.723 303.254ZM306.564 304.906L307.072 304.613C307.212 304.524 307.212 304.397 307.072 304.309L306.564 304.016C306.425 303.928 306.184 303.928 306.044 304.016L305.536 304.309C305.396 304.397 305.396 304.524 305.536 304.613L306.044 304.906C306.184 304.982 306.425 304.982 306.564 304.906ZM307.872 305.655L308.38 305.363C308.52 305.274 308.52 305.147 308.38 305.058L307.872 304.766C307.733 304.677 307.491 304.677 307.352 304.766L306.844 305.058C306.704 305.147 306.704 305.274 306.844 305.363L307.352 305.655C307.491 305.744 307.733 305.744 307.872 305.655ZM309.713 305.833L309.205 305.541C309.066 305.452 308.824 305.452 308.685 305.541L308.177 305.833C308.037 305.922 308.037 306.049 308.177 306.138L308.685 306.43C308.824 306.519 309.066 306.519 309.205 306.43L309.713 306.138C309.866 306.061 309.866 305.922 309.713 305.833ZM290.63 297.399L292.268 298.352C292.408 298.441 292.649 298.441 292.789 298.352L293.296 298.06C293.436 297.971 293.436 297.844 293.296 297.755L291.659 296.802C291.519 296.713 291.278 296.713 291.138 296.802L290.63 297.094C290.478 297.183 290.478 297.323 290.63 297.399ZM293.068 298.809L293.576 299.101C293.715 299.19 293.957 299.19 294.096 299.101L294.604 298.809C294.744 298.72 294.744 298.593 294.604 298.504L294.096 298.212C293.957 298.123 293.715 298.123 293.576 298.212L293.068 298.504C292.928 298.593 292.928 298.733 293.068 298.809ZM294.388 299.571L294.896 299.863C295.036 299.952 295.277 299.952 295.417 299.863L295.925 299.571C296.064 299.482 296.064 299.355 295.925 299.266L295.417 298.974C295.277 298.885 295.036 298.885 294.896 298.974L294.388 299.266C294.236 299.355 294.236 299.482 294.388 299.571ZM295.696 300.333L296.204 300.625C296.344 300.714 296.585 300.714 296.725 300.625L297.232 300.333C297.372 300.244 297.372 300.117 297.232 300.028L296.725 299.736C296.585 299.647 296.344 299.647 296.204 299.736L295.696 300.028C295.544 300.104 295.556 300.244 295.696 300.333ZM298.032 301.375L298.54 301.082C298.68 300.994 298.68 300.867 298.54 300.778L298.032 300.486C297.893 300.397 297.651 300.397 297.512 300.486L297.004 300.778C296.864 300.867 296.864 300.994 297.004 301.082L297.512 301.375C297.664 301.463 297.893 301.463 298.032 301.375ZM299.353 302.137L299.861 301.845C300 301.756 300 301.629 299.861 301.54L299.353 301.248C299.213 301.159 298.972 301.159 298.832 301.248L298.324 301.54C298.185 301.629 298.185 301.756 298.324 301.845L298.832 302.137C298.972 302.226 299.2 302.226 299.353 302.137ZM300.661 302.899L301.168 302.607C301.308 302.518 301.308 302.391 301.168 302.302L300.661 302.01C300.521 301.921 300.28 301.921 300.14 302.01L299.632 302.302C299.492 302.391 299.492 302.518 299.632 302.607L300.14 302.899C300.28 302.975 300.521 302.975 300.661 302.899ZM301.968 303.648L302.476 303.356C302.616 303.267 302.616 303.14 302.476 303.051L301.968 302.759C301.829 302.67 301.587 302.67 301.448 302.759L300.94 303.051C300.8 303.14 300.8 303.267 300.94 303.356L301.448 303.648C301.587 303.737 301.829 303.737 301.968 303.648ZM303.276 304.41L303.784 304.118C303.924 304.029 303.924 303.902 303.784 303.813L303.276 303.521C303.136 303.432 302.895 303.432 302.755 303.521L302.248 303.813C302.108 303.902 302.108 304.029 302.248 304.118L302.755 304.41C302.908 304.486 303.136 304.486 303.276 304.41ZM304.596 305.16L305.104 304.867C305.244 304.779 305.244 304.651 305.104 304.563L304.596 304.27C304.457 304.182 304.216 304.182 304.076 304.27L303.568 304.563C303.428 304.651 303.428 304.779 303.568 304.867L304.076 305.16C304.216 305.248 304.444 305.248 304.596 305.16ZM304.876 305.63L305.384 305.922C305.523 306.011 305.765 306.011 305.904 305.922L306.412 305.63C306.552 305.541 306.552 305.414 306.412 305.325L305.904 305.033C305.765 304.944 305.523 304.944 305.384 305.033L304.876 305.325C304.723 305.414 304.723 305.541 304.876 305.63ZM308.507 306.544L307.212 305.795C307.072 305.706 306.831 305.706 306.691 305.795L306.184 306.087C306.044 306.176 306.044 306.303 306.184 306.392L307.479 307.141C307.618 307.23 307.86 307.23 307.999 307.141L308.507 306.849C308.647 306.76 308.647 306.62 308.507 306.544ZM289.424 298.136L291.76 299.482C291.925 299.571 292.192 299.571 292.344 299.482L292.789 299.228C292.954 299.139 292.954 298.987 292.789 298.885L290.452 297.539C290.287 297.45 290.021 297.45 289.868 297.539L289.424 297.793C289.259 297.894 289.259 298.047 289.424 298.136ZM292.624 299.99L293.068 300.244C293.233 300.333 293.5 300.333 293.652 300.244L294.096 299.99C294.261 299.901 294.261 299.749 294.096 299.647L293.652 299.393C293.487 299.304 293.22 299.304 293.068 299.393L292.624 299.647C292.458 299.736 292.458 299.889 292.624 299.99ZM293.931 300.74L294.376 300.994C294.541 301.082 294.807 301.082 294.96 300.994L295.404 300.74C295.569 300.651 295.569 300.498 295.404 300.397L294.96 300.143C294.795 300.054 294.528 300.054 294.376 300.143L293.931 300.397C293.766 300.498 293.766 300.651 293.931 300.74ZM295.239 301.502L295.683 301.756C295.848 301.845 296.115 301.845 296.267 301.756L296.712 301.502C296.877 301.413 296.877 301.26 296.712 301.159L296.267 300.905C296.102 300.816 295.836 300.816 295.683 300.905L295.239 301.159C295.074 301.26 295.074 301.413 295.239 301.502ZM296.56 302.264L297.004 302.518C297.169 302.607 297.436 302.607 297.588 302.518L298.032 302.264C298.197 302.175 298.197 302.022 298.032 301.921L297.588 301.667C297.423 301.578 297.156 301.578 297.004 301.667L296.56 301.921C296.394 302.01 296.394 302.162 296.56 302.264ZM297.867 303.013L298.312 303.267C298.477 303.356 298.743 303.356 298.896 303.267L299.34 303.013C299.505 302.924 299.505 302.772 299.34 302.67L298.896 302.416C298.731 302.327 298.464 302.327 298.312 302.416L297.867 302.67C297.702 302.772 297.702 302.924 297.867 303.013ZM299.175 303.775L299.619 304.029C299.784 304.118 300.051 304.118 300.203 304.029L300.648 303.775C300.813 303.686 300.813 303.534 300.648 303.432L300.203 303.178C300.038 303.089 299.772 303.089 299.619 303.178L299.175 303.432C299.01 303.521 299.01 303.674 299.175 303.775ZM300.483 304.524L300.927 304.779C301.092 304.867 301.359 304.867 301.511 304.779L301.956 304.524C302.121 304.436 302.121 304.283 301.956 304.182L301.511 303.928C301.346 303.839 301.08 303.839 300.927 303.928L300.483 304.182C300.318 304.283 300.318 304.436 300.483 304.524ZM301.803 305.287L302.248 305.541C302.413 305.629 302.679 305.629 302.832 305.541L303.276 305.287C303.441 305.198 303.441 305.045 303.276 304.944L302.832 304.69C302.667 304.601 302.4 304.601 302.248 304.69L301.803 304.944C301.638 305.045 301.638 305.198 301.803 305.287ZM303.111 306.049L303.555 306.303C303.72 306.392 303.987 306.392 304.139 306.303L304.584 306.049C304.749 305.96 304.749 305.807 304.584 305.706L304.139 305.452C303.974 305.363 303.708 305.363 303.555 305.452L303.111 305.706C302.946 305.795 302.946 305.947 303.111 306.049ZM304.419 306.798L304.863 307.052C305.028 307.141 305.295 307.141 305.447 307.052L305.892 306.798C306.057 306.709 306.057 306.557 305.892 306.455L305.447 306.201C305.282 306.112 305.015 306.112 304.863 306.201L304.419 306.455C304.254 306.557 304.254 306.709 304.419 306.798ZM307.225 307.243L306.78 306.989C306.615 306.9 306.349 306.9 306.196 306.989L305.752 307.243C305.587 307.331 305.587 307.484 305.752 307.585L306.196 307.84C306.361 307.928 306.628 307.928 306.78 307.84L307.225 307.585C307.39 307.484 307.39 307.331 307.225 307.243ZM290.249 298.834L289.221 298.237C289.056 298.148 288.789 298.148 288.637 298.237L288.192 298.491C288.027 298.58 288.027 298.733 288.192 298.834L289.221 299.431C289.386 299.52 289.653 299.52 289.805 299.431L290.249 299.177C290.414 299.088 290.414 298.936 290.249 298.834ZM291.57 299.596L291.125 299.342C290.96 299.253 290.694 299.253 290.541 299.342L290.097 299.596C289.932 299.685 289.932 299.838 290.097 299.939L290.541 300.193C290.706 300.282 290.973 300.282 291.125 300.193L291.57 299.939C291.735 299.838 291.735 299.685 291.57 299.596ZM292.877 300.358L292.433 300.104C292.268 300.016 292.001 300.016 291.849 300.104L291.405 300.358C291.24 300.447 291.24 300.6 291.405 300.701L291.849 300.955C292.014 301.044 292.281 301.044 292.433 300.955L292.877 300.701C293.043 300.6 293.043 300.447 292.877 300.358ZM302.057 305.655L293.754 300.854C293.588 300.765 293.322 300.765 293.169 300.854L292.725 301.108C292.56 301.197 292.56 301.349 292.725 301.451L301.029 306.252C301.194 306.341 301.46 306.341 301.613 306.252L302.057 305.998C302.222 305.896 302.21 305.744 302.057 305.655ZM303.365 306.404L302.921 306.15C302.755 306.061 302.489 306.061 302.336 306.15L301.892 306.404C301.727 306.493 301.727 306.646 301.892 306.747L302.336 307.001C302.502 307.09 302.768 307.09 302.921 307.001L303.365 306.747C303.53 306.658 303.53 306.506 303.365 306.404ZM304.673 307.166L304.228 306.912C304.063 306.823 303.797 306.823 303.644 306.912L303.2 307.166C303.035 307.255 303.035 307.408 303.2 307.509L303.644 307.763C303.809 307.852 304.076 307.852 304.228 307.763L304.673 307.509C304.838 307.408 304.838 307.255 304.673 307.166ZM306.006 307.941L305.561 307.687C305.396 307.598 305.13 307.598 304.977 307.687L304.533 307.941C304.368 308.03 304.368 308.182 304.533 308.284L304.977 308.538C305.142 308.627 305.409 308.627 305.561 308.538L306.006 308.284C306.171 308.182 306.171 308.03 306.006 307.941Z",
    fill: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.67 311.917L282.669 299.889C281.857 299.419 281.082 298.149 280.943 297.032L278.822 280.164C278.683 279.059 279.229 278.526 280.041 278.996L301.042 291.024C301.854 291.494 302.629 292.764 302.768 293.882L304.889 310.749C305.028 311.854 304.482 312.387 303.67 311.917Z",
    fill: "#858FD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.397 290.794L280.397 278.766C280.079 278.589 279.8 278.55 279.584 278.652C279.559 278.665 279.203 278.893 279.178 278.919C279.394 278.792 279.686 278.805 280.041 279.008L301.042 291.036C301.854 291.506 302.629 292.776 302.768 293.894L304.889 310.761C304.978 311.459 304.8 311.917 304.444 312.056C304.47 312.056 304.508 312.044 304.559 312.006C304.571 311.993 304.952 311.726 304.965 311.713C305.193 311.51 305.308 311.091 305.232 310.519L303.111 293.652C302.984 292.535 302.21 291.252 301.397 290.794Z",
    fill: "#2D3259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.234 298.923C314.234 298.923 313.51 299.393 312.456 299.558C311.389 299.724 310.844 299.33 309.371 299.698C307.86 300.079 306.108 302.518 307.377 303.534C308.266 304.232 309.815 303.381 311.059 303.204C311.605 303.127 312.685 303.267 313.23 303.242C315.046 303.178 316.659 300.943 316.659 300.943L314.234 298.923Z",
    fill: "#FFD4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.392 298.276C318.334 298.797 324.352 296.638 324.352 296.638C324.352 296.638 324.162 287.404 324.098 281.003C324.048 275.274 324.543 270.994 324.327 268.238L319.439 271.896C319.439 277.637 319.883 285.816 319.883 289.576C319.883 291.837 314.779 297.717 312.392 298.276Z",
    fill: "#CED3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.61 266.193C323.438 265.354 326.194 268.2 328.035 274.194C329.863 280.202 334.789 287.48 333.862 289.982C332.935 292.484 315.706 302.302 315.706 302.302C315.706 302.302 315.516 301.375 314.589 300.257C313.662 299.14 313.23 299.14 313.23 299.14L325.8 287.747C325.8 287.747 320.95 281.307 318.829 275.503C316.938 270.346 318.525 267.603 321.61 266.193Z",
    fill: "url(#paint174_linear_195_3461)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_195_3461",
    x1: 186.195,
    y1: 278.56,
    x2: 341.387,
    y2: 278.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5905,
    stopColor: "#EBEDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7024,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9503,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_195_3461",
    x1: 276.636,
    y1: 228.17,
    x2: 227.987,
    y2: 302.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8551,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_195_3461",
    x1: 282.171,
    y1: 236.287,
    x2: 264.586,
    y2: 270.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1818,
    stopColor: "#4D5A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2483,
    stopColor: "#6A75A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3644,
    stopColor: "#979FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4813,
    stopColor: "#BDC2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5972,
    stopColor: "#DADCE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#EEF0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#FBFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9343,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_195_3461",
    x1: -2.34634,
    y1: 100.171,
    x2: 491.521,
    y2: 208.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8551,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_195_3461",
    x1: 173.545,
    y1: 17.3374,
    x2: 375.702,
    y2: 321.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_195_3461",
    x1: 225.346,
    y1: -28.245,
    x2: 394.364,
    y2: 310.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3BAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BAE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_195_3461",
    x1: 225.276,
    y1: -28.1861,
    x2: 394.284,
    y2: 310.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4BBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#B9BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BCC2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#B3B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BBE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_195_3461",
    x1: 225.206,
    y1: -28.1267,
    x2: 394.204,
    y2: 310.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BDC3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#B7BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5BCE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_195_3461",
    x1: 225.135,
    y1: -28.0683,
    x2: 394.124,
    y2: 310.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BCC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BFC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7BDE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_195_3461",
    x1: 225.066,
    y1: -28.0093,
    x2: 394.044,
    y2: 310.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C1C6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#BEC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8BFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_195_3461",
    x1: 224.995,
    y1: -27.9499,
    x2: 393.965,
    y2: 310.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BFC4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C2C8ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#C2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C0EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_195_3461",
    x1: 224.925,
    y1: -27.8915,
    x2: 393.885,
    y2: 310.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C0C6ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C4C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#BEC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#C6CBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#B2B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#BAC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_195_3461",
    x1: 224.855,
    y1: -27.8321,
    x2: 393.805,
    y2: 310.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C2C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C6CBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C1C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#CACEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#B6BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_195_3461",
    x1: 224.785,
    y1: -27.7733,
    x2: 393.725,
    y2: 310.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C3C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#CDD2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6644,
    stopColor: "#B9C0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9836,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_195_3461",
    x1: 224.715,
    y1: -27.7144,
    x2: 393.646,
    y2: 310.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C5CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C6CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#D0D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#D1D5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#BDC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9797,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEC4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_195_3461",
    x1: 224.645,
    y1: -27.656,
    x2: 393.566,
    y2: 310.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C7CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C8CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5228,
    stopColor: "#D3D7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#D5D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6403,
    stopColor: "#C1C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9763,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_195_3461",
    x1: 224.575,
    y1: -27.5961,
    x2: 393.486,
    y2: 310.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CBD1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#D5D9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#D9DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6316,
    stopColor: "#C5CAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9704,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C7ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_195_3461",
    x1: 224.505,
    y1: -27.5378,
    x2: 393.406,
    y2: 310.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CACFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#CED3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#CDD3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#D8DCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#DDE0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#C9CEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9679,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_195_3461",
    x1: 224.435,
    y1: -27.4789,
    x2: 393.327,
    y2: 310.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D0D4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D0D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D0D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#DADEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#E1E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6182,
    stopColor: "#CDD1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9656,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C9EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_195_3461",
    x1: 224.365,
    y1: -27.4202,
    x2: 393.247,
    y2: 310.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D1D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D2D7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#DDE1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#E4E7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6142,
    stopColor: "#D0D5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_195_3461",
    x1: 224.295,
    y1: -27.3614,
    x2: 393.167,
    y2: 310.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CFD3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D5DAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D6DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4993,
    stopColor: "#E0E3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#E8EAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    stopColor: "#D4D8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9597,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_195_3461",
    x1: 224.225,
    y1: -27.3027,
    x2: 393.087,
    y2: 310.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D0D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D5D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D7DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D8DDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#E2E6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6051,
    stopColor: "#D8DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_195_3461",
    x1: 224.155,
    y1: -27.2434,
    x2: 393.007,
    y2: 310.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D2D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D6DBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4921,
    stopColor: "#E5E8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#F0F1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6013,
    stopColor: "#DCDFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9566,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8CDF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_195_3461",
    x1: 224.084,
    y1: -27.1853,
    x2: 392.928,
    y2: 310.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D8DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#DCE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4882,
    stopColor: "#E7EAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#F4F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#E0E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9551,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9CFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_195_3461",
    x1: 224.014,
    y1: -27.1263,
    x2: 392.848,
    y2: 311.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D5D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#DFE3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#E0E4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4882,
    stopColor: "#EAEDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#F7F8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5957,
    stopColor: "#E3E6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7185,
    stopColor: "#B1B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9526,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_195_3461",
    x1: 223.944,
    y1: -27.0678,
    x2: 392.768,
    y2: 311.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D6DBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#E1E6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#E2E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#ECEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#FBFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#E7EAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7101,
    stopColor: "#B5BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9514,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_195_3461",
    x1: 223.874,
    y1: -27.0094,
    x2: 392.688,
    y2: 311.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5905,
    stopColor: "#EBEDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7024,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9503,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_195_3461",
    x1: 86.5914,
    y1: 69.8223,
    x2: 128.959,
    y2: 214.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1263,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2437,
    stopColor: "#D9EE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4134,
    stopColor: "#A7F361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    stopColor: "#84EA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6088,
    stopColor: "#4CDB98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7424,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8771,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.221 126.128) scale(47.4259 47.4429)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_195_3461",
    x1: 51.0281,
    y1: 110.338,
    x2: 110.313,
    y2: 222.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1263,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2437,
    stopColor: "#D9EE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4134,
    stopColor: "#A7F361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    stopColor: "#84EA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6088,
    stopColor: "#4CDB98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7424,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8771,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.1214 159.428) scale(38.2137 38.2274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_195_3461",
    x1: 15.1993,
    y1: 117.105,
    x2: 82.9519,
    y2: 237.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1263,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2437,
    stopColor: "#D9EE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4134,
    stopColor: "#A7F361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    stopColor: "#84EA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6088,
    stopColor: "#4CDB98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7424,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8771,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5091 191.99) scale(29.452 29.4626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_195_3461",
    x1: 46.5174,
    y1: 239.239,
    x2: 33.6325,
    y2: 261.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_195_3461",
    x1: -10.7338,
    y1: 125.671,
    x2: 53.2096,
    y2: 253.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1263,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2437,
    stopColor: "#D9EE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4134,
    stopColor: "#A7F361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    stopColor: "#84EA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6088,
    stopColor: "#4CDB98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7424,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8771,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.1771 226.14) scale(21.4934 21.5012)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.2884 324.44) scale(63.9645 42.027)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4192,
    stopColor: "#F5F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5543,
    stopColor: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6482,
    stopColor: "#E9EBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#DADDF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7727,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8414,
    stopColor: "#D8DCF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9589,
    stopColor: "#F4F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_195_3461",
    x1: 161.048,
    y1: 293.348,
    x2: 28.4529,
    y2: 293.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2475,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9464,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.8377 297.005) scale(65.8741 65.8978)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#B0FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.8377 297.005) scale(65.8741 65.8978)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6034,
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7613,
    stopColor: "#E0F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9533,
    stopColor: "#BEE1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4DDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_195_3461",
    x1: 65.6991,
    y1: 192.932,
    x2: 108.685,
    y2: 352.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9546,
    stopColor: "#F5F4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_195_3461",
    x1: 63.7049,
    y1: 329.151,
    x2: 65.2931,
    y2: 286.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_195_3461",
    x1: 142.138,
    y1: 308.103,
    x2: 111.656,
    y2: 335.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#836DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_195_3461",
    x1: 127.715,
    y1: 289.665,
    x2: 140.736,
    y2: 307.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2335,
    stopColor: "#0FC8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6167,
    stopColor: "#38CAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66CCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_195_3461",
    x1: 131.63,
    y1: 288.945,
    x2: 69.0985,
    y2: 284.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1902,
    stopColor: "#3AEB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4903,
    stopColor: "#63EF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9023,
    stopColor: "#A4F562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4F759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_195_3461",
    x1: 96.4344,
    y1: 295.054,
    x2: 120.878,
    y2: 304.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#836DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_195_3461",
    x1: 117.269,
    y1: 317.959,
    x2: 81.7188,
    y2: 317.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_195_3461",
    x1: 76.4851,
    y1: 296.667,
    x2: 80.6144,
    y2: 316.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1902,
    stopColor: "#3AEB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4903,
    stopColor: "#63EF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9023,
    stopColor: "#A4F562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4F759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_195_3461",
    x1: 83.4898,
    y1: 300.714,
    x2: 90.0265,
    y2: 289.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2335,
    stopColor: "#0FC8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6167,
    stopColor: "#38CAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66CCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_195_3461",
    x1: 27.5095,
    y1: 333.145,
    x2: 165.54,
    y2: 333.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1061,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1717,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#DFE3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9464,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.443 284.425) scale(46.4223 46.439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.1336 338.955) scale(51 51.0183)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_195_3461",
    x1: 147.962,
    y1: 342.079,
    x2: 141.305,
    y2: 353.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1061,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1717,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#DFE3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9464,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_195_3461",
    x1: 160.948,
    y1: 352.239,
    x2: 139.68,
    y2: 347.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5529,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.415 348.164) rotate(180) scale(4.05722 4.05868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0152,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3727,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6167,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8672,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_195_3461",
    x1: 186.376,
    y1: 359.998,
    x2: 174.617,
    y2: 379.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1433,
    stopColor: "#564BD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#6152E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#4528C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4832,
    stopColor: "#4221A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5739,
    stopColor: "#401B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6263,
    stopColor: "#3F1982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8687,
    stopColor: "#5E239E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491C8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_195_3461",
    x1: 208.253,
    y1: 384.55,
    x2: 223.157,
    y2: 393.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0808,
    stopColor: "#3F1982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E239E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.358 384.292) rotate(180) scale(7.30274 7.30537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0152,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3727,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6167,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8672,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.0193 296.597) rotate(167.474) scale(36.0929 22.017)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.9552 305.466) scale(64.9532 64.9766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(343.869 356.461) scale(30.6579 14.2917)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(376.631 337.794) scale(30.6579 14.2917)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(313 331.565) scale(30.6579 14.2917)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_195_3461",
    x1: 349.76,
    y1: 339.575,
    x2: 395.712,
    y2: 339.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_195_3461",
    x1: 349.76,
    y1: 342.236,
    x2: 395.711,
    y2: 342.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_195_3461",
    x1: 396.22,
    y1: 335.197,
    x2: 396.228,
    y2: 335.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_195_3461",
    x1: 416.019,
    y1: 286.054,
    x2: 370.337,
    y2: 332.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(362.849 339.482) scale(29.3433 29.3539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_195_3461",
    x1: 391.643,
    y1: 310.594,
    x2: 357.494,
    y2: 344.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(381.099 318.341) scale(12.9078 12.9124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_195_3461",
    x1: 397.926,
    y1: 303.151,
    x2: 365.7,
    y2: 335.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(383.542 321.087) rotate(-71.221) scale(4.9713 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_195_3461",
    x1: 349.76,
    y1: 331.755,
    x2: 395.712,
    y2: 331.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_195_3461",
    x1: 349.76,
    y1: 334.415,
    x2: 395.711,
    y2: 334.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_195_3461",
    x1: 396.22,
    y1: 327.376,
    x2: 396.228,
    y2: 327.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_195_3461",
    x1: 416.019,
    y1: 278.234,
    x2: 370.337,
    y2: 324.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(362.849 331.662) scale(29.3433 29.3538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_195_3461",
    x1: 391.643,
    y1: 302.773,
    x2: 357.494,
    y2: 337.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(381.099 310.521) scale(12.9078 12.9125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_195_3461",
    x1: 397.926,
    y1: 295.331,
    x2: 365.7,
    y2: 327.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(383.542 313.267) rotate(-71.221) scale(4.97132 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_195_3461",
    x1: 349.76,
    y1: 323.934,
    x2: 395.712,
    y2: 323.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_195_3461",
    x1: 349.76,
    y1: 326.595,
    x2: 395.711,
    y2: 326.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_195_3461",
    x1: 396.22,
    y1: 319.556,
    x2: 396.228,
    y2: 319.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_195_3461",
    x1: 416.019,
    y1: 270.414,
    x2: 370.337,
    y2: 316.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(362.849 323.841) scale(29.3433 29.3538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_195_3461",
    x1: 391.643,
    y1: 294.953,
    x2: 357.494,
    y2: 329.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(381.099 302.7) scale(12.9078 12.9124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_195_3461",
    x1: 397.926,
    y1: 287.51,
    x2: 365.7,
    y2: 319.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(383.542 305.446) rotate(-71.221) scale(4.9713 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_195_3461",
    x1: 349.76,
    y1: 316.084,
    x2: 395.712,
    y2: 316.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_195_3461",
    x1: 349.76,
    y1: 318.744,
    x2: 395.711,
    y2: 318.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_195_3461",
    x1: 396.22,
    y1: 311.705,
    x2: 396.228,
    y2: 311.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_195_3461",
    x1: 416.019,
    y1: 262.562,
    x2: 370.337,
    y2: 308.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(362.849 315.99) scale(29.3433 29.3538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_195_3461",
    x1: 391.643,
    y1: 287.102,
    x2: 357.494,
    y2: 321.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(381.099 294.85) scale(12.9078 12.9125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_195_3461",
    x1: 397.926,
    y1: 279.66,
    x2: 365.7,
    y2: 312.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(383.542 297.595) rotate(-71.221) scale(4.9713 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_195_3461",
    x1: 349.76,
    y1: 308.581,
    x2: 395.712,
    y2: 308.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_195_3461",
    x1: 349.76,
    y1: 311.242,
    x2: 395.711,
    y2: 311.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_195_3461",
    x1: 396.22,
    y1: 304.203,
    x2: 396.228,
    y2: 304.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_195_3461",
    x1: 416.019,
    y1: 255.061,
    x2: 370.337,
    y2: 301.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(362.849 308.489) scale(29.3433 29.3538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_195_3461",
    x1: 391.643,
    y1: 279.6,
    x2: 357.494,
    y2: 313.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(381.099 287.348) scale(12.9078 12.9125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_195_3461",
    x1: 397.926,
    y1: 272.158,
    x2: 365.7,
    y2: 304.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(383.542 290.093) rotate(-71.221) scale(4.9713 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_195_3461",
    x1: 349.76,
    y1: 301.149,
    x2: 395.712,
    y2: 301.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_195_3461",
    x1: 349.76,
    y1: 303.81,
    x2: 395.711,
    y2: 303.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_195_3461",
    x1: 396.22,
    y1: 296.771,
    x2: 396.228,
    y2: 296.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_195_3461",
    x1: 416.019,
    y1: 247.628,
    x2: 370.337,
    y2: 293.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(362.849 301.057) scale(29.3433 29.3538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_195_3461",
    x1: 391.643,
    y1: 272.168,
    x2: 357.494,
    y2: 306.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(381.099 279.915) scale(12.9077 12.9123)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_195_3461",
    x1: 397.926,
    y1: 264.725,
    x2: 365.7,
    y2: 297.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(383.542 282.661) rotate(-71.221) scale(4.97132 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_195_3461",
    x1: 349.76,
    y1: 293.612,
    x2: 395.712,
    y2: 293.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_195_3461",
    x1: 349.76,
    y1: 296.274,
    x2: 395.711,
    y2: 296.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_195_3461",
    x1: 396.22,
    y1: 289.235,
    x2: 396.228,
    y2: 289.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_195_3461",
    x1: 416.019,
    y1: 240.092,
    x2: 370.337,
    y2: 286.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(362.849 293.52) scale(29.3433 29.3538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_195_3461",
    x1: 391.643,
    y1: 264.632,
    x2: 357.494,
    y2: 298.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(381.099 272.379) scale(12.9078 12.9125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_195_3461",
    x1: 397.926,
    y1: 257.189,
    x2: 365.7,
    y2: 289.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(383.542 275.124) rotate(-71.221) scale(4.9713 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_195_3461",
    x1: 286.128,
    y1: 333.345,
    x2: 332.08,
    y2: 333.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_195_3461",
    x1: 286.128,
    y1: 336.005,
    x2: 332.08,
    y2: 336.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_195_3461",
    x1: 332.589,
    y1: 328.967,
    x2: 332.597,
    y2: 328.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_195_3461",
    x1: 352.387,
    y1: 279.823,
    x2: 306.706,
    y2: 325.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(299.217 333.252) scale(29.3434 29.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_195_3461",
    x1: 328.011,
    y1: 304.364,
    x2: 293.863,
    y2: 338.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(317.468 312.111) scale(12.9078 12.9125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_195_3461",
    x1: 334.294,
    y1: 296.921,
    x2: 302.068,
    y2: 329.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(319.911 314.857) rotate(-71.221) scale(4.97134 10.0321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_195_3461",
    x1: 286.128,
    y1: 325.525,
    x2: 332.08,
    y2: 325.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_195_3461",
    x1: 286.128,
    y1: 328.185,
    x2: 332.08,
    y2: 328.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_195_3461",
    x1: 332.589,
    y1: 321.146,
    x2: 332.597,
    y2: 321.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_195_3461",
    x1: 352.387,
    y1: 272.004,
    x2: 306.706,
    y2: 317.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(299.217 325.432) scale(29.3434 29.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_195_3461",
    x1: 328.011,
    y1: 296.544,
    x2: 293.863,
    y2: 330.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(317.468 304.291) scale(12.9078 12.9124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_195_3461",
    x1: 334.294,
    y1: 289.101,
    x2: 302.068,
    y2: 321.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(319.911 307.037) rotate(-71.221) scale(4.97134 10.0321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_195_3461",
    x1: 286.128,
    y1: 317.704,
    x2: 332.08,
    y2: 317.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_195_3461",
    x1: 286.128,
    y1: 320.366,
    x2: 332.08,
    y2: 320.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_195_3461",
    x1: 332.589,
    y1: 313.326,
    x2: 332.597,
    y2: 313.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_195_3461",
    x1: 352.387,
    y1: 264.183,
    x2: 306.706,
    y2: 310.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(299.217 317.612) scale(29.3434 29.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_195_3461",
    x1: 328.011,
    y1: 288.724,
    x2: 293.863,
    y2: 323.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(317.468 296.471) scale(12.9078 12.9125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_195_3461",
    x1: 334.294,
    y1: 281.281,
    x2: 302.068,
    y2: 313.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(319.911 299.216) rotate(-71.221) scale(4.97134 10.0321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_195_3461",
    x1: 316.998,
    y1: 358.241,
    x2: 362.95,
    y2: 358.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_195_3461",
    x1: 316.775,
    y1: 353.863,
    x2: 316.783,
    y2: 353.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_195_3461",
    x1: 316.998,
    y1: 360.902,
    x2: 362.95,
    y2: 360.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_195_3461",
    x1: 363.459,
    y1: 353.863,
    x2: 363.467,
    y2: 353.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6391,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8586,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9697,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_195_3461",
    x1: 383.257,
    y1: 304.72,
    x2: 337.575,
    y2: 350.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(330.087 358.148) scale(29.3434 29.3539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_195_3461",
    x1: 358.881,
    y1: 329.26,
    x2: 324.733,
    y2: 363.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#FFD680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(348.338 337.007) scale(12.9078 12.9124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_195_3461",
    x1: 365.164,
    y1: 321.817,
    x2: 332.938,
    y2: 354.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#FFA16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7739,
    stopColor: "#FFAC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FFBE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFC87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(350.781 339.753) rotate(-71.221) scale(4.97134 10.0321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(363.699 299.722) rotate(-71.221) scale(4.9713 10.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_195_3461",
    x1: 361.584,
    y1: 254.66,
    x2: 196.728,
    y2: 90.8442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1061,
    stopColor: "#84EFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1358,
    stopColor: "#80F0AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4933,
    stopColor: "#51F8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7676,
    stopColor: "#34FDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9242,
    stopColor: "#29FFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_195_3461",
    x1: 420.194,
    y1: 151.29,
    x2: 124.433,
    y2: 254.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1039,
    stopColor: "#90ED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    stopColor: "#35D5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4444,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5976,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7374,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7801,
    stopColor: "#5B76F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8495,
    stopColor: "#7374F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9363,
    stopColor: "#9A70F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(418.287 128.969) scale(54.2456 54.2651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(238.884 209.652) scale(95.6961 95.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_195_3461",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(307.383 305.527) scale(22.7303 10.5961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_195_3461",
    x1: 307.148,
    y1: 257.812,
    x2: 289.593,
    y2: 296.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#66CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#62BCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7134,
    stopColor: "#5993FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_195_3461",
    x1: 281.305,
    y1: 339.243,
    x2: 300.169,
    y2: 289.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_195_3461",
    x1: 297.253,
    y1: 346.107,
    x2: 316.7,
    y2: 294.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_195_3461",
    x1: 319.724,
    y1: 263.882,
    x2: 304.303,
    y2: 303.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#66CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#62BCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7134,
    stopColor: "#5993FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_195_3461",
    x1: 312.066,
    y1: 261.416,
    x2: 308.783,
    y2: 248.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7071,
    stopColor: "#836DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_195_3461",
    x1: 330.629,
    y1: 268.154,
    x2: 315.209,
    y2: 307.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#66CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#62BCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7134,
    stopColor: "#5993FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_3461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 435,
    height: 400,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_195_3461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 435.013,
    height: 400,
    fill: "white",
    transform: "translate(0.143311)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleImg1);
export default __webpack_public_path__ + "static/media/circleImg1.efe612e59e6b337ed5f50a8d97a5a53a.svg";
export { ForwardRef as ReactComponent };